var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 361.872,
    height: 213.059,
    viewBox: "0 0 361.872 213.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4763",
    "data-name": "Group 4763",
    transform: "translate(-89 -51.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M2508.54,1716.4a3.3,3.3,0,0,0-3.408-3.245l-71.539,2.286a3.3,3.3,0,0,0-3.2,3.4l3.53,118.479a3.3,3.3,0,0,0,3.334,3.2l70.1-.681a3.3,3.3,0,0,0,3.271-3.361Z",
    transform: "translate(-2299.632 -1591.683)",
    fill: "#75d5ef",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M2045.4,1374.234a3.048,3.048,0,0,0-3.311-2.967l-84.727,7.338a3.091,3.091,0,0,0-2.833,3.037v170.321a3.027,3.027,0,0,0,3.145,2.92H2046.4a2.943,2.943,0,0,0,3.047-3.021Z",
    transform: "translate(-1854.829 -1315.042)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4760",
    "data-name": "Group 4760",
    transform: "translate(8711.785 -949.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Review_Stock_2",
    "data-name": "Review Stock 2",
    transform: "translate(-8533.383 950.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723",
    transform: "translate(30.597 41.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4238",
    "data-name": "Group 4238",
    transform: "translate(143.617 8.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4218",
    "data-name": "Group 4218",
    transform: "translate(52.639 27.533) rotate(179.698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1749",
    "data-name": "Rectangle 1749",
    width: 4.032,
    height: 20.055,
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4219",
    "data-name": "Group 4219",
    transform: "translate(24.082 18.601) rotate(179.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1750",
    "data-name": "Rectangle 1750",
    width: 10.438,
    height: 11.071,
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4220",
    "data-name": "Group 4220",
    transform: "matrix(-1, 0.005, -0.005, -1, 34.469, 18.545)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1751",
    "data-name": "Rectangle 1751",
    width: 10.437,
    height: 11.072,
    transform: "translate(0 0)",
    fill: "#75d5ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4221",
    "data-name": "Group 4221",
    transform: "translate(34.529 10.129) rotate(89.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5140",
    "data-name": "Path 5140",
    d: "M.2,20.932Q.44,10.53.417.108A.111.111,0,0,0,.2.106q-.216,10.4-.19,20.824a.1.1,0,0,0,.19,0",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4222",
    "data-name": "Group 4222",
    transform: "translate(26.089 27.439) rotate(179.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1752",
    "data-name": "Rectangle 1752",
    width: 18.963,
    height: 9.022,
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4223",
    "data-name": "Group 4223",
    transform: "translate(44.961 27.338) rotate(179.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1753",
    "data-name": "Rectangle 1753",
    width: 18.963,
    height: 9.022,
    transform: "translate(0 0)",
    fill: "#75d5ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4224",
    "data-name": "Group 4224",
    transform: "translate(45.029 20.368) rotate(89.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5141",
    "data-name": "Path 5141",
    d: "M.25,37.942C.528,25.347.537,12.705.471.107a.111.111,0,0,0-.221,0C.047,12.7-.082,25.344.06,37.941a.1.1,0,0,0,.19,0",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4225",
    "data-name": "Group 4225",
    transform: "translate(73.466 30.773) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1754",
    "data-name": "Rectangle 1754",
    width: 73.466,
    height: 3.232,
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4226",
    "data-name": "Group 4226",
    transform: "translate(15.011 40.124) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1755",
    "data-name": "Rectangle 1755",
    width: 2.982,
    height: 11.029,
    transform: "translate(0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4227",
    "data-name": "Group 4227",
    transform: "translate(59.531 40.124) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1756",
    "data-name": "Rectangle 1756",
    width: 2.982,
    height: 11.029,
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4228",
    "data-name": "Group 4228",
    transform: "translate(56.612 27.582) rotate(179.698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1757",
    "data-name": "Rectangle 1757",
    width: 4.033,
    height: 27.582,
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4229",
    "data-name": "Group 4229",
    transform: "translate(62.881 27.486) rotate(179.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1758",
    "data-name": "Rectangle 1758",
    width: 6.263,
    height: 22.352,
    transform: "translate(0 0)",
    fill: "#75d5ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4230",
    "data-name": "Group 4230",
    transform: "translate(56.457 9.549) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M.109,6.263A22.611,22.611,0,0,1,0,3.132,22.626,22.626,0,0,1,.109,0,22.626,22.626,0,0,1,.217,3.132,22.611,22.611,0,0,1,.109,6.263",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4231",
    "data-name": "Group 4231",
    transform: "translate(56.457 8.61) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5143",
    "data-name": "Path 5143",
    d: "M.108,6.263A22.759,22.759,0,0,1,0,3.132,22.785,22.785,0,0,1,.108,0,22.637,22.637,0,0,1,.217,3.132,22.611,22.611,0,0,1,.108,6.263",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4232",
    "data-name": "Group 4232",
    transform: "translate(56.457 24.232) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M.109,6.263A22.611,22.611,0,0,1,0,3.132,22.637,22.637,0,0,1,.109,0,22.785,22.785,0,0,1,.217,3.132,22.759,22.759,0,0,1,.109,6.263",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4233",
    "data-name": "Group 4233",
    transform: "translate(56.457 23.292) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M.108,6.263A22.663,22.663,0,0,1,0,3.132,22.678,22.678,0,0,1,.108,0,22.678,22.678,0,0,1,.216,3.132,22.663,22.663,0,0,1,.108,6.263",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4234",
    "data-name": "Group 4234",
    transform: "translate(59.581 11.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M-.106,10.073c-.06,0-.109-2.255-.109-5.036S-.166,0-.106,0,0,2.255,0,5.037s-.049,5.036-.109,5.036",
    transform: "translate(0.215)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4235",
    "data-name": "Group 4235",
    transform: "translate(69.605 27.494) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1759",
    "data-name": "Rectangle 1759",
    width: 6.816,
    height: 16.872,
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4236",
    "data-name": "Group 4236",
    transform: "translate(53.232 5.867) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    d: "M1.158,2.317A1.158,1.158,0,1,1,2.317,1.158,1.158,1.158,0,0,1,1.158,2.317",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4237",
    "data-name": "Group 4237",
    transform: "translate(54.748 24.303) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1760",
    "data-name": "Rectangle 1760",
    width: 0.716,
    height: 16.408,
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(20 55.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4239",
    "data-name": "Group 4239",
    transform: "translate(0 161.754) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    d: "M.131,221.872C.059,221.872,0,172.2,0,110.941,0,49.662.059,0,.131,0S.263,49.662.263,110.941C.263,172.2.2,221.872.131,221.872",
    transform: "translate(0)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M.131,221.872C.059,221.872,0,172.2,0,110.941,0,49.662.059,0,.131,0S.263,49.662.263,110.941C.263,172.2.2,221.872.131,221.872",
    transform: "translate(0 -140)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4240",
    "data-name": "Group 4240",
    transform: "translate(174.536 6.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5149",
    "data-name": "Path 5149",
    d: "M0,20.269a5.572,5.572,0,0,0,4.826-.96,5.572,5.572,0,0,0,2.109-4.446c-.036-1.588-.753-3.206-.26-4.716.339-1.037,1.208-1.845,1.5-2.9C8.609,5.682,7.661,4.1,6.755,2.744A10.566,10.566,0,0,0,4.771.336,3.567,3.567,0,0,0,1.865-.523",
    transform: "translate(0 0.58)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4241",
    "data-name": "Group 4241",
    transform: "translate(156.504 6.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    d: "M-3.314-45.7a4.584,4.584,0,0,1-1.5,3.169A6.26,6.26,0,0,0-6.672-39.5c-.305,2.108,1.759,4.066,1.333,6.152-.228,1.119-1.144,2.017-1.308,3.148A3.912,3.912,0,0,0-5.493-27.21c.726.832,1.611,1.525,2.253,2.424,0,0,1.337,2.194,5.453.789",
    transform: "translate(6.703 45.699)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4242",
    "data-name": "Group 4242",
    transform: "translate(159.855 1.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    d: "M-18.051-7.83a2.742,2.742,0,0,0-1.987-2.325,15.113,15.113,0,0,1-3.038-1.155,14.519,14.519,0,0,1-2.012-2.062,6.832,6.832,0,0,0-6.528-1.757A6.834,6.834,0,0,0-36.347-10.3a4.393,4.393,0,0,0,1.1,4.408c1.416,1.194,3.516.929,5.331.557s3.869-.738,5.384.328a7.768,7.768,0,0,1,2,2.656A4.739,4.739,0,0,0-20.222-.033c1.057.364,2.491-.264,2.532-1.381",
    transform: "translate(36.513 15.354)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4243",
    "data-name": "Group 4243",
    transform: "translate(158.807 6.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M-14.885-58.107a1.819,1.819,0,0,1,1.624,1.849L-14.347-31.69c-.045,2.9-4.287,4.532-7.393,4.459-3.137-.073-3.238-1.611-3.277-4.372-.066-4.612-.06-6.343-.062-6.317,0,0-3.963-.667-4.773-5.841A55.311,55.311,0,0,1-29.891-54c.2-3.1,2.267-6.9,5.358-6.571Z",
    transform: "translate(30.108 60.589)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4244",
    "data-name": "Group 4244",
    transform: "translate(161.363 15.451) rotate(93.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5153",
    "data-name": "Path 5153",
    d: "M.635,1.325A.662.662,0,0,0,1.268.651.634.634,0,0,0,.635,0,.664.664,0,0,0,0,.674a.635.635,0,0,0,.635.651",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4245",
    "data-name": "Group 4245",
    transform: "translate(159.923 14.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5154",
    "data-name": "Path 5154",
    d: "M-.01.525C.072.612.575.241,1.289.245S2.525.606,2.6.519c.038-.038-.046-.2-.273-.362A1.819,1.819,0,0,0,1.279-.169,1.746,1.746,0,0,0,.244.162C.024.33-.051.486-.01.525",
    transform: "translate(0.021 0.169)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4246",
    "data-name": "Group 4246",
    transform: "matrix(-0.056, 0.998, -0.998, -0.056, 168.47, 15.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5155",
    "data-name": "Path 5155",
    d: "M.634,1.325A.664.664,0,0,0,1.268.65.634.634,0,0,0,.634,0,.663.663,0,0,0,0,.675a.634.634,0,0,0,.634.651",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4247",
    "data-name": "Group 4247",
    transform: "translate(166.94 14.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5156",
    "data-name": "Path 5156",
    d: "M-.01.525C.072.611.576.241,1.289.244S2.525.606,2.6.518C2.641.48,2.558.323,2.329.157A1.821,1.821,0,0,0,1.278-.17,1.749,1.749,0,0,0,.244.162C.024.33-.051.486-.01.525",
    transform: "translate(0.021 0.17)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4248",
    "data-name": "Group 4248",
    transform: "translate(162.53 14.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5157",
    "data-name": "Path 5157",
    d: "M-1.777,5.925a4.724,4.724,0,0,0-1.159-.212c-.182-.019-.354-.056-.385-.18a.932.932,0,0,1,.123-.54l.543-1.386A23.983,23.983,0,0,0-1.437-.021,23.9,23.9,0,0,0-2.946,3.5c-.181.487-.354.951-.519,1.395a1.054,1.054,0,0,0-.1.715.456.456,0,0,0,.3.267,1.266,1.266,0,0,0,.31.044,4.651,4.651,0,0,0,1.175,0",
    transform: "translate(3.594 0.022)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4249",
    "data-name": "Group 4249",
    transform: "translate(163.836 27.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5158",
    "data-name": "Path 5158",
    d: "M0-1.57A13.158,13.158,0,0,0,6.931-3.4S5.176.151,0-.345Z",
    transform: "translate(0 3.402)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4250",
    "data-name": "Group 4250",
    transform: "translate(164.574 21.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5159",
    "data-name": "Path 5159",
    d: "M-.07-1.7a1.285,1.285,0,0,1,1.154-.475,1.17,1.17,0,0,1,.81.436.745.745,0,0,1,.055.851.863.863,0,0,1-.936.235A2.7,2.7,0,0,1,.1-1.2.781.781,0,0,1-.1-1.41a.238.238,0,0,1,0-.266",
    transform: "translate(0.141 2.182)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4251",
    "data-name": "Group 4251",
    transform: "translate(166.628 13.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5160",
    "data-name": "Path 5160",
    d: "M0-.459c.07.194.783.1,1.62.207.839.086,1.514.332,1.626.159.05-.083-.068-.266-.34-.455A2.716,2.716,0,0,0,1.7-.973,2.717,2.717,0,0,0,.429-.827C.121-.7-.034-.551,0-.459",
    transform: "translate(0.007 0.991)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4252",
    "data-name": "Group 4252",
    transform: "translate(160.183 12.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5161",
    "data-name": "Path 5161",
    d: "M-.018.437C.107.6.6.432,1.191.426,1.782.4,2.282.537,2.4.368c.051-.082-.028-.245-.246-.4A1.669,1.669,0,0,0,1.17-.3,1.668,1.668,0,0,0,.205.025C0,.191-.073.358-.018.437",
    transform: "translate(0.036 0.299)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4253",
    "data-name": "Group 4253",
    transform: "translate(163.186 5.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5162",
    "data-name": "Path 5162",
    d: "M-14.134,20.021a4.672,4.672,0,0,1-4.034-1.138A4.672,4.672,0,0,1-19.6,14.942c.161-1.27.845-2.563.406-3.765-.582-1.59-2.811-2.079-3.4-3.665-.344-.922-.035-2-.425-2.9a3.448,3.448,0,0,0-2.13-1.653,8.9,8.9,0,0,1-2.534-1.1A1.99,1.99,0,0,1-28.4-.58,49,49,0,0,1-17.1,2.166a4.364,4.364,0,0,1,2.23,1.444,4.567,4.567,0,0,1,.458,2.772q-.325,6.966-.65,13.932",
    transform: "translate(28.59 0.58)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4254",
    "data-name": "Group 4254",
    transform: "translate(163.133 4.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5163",
    "data-name": "Path 5163",
    d: "M-16.858,2.41a.4.4,0,0,1,.086.211.792.792,0,0,1-.2.622,1.3,1.3,0,0,1-.926.468,2.983,2.983,0,0,1-1.31-.392,3.629,3.629,0,0,0-1.509-.445,7.893,7.893,0,0,0-1.826.166,12.3,12.3,0,0,1-2.065.266,2.974,2.974,0,0,1-2.118-.773A6.142,6.142,0,0,1-27.945.642a9.495,9.495,0,0,0-.987-1.775,2.9,2.9,0,0,0-2.985-1.089,3.028,3.028,0,0,0-1.8,1.332,7.25,7.25,0,0,0-.379.767.667.667,0,0,1,.039-.222,2.772,2.772,0,0,1,.25-.6,3.056,3.056,0,0,1,1.843-1.463,3.021,3.021,0,0,1,1.661.033,3.094,3.094,0,0,1,1.565,1.087A9.448,9.448,0,0,1-27.708.528a5.977,5.977,0,0,0,1.166,1.809,2.718,2.718,0,0,0,1.936.706A12.469,12.469,0,0,0-22.585,2.8,7.853,7.853,0,0,1-20.7,2.652a3.788,3.788,0,0,1,1.577.5,2.926,2.926,0,0,0,1.223.413,1.2,1.2,0,0,0,.85-.387.759.759,0,0,0,.224-.548c-.006-.141-.048-.211-.032-.217",
    transform: "translate(34.1 2.507)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4255",
    "data-name": "Group 4255",
    transform: "translate(174.536 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5164",
    "data-name": "Path 5164",
    d: "M-2.877,2.972A3.918,3.918,0,0,1-5.819-.822,3.919,3.919,0,0,1-2.693-4.466a2.3,2.3,0,0,1,2.271.709C.051-3.111.02-2.147.624-1.621c.646.562,1.638.32,2.476.5A2.807,2.807,0,0,1,5.118,1.9,3.8,3.8,0,0,1,2.73,4.85a5.983,5.983,0,0,1-3.907.076A14.652,14.652,0,0,1-4.748,3.193",
    transform: "translate(5.82 4.514)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4256",
    "data-name": "Group 4256",
    transform: "translate(178.219 3.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5165",
    "data-name": "Path 5165",
    d: "M-5.353-6.957a2.319,2.319,0,0,1-.379.949A5.254,5.254,0,0,1-7.467-4.249a5.255,5.255,0,0,1-2.343.783,2.325,2.325,0,0,1-1.019-.077c0-.047.391-.021,1-.111a5.959,5.959,0,0,0,2.222-.822A5.96,5.96,0,0,0-5.892-6.11c.348-.5.5-.864.538-.846",
    transform: "translate(10.828 6.957)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4257",
    "data-name": "Group 4257",
    transform: "translate(175.408 6.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5166",
    "data-name": "Path 5166",
    d: "M-5.425,3.177A10.2,10.2,0,0,0-7.874,1.019a10.192,10.192,0,0,0-3.1-1.027A2.437,2.437,0,0,1-9.988,0,6.385,6.385,0,0,1-7.74.786,6.384,6.384,0,0,1-5.931,2.333a2.439,2.439,0,0,1,.507.844",
    transform: "translate(10.973 0.045)",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4258",
    "data-name": "Group 4258",
    transform: "translate(164.38 23.439) rotate(-119.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5167",
    "data-name": "Path 5167",
    d: "M.283,3.282A3.2,3.2,0,0,1,0,1.64,3.6,3.6,0,0,1,.283,0,10.048,10.048,0,0,1,.264,1.643,15.856,15.856,0,0,1,.283,3.282",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4259",
    "data-name": "Group 4259",
    transform: "translate(180.47 5.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5168",
    "data-name": "Path 5168",
    d: "M0-.02C0-.029.063-.054.191-.093A4.743,4.743,0,0,1,.762-.217a5.934,5.934,0,0,1,2.149.071A4.563,4.563,0,0,1,4.325.383a.871.871,0,0,1,.4.8.67.67,0,0,1-.262.434,1.134,1.134,0,0,1-.451.193,3.15,3.15,0,0,1-.95.012,7.149,7.149,0,0,1-.958-.159,6.362,6.362,0,0,1-.964-.3A2.03,2.03,0,0,1,.274.73,1.391,1.391,0,0,1,.067-.34C.125-.688.215-1,.293-1.317A6.487,6.487,0,0,1,.98-3.093a1.187,1.187,0,0,1,.754-.561.732.732,0,0,1,.819.371,1.1,1.1,0,0,1-.04.828A5.1,5.1,0,0,1,2.2-1.8,5.056,5.056,0,0,1,.764-.2,3.918,3.918,0,0,1,.266.1C.146.163.081.19.076.181S.314.031.7-.285A5.323,5.323,0,0,0,2.037-1.894a4.935,4.935,0,0,0,.284-.631.912.912,0,0,0,.033-.666.509.509,0,0,0-.578-.236.96.96,0,0,0-.593.467,6.43,6.43,0,0,0-.64,1.707C.414-.638.108.066.488.576a3.012,3.012,0,0,0,1.68.839,7.061,7.061,0,0,0,.923.16,2.982,2.982,0,0,0,.875,0c.269-.051.5-.2.532-.425A.653.653,0,0,0,4.2.56,4.559,4.559,0,0,0,2.87.036,6.365,6.365,0,0,0,.775-.115C.277-.067.005,0,0-.02",
    transform: "translate(0 3.67)",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4260",
    "data-name": "Group 4260",
    transform: "translate(162.499 2.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5169",
    "data-name": "Path 5169",
    d: "M-12.371,1.563c.008,0-.017.056-.073.152a1.526,1.526,0,0,1-.333.351,2.26,2.26,0,0,1-1.711.38,4.308,4.308,0,0,1-2.238-1.334,11.865,11.865,0,0,0-2.3-2.1A4.066,4.066,0,0,0-22-1.365,3.918,3.918,0,0,0-24.069-.023a4.3,4.3,0,0,0-.789,1.505c-.112.391-.134.618-.157.616s-.011-.058-.008-.167a2.687,2.687,0,0,1,.065-.474,4.038,4.038,0,0,1,.742-1.6A4.019,4.019,0,0,1-22.058-1.6a4.25,4.25,0,0,1,3.16.383A11.423,11.423,0,0,1-16.555.941a4.228,4.228,0,0,0,2.1,1.322,2.229,2.229,0,0,0,1.62-.28,3.315,3.315,0,0,0,.465-.42",
    transform: "translate(25.024 1.746)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4261",
    "data-name": "Group 4261",
    transform: "translate(135.76 38.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5170",
    "data-name": "Path 5170",
    d: "M-19.2-73.739s-3.638,2.288-4.069,7.982-1.681,17.575-1.681,17.575l-13.89,3.4,1.548,8.332,22.915-6.389Z",
    transform: "translate(38.841 73.739)",
    fill: "#96c4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4262",
    "data-name": "Group 4262",
    transform: "translate(155.209 32.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5171",
    "data-name": "Path 5171",
    d: "M-19.419-89.75l2.271,2.582s5.91,1.405,7.193,1.955S-11.971-72.57-11.971-72.57l.487,24.853a3.132,3.132,0,0,1-3.409,3.182l-22.455-2-1.933-28.037.19-8.566,5.355-1.852,3.1-3.065,2.453,5.5Z",
    transform: "translate(39.281 89.75)",
    fill: "#96c4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4263",
    "data-name": "Group 4263",
    transform: "translate(168.972 36.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5172",
    "data-name": "Path 5172",
    d: "M-15.217-76.5s4.576,1.755,4.965,8.654C-10-63.3-8.4-55.542-7.34-50.773a10.291,10.291,0,0,1-1.388,7.795,10.3,10.3,0,0,1-8.219,4.73l-9.728.429-4.106-6.535,10.908-3.18,2.585-15.729Z",
    transform: "translate(30.781 76.498)",
    fill: "#96c4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4264",
    "data-name": "Group 4264",
    transform: "translate(171.032 63.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5173",
    "data-name": "Path 5173",
    d: "M-15.128,6.18a6.567,6.567,0,0,1-.139-.754,9.225,9.225,0,0,0-.575-1.989A5.4,5.4,0,0,0-17.7,1.08,3.959,3.959,0,0,0-19.33.409,5.5,5.5,0,0,0-21.24.5a59.078,59.078,0,0,0-6.639,1.82l-1.982.672a4.269,4.269,0,0,1-.74.212,4.375,4.375,0,0,1,.7-.308l1.954-.751A48.7,48.7,0,0,1-21.29.241a5.682,5.682,0,0,1,2-.087,4.168,4.168,0,0,1,1.727.727A5.482,5.482,0,0,1-15.67,3.365a8.1,8.1,0,0,1,.5,2.045,3.213,3.213,0,0,1,.038.77",
    transform: "translate(30.601 -0.1)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4265",
    "data-name": "Group 4265",
    transform: "translate(180.331 49.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5174",
    "data-name": "Path 5174",
    d: "M-.024-25.6a1.975,1.975,0,0,1,.078.51c.034.329.067.806.1,1.4.056,1.246.127,2.842.206,4.606a34.7,34.7,0,0,0,.512,4.565c.221,1.154.457,1.847.413,1.862a1.936,1.936,0,0,1-.2-.473c-.062-.154-.122-.348-.187-.575s-.14-.484-.2-.775A27.152,27.152,0,0,1,.1-19.074c-.1-1.8-.111-3.435-.129-4.615q-.008-.814-.016-1.4A1.952,1.952,0,0,1-.024-25.6",
    transform: "translate(0.048 25.602)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4266",
    "data-name": "Group 4266",
    transform: "translate(172.554 71.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5175",
    "data-name": "Path 5175",
    d: "M-17.113-7.31a3.911,3.911,0,0,1-.519.516,12.165,12.165,0,0,1-1.61,1.18,13.756,13.756,0,0,1-6.246,1.959,13.023,13.023,0,0,1-3.622-.272c-1.1-.233-2.026-.624-2.835-.814A13.454,13.454,0,0,0-33.9-5.015a2.441,2.441,0,0,1-.718-.145c0-.02.259.021.726.043a10.9,10.9,0,0,1,1.987.194c.832.172,1.767.545,2.843.758a13.314,13.314,0,0,0,3.555.246,14.3,14.3,0,0,0,6.168-1.856A25.63,25.63,0,0,0-17.113-7.31",
    transform: "translate(34.616 7.312)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4267",
    "data-name": "Group 4267",
    transform: "translate(161.934 58.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5176",
    "data-name": "Path 5176",
    d: "M-14.941-17.073a3.538,3.538,0,0,1-.43.56A18.073,18.073,0,0,1-16.681-15.1a24.051,24.051,0,0,1-2.156,1.874A26.819,26.819,0,0,1-21.756-11.3a26.851,26.851,0,0,1-3.162,1.5,24.121,24.121,0,0,1-2.719.878,18.272,18.272,0,0,1-1.883.394,3.658,3.658,0,0,1-.7.079,3.529,3.529,0,0,1,.682-.179c.442-.093,1.078-.251,1.854-.473a27.538,27.538,0,0,0,2.678-.924,29.465,29.465,0,0,0,3.123-1.5,29.434,29.434,0,0,0,2.9-1.9,27.663,27.663,0,0,0,2.174-1.816c.591-.549,1.055-1.011,1.363-1.342a3.622,3.622,0,0,1,.506-.491",
    transform: "translate(30.222 17.073)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4269",
    "data-name": "Group 4269",
    transform: "translate(162.832 59.745)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4268",
    "data-name": "Group 4268",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5177",
    "data-name": "Path 5177",
    d: "M-.491,6.147c-.625-.516-.245-1.62.468-2.006A5.2,5.2,0,0,1,2.36,3.815,9.1,9.1,0,0,0,7.89,1.744C9.038.793,10.071-.5,11.549-.7,11.211.508,9.754,1.685,8.728,2.408,5.749,4.512,2.469,5.3-.993,6.5",
    transform: "translate(0.993 0.701)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4270",
    "data-name": "Group 4270",
    transform: "translate(166.764 34.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5178",
    "data-name": "Path 5178",
    d: "M-9.85-12.31a1.889,1.889,0,0,1-.347.372c-.235.227-.58.549-1.012.942-.862.786-2.064,1.859-3.4,3.032a10.144,10.144,0,0,1-2.025,1.523,3.22,3.22,0,0,1-1.081.332,2.386,2.386,0,0,1-.982-.113A1.853,1.853,0,0,1-19.8-7.1a1.168,1.168,0,0,1-.119-.367c-.011-.087-.011-.133,0-.134.026-.006.046.181.211.45a1.828,1.828,0,0,0,1.062.747,2.273,2.273,0,0,0,.9.074,3.069,3.069,0,0,0,.995-.331,10.655,10.655,0,0,0,1.961-1.5c1.339-1.173,2.562-2.223,3.454-2.974.447-.376.812-.676,1.067-.879a1.919,1.919,0,0,1,.415-.295",
    transform: "translate(19.924 12.311)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4271",
    "data-name": "Group 4271",
    transform: "translate(161.013 37.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5179",
    "data-name": "Path 5179",
    d: "M-4.517-1.1a2.584,2.584,0,0,1-.735.875,5.059,5.059,0,0,1-1.034.7.994.994,0,0,1-.79.147,1.146,1.146,0,0,1-.547-.658c-.45-.967-.844-1.849-1.117-2.493A4.873,4.873,0,0,1-9.133-3.6a4.852,4.852,0,0,1,.561.986c.317.624.737,1.494,1.187,2.461.107.238.227.462.4.528A.8.8,0,0,0-6.394.255,5.778,5.778,0,0,0-5.37-.373c.546-.42.821-.758.853-.731",
    transform: "translate(9.138 3.597)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4272",
    "data-name": "Group 4272",
    transform: "translate(166.116 39.356) rotate(2.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5180",
    "data-name": "Path 5180",
    d: "M.131,11.444C.059,11.444,0,8.882,0,5.722S.059,0,.131,0,.263,2.562.263,5.722.2,11.444.131,11.444",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4273",
    "data-name": "Group 4273",
    transform: "translate(155.859 46.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5181",
    "data-name": "Path 5181",
    d: "M-.129,3.172A4.889,4.889,0,0,1-.26,1.586,4.891,4.891,0,0,1-.129,0,4.866,4.866,0,0,1,0,1.586,4.864,4.864,0,0,1-.129,3.172",
    transform: "translate(0.26)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4274",
    "data-name": "Group 4274",
    transform: "translate(175.688 39.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    "data-name": "Path 5182",
    d: "M0-.053a.07.07,0,0,0,.042.027A.063.063,0,0,0,0-.053",
    transform: "translate(0 0.053)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4275",
    "data-name": "Group 4275",
    transform: "translate(175.73 39.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5183",
    "data-name": "Path 5183",
    d: "M0,0H0Z",
    transform: "translate(0.001)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4276",
    "data-name": "Group 4276",
    transform: "translate(179.11 39.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5184",
    "data-name": "Path 5184",
    d: "M-.013,0-.027,0A.044.044,0,0,0-.013,0",
    transform: "translate(0.027 0.003)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4278",
    "data-name": "Group 4278",
    transform: "translate(175.976 41.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5186",
    "data-name": "Path 5186",
    d: "M0-.045c.005.014.018.018.03.023A.038.038,0,0,0,0-.045",
    transform: "translate(0 0.045)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4279",
    "data-name": "Group 4279",
    transform: "translate(178.366 41.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5187",
    "data-name": "Path 5187",
    d: "M-.009,0l-.01,0,.01,0",
    transform: "translate(0.019 0.005)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4281",
    "data-name": "Group 4281",
    transform: "translate(175.192 45.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5189",
    "data-name": "Path 5189",
    d: "M0-.023A.05.05,0,0,0,.037-.01.042.042,0,0,0,0-.023",
    transform: "translate(0 0.024)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4282",
    "data-name": "Group 4282",
    transform: "translate(177.844 44.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5190",
    "data-name": "Path 5190",
    d: "M-.01,0h0",
    transform: "translate(0.021 0.003)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4284",
    "data-name": "Group 4284",
    transform: "translate(175.65 48.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5192",
    "data-name": "Path 5192",
    d: "M0-.015a.039.039,0,0,0,.033.01A.032.032,0,0,0,0-.015",
    transform: "translate(0 0.017)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4285",
    "data-name": "Group 4285",
    transform: "translate(177.809 47.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5193",
    "data-name": "Path 5193",
    d: "M-.009,0l-.01,0,.01,0",
    transform: "translate(0.019 0.005)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4287",
    "data-name": "Group 4287",
    transform: "translate(175.351 51.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5195",
    "data-name": "Path 5195",
    d: "M0-.018c.009.011.021.011.032.012A.032.032,0,0,0,0-.018",
    transform: "translate(0 0.019)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4288",
    "data-name": "Group 4288",
    transform: "translate(177.549 50.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5196",
    "data-name": "Path 5196",
    d: "M-.009,0l-.01,0,.01,0",
    transform: "translate(0.019 0.004)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4290",
    "data-name": "Group 4290",
    transform: "translate(175.421 54.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5198",
    "data-name": "Path 5198",
    d: "M0-.041c.006.013.018.017.03.021A.038.038,0,0,0,0-.041",
    transform: "translate(0 0.041)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4291",
    "data-name": "Group 4291",
    transform: "translate(175.451 54.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5199",
    "data-name": "Path 5199",
    d: "M0,0H0Z",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4292",
    "data-name": "Group 4292",
    transform: "translate(177.911 54.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5200",
    "data-name": "Path 5200",
    d: "M-.01,0h0",
    transform: "translate(0.021 0.001)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4294",
    "data-name": "Group 4294",
    transform: "translate(175.804 57.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5202",
    "data-name": "Path 5202",
    d: "M0-.015a.042.042,0,0,0,.036.009A.036.036,0,0,0,0-.015",
    transform: "translate(0 0.016)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4295",
    "data-name": "Group 4295",
    transform: "translate(175.839 57.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5203",
    "data-name": "Path 5203",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4296",
    "data-name": "Group 4296",
    transform: "translate(178.351 56.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5204",
    "data-name": "Path 5204",
    d: "M-.011,0-.022,0A.027.027,0,0,0-.011,0",
    transform: "translate(0.022 0.001)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4298",
    "data-name": "Group 4298",
    transform: "translate(176.296 61.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5206",
    "data-name": "Path 5206",
    d: "M0-.006a.035.035,0,0,0,.034,0A.032.032,0,0,0,0-.006",
    transform: "translate(0 0.012)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4299",
    "data-name": "Group 4299",
    transform: "translate(176.331 61.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5207",
    "data-name": "Path 5207",
    d: "M0,0H0",
    transform: "translate(0.001)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4300",
    "data-name": "Group 4300",
    transform: "translate(178.009 59.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5208",
    "data-name": "Path 5208",
    d: "M-.008-.011l-.008.006.008-.006",
    transform: "translate(0.016 0.011)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4302",
    "data-name": "Group 4302",
    transform: "translate(176.34 63.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5210",
    "data-name": "Path 5210",
    d: "M0-.022a.023.023,0,0,0,.021.013C.014-.02.008-.024,0-.022",
    transform: "translate(0 0.022)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4303",
    "data-name": "Group 4303",
    transform: "translate(176.361 63.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5211",
    "data-name": "Path 5211",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4304",
    "data-name": "Group 4304",
    transform: "translate(177.698 62.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5212",
    "data-name": "Path 5212",
    d: "M-.006,0-.012,0A.009.009,0,0,0-.006,0",
    transform: "translate(0.012 0.003)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4310",
    "data-name": "Group 4310",
    transform: "translate(169.328 42.41)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4306",
    "data-name": "Group 4306",
    transform: "translate(0.007 0.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5214",
    "data-name": "Path 5214",
    d: "M0-.027c.006.012.015.013.025.015C.017-.024.01-.029,0-.027",
    transform: "translate(0 0.028)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4307",
    "data-name": "Group 4307",
    transform: "translate(0.032 0.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5215",
    "data-name": "Path 5215",
    d: "M0,0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4308",
    "data-name": "Group 4308",
    transform: "translate(1.546 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5216",
    "data-name": "Path 5216",
    d: "M-.006-.006-.012,0Z",
    transform: "translate(0.012 0.006)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4309",
    "data-name": "Group 4309",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5217",
    "data-name": "Path 5217",
    d: "M-.468.834V.813c.022,0,.009.022.028.015,0-.029.034,0,.039-.016,0,0,.01,0,.011.011,0-.016.01,0,.016-.01s0,0,0-.009L-.366.8c.007,0,.009.013,0,.015A1.238,1.238,0,0,0-.106.786c-.008-.01-.018,0-.026-.018.009-.012.016,0,.019-.011C-.1.784-.09.76-.077.786V.77L-.07.779C-.027.753-.06.769-.019.764,0,.757.011.733.026.738c0,0-.01-.008,0-.013,0,.013.014-.013.02,0C.047.722.067.719.056.7.061.711.08.711.071.721s.012,0,.016,0l-.009,0C.1.706.111.718.12.7L.111.693C.122.689.131.685.14.7L.13.71A.085.085,0,0,0,.174.688H.168C.184.666.286.623.3.6L.285.584.3.568A.266.266,0,0,1,.3.611C.334.6.506.535.539.531.554.534.55.554.55.554s0-.017.015-.02,0,.011,0,.013S.578.547.576.54.565.52.558.511l.017,0,0,.011S.577.485.6.485.652.464.68.456c0,.007,0,.012-.007.018s.008,0,.014,0C.677.464.7.461.689.458.7.425.733.438.743.413.736.39.614.009.6-.019c.005,0,.01,0,.012,0A.012.012,0,0,0,.6-.02L.6-.005C.6,0,.6-.012.587-.007.582-.018.591-.025.6-.03c-.009,0-.021,0-.018.011-.01,0-.006-.015-.017-.016s-.009.021-.02.017v0C.521-.024.524.01.5,0V0C.493-.005.485.009.47.005c0,0,.011.009,0,.013S.454.026.441.021l0,.015-.26.1,0,0C.111.163-.033.2-.1.23c-.014-.01-.029,0-.041,0,.007,0,.007.013,0,.014-.037.005,0,.009-.036.021A.734.734,0,0,1-.422.286C-.44.307-.467.3-.485.31l0,0c-.021.01-.144,0-.168.012l0,0C-.669.332-.668.311-.685.306A.033.033,0,0,1-.707.341v0A.285.285,0,0,1-.759.363V.352C-.773.364-.8.36-.812.362S-.875.339-.907.354L-.928.322l0,0A1.566,1.566,0,0,0-.923.793V.8l.01,0C-.9.808-.9.8-.9.807l-.016,0c.012,0,0,.009,0,.016A.027.027,0,0,1-.9.827s0,0,0-.007S-.891.8-.883.81s0,.018.015.019A1.085,1.085,0,0,0-.651.841s0,0,0,.007C-.63.841-.611.842-.591.836a.039.039,0,0,1,.01.016c0-.009.113-.018.113-.018",
    transform: "translate(0.947 0.035)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4315",
    "data-name": "Group 4315",
    transform: "translate(169.142 44.883)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4311",
    "data-name": "Group 4311",
    transform: "translate(0 0.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5218",
    "data-name": "Path 5218",
    d: "M0-.034a.025.025,0,0,0,.02.018C.015-.029.009-.035,0-.034",
    transform: "translate(0 0.034)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(0.02 0.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5219",
    "data-name": "Path 5219",
    d: "M0,0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4313",
    "data-name": "Group 4313",
    transform: "translate(1.595 0.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5220",
    "data-name": "Path 5220",
    d: "M-.006,0H-.013A.01.01,0,0,0-.006,0",
    transform: "translate(0.013 0.002)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4314",
    "data-name": "Group 4314",
    transform: "translate(0.007 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5221",
    "data-name": "Path 5221",
    d: "M-.38.475l0-.02c.018,0,0,.024.021.021.009-.028.028.006.035-.009,0,0,.008,0,.007.013C-.31.465-.3.477-.3.474s0-.005,0-.01l.013,0c0,.006,0,.015,0,.016A1.142,1.142,0,0,0-.071.512C-.075.5-.086.507-.088.488S-.075.493-.07.483c0,.027.019.009.023.037l0-.015,0,.01C0,.5-.029.508.006.515S.038.495.049.5.044.494.05.49C.049.5.065.482.066.5.072.495.088.5.084.479.086.489.1.494.091.5S.1.506.1.5L.1.5C.116.5.124.51.136.5L.131.487c.01,0,.019,0,.021.019l-.012,0A.066.066,0,0,0,.184.5L.178.5C.2.485.295.48.314.459L.307.444.324.433S.311.479.31.474A1.473,1.473,0,0,1,.529.495c.01.009,0,.023,0,.025S.536.505.547.508s0,.011,0,.013.01,0,.011,0,0-.023,0-.035l.015,0L.564.5S.576.468.59.475.643.482.667.488C.666.494.661.5.655.5S.664.5.666.506C.662.493.678.5.673.493.7.468.716.5.735.478S.814.061.818.032c.005,0,.01,0,.011,0A.011.011,0,0,0,.813.029l0,.016C.8.049.809.035.8.034S.809.02.819.02C.81.018.8.007.8.021.79.015.8.006.79,0S.773.013.765.005V0C.748-.013.734.019.717,0l0,0C.714-.008.7,0,.69-.009S.7,0,.688,0,.666,0,.658-.009L.647,0C.6,0,.42-.006.374-.009l0,0A2.466,2.466,0,0,0,.088-.019C.078-.032.062-.031.051-.036c.006.006,0,.015,0,.014-.036-.006,0,.008-.04.01A.875.875,0,0,1-.226-.05c-.022.016-.045,0-.065.009l0,0C-.31-.04-.426-.07-.451-.066l0,0C-.47-.054-.465-.073-.48-.082A.033.033,0,0,1-.507-.05v0a.306.306,0,0,1-.053.019l0-.011c-.016.01-.042,0-.052,0S-.667-.075-.7-.064L-.717-.1l0,0A1.812,1.812,0,0,0-.761.371l0,.011h.009c.009.007.015-.006.013.005l-.013,0c.009,0,0,.009,0,.015A.019.019,0,0,1-.746.407s0-.005,0-.008S-.734.386-.728.392s0,.018.01.021A1.082,1.082,0,0,0-.535.452s0,0,0,.006c.02,0,.036,0,.054,0A.042.042,0,0,1-.478.473c0-.01.1,0,.1,0",
    transform: "translate(0.769 0.098)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4319",
    "data-name": "Group 4319",
    transform: "translate(169.717 46.846)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4316",
    "data-name": "Group 4316",
    transform: "translate(0.01 0.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5222",
    "data-name": "Path 5222",
    d: "M0-.027c.006.012.015.013.025.015C.017-.024.01-.029,0-.027",
    transform: "translate(0 0.028)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4317",
    "data-name": "Group 4317",
    transform: "translate(1.624 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5223",
    "data-name": "Path 5223",
    d: "M-.006,0-.013,0Z",
    transform: "translate(0.013 0.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4318",
    "data-name": "Group 4318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5224",
    "data-name": "Path 5224",
    d: "M-.474.793V.772c.022,0,.009.022.028.016.005-.029.034,0,.039-.016,0,0,.01,0,.01.011,0-.016.01,0,.016-.009s0,0,0-.009L-.372.758c.006,0,.009.013,0,.016A1.321,1.321,0,0,0-.11.754C-.117.743-.128.753-.136.735c.009-.012.016,0,.019-.01.008.026.024,0,.036.029V.739l.007.008C-.028.724-.063.738-.021.735,0,.728.01.7.024.71S.016.7.021.7c0,.013.015-.012.02,0C.047.7.067.694.057.676.062.685.08.685.071.7c.006,0,.012,0,.015,0l-.008,0C.1.681.111.694.121.674L.112.668C.124.665.133.662.142.679L.13.687A.082.082,0,0,0,.176.666H.17C.188.645.293.608.306.58L.294.568.307.553A.242.242,0,0,1,.307.6C.342.587.52.532.554.532c.015,0,.009.023.009.023s0-.016.016-.019,0,.011,0,.014S.592.55.591.543.58.522.574.512l.018,0,0,.011S.6.488.613.489.672.473.7.467C.7.474.7.479.693.485S.7.48.707.484C.7.475.716.473.71.47.723.437.757.453.769.429.763.4.676.015.669-.014c0,0,.01,0,.013,0a.012.012,0,0,0-.019,0L.667,0C.656.009.661-.008.65,0c0-.012.006-.018.015-.023-.01,0-.021,0-.02.01-.01,0,0-.015-.016-.018S.617-.012.607-.017v0C.582-.025.581.009.56,0V0C.552-.008.542.005.527,0c0,0,.01.01,0,.013S.508.021.5.014L.489.029.212.118l0,0C.142.139-.009.169-.083.2-.1.187-.112.193-.125.192c.008,0,.007.013,0,.013-.038,0,0,.009-.038.02A.822.822,0,0,1-.417.246c-.019.021-.047.01-.067.023l0,0c-.022.01-.15,0-.174.01l0,0C-.675.289-.674.269-.691.264A.033.033,0,0,1-.714.3v0A.269.269,0,0,1-.768.321V.309c-.015.013-.044.009-.055.01C-.848.316-.888.3-.922.312L-.944.281l0,0A1.566,1.566,0,0,0-.933.752V.763l.009,0c.012.006.017-.008.017,0H-.924c.012,0,0,.009,0,.016A.035.035,0,0,1-.911.785s0,0,0-.007S-.9.763-.892.768s0,.018.015.019A1.184,1.184,0,0,0-.658.8s0,0,0,.007C-.638.8-.618.8-.6.793a.033.033,0,0,1,.01.016c0-.009.112-.018.114-.017",
    transform: "translate(0.959 0.033)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4323",
    "data-name": "Group 4323",
    transform: "translate(169.428 50.191)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4320",
    "data-name": "Group 4320",
    transform: "translate(0.161 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5225",
    "data-name": "Path 5225",
    d: "M0-.011a.031.031,0,0,0,.031,0A.028.028,0,0,0,0-.011",
    transform: "translate(0 0.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4321",
    "data-name": "Group 4321",
    transform: "translate(1.899 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5226",
    "data-name": "Path 5226",
    d: "M-.008-.008-.016,0a.02.02,0,0,0,.008,0",
    transform: "translate(0.016 0.008)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4322",
    "data-name": "Group 4322",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5227",
    "data-name": "Path 5227",
    d: "M-.665.791-.67.772c.023-.009.015.019.035.007C-.637.748-.6.768-.6.751c0,0,.011,0,.014.008,0-.016.01-.008.015-.014s0,0-.007-.007L-.562.727c.008,0,.013.011.007.014A2.05,2.05,0,0,0-.277.651C-.286.642-.3.654-.308.639-.3.626-.29.636-.289.625c.014.024.027,0,.046.02l0-.016.009.007C-.193.6-.229.624-.183.611-.158.6-.153.574-.137.576c0,0-.011-.006-.006-.012.006.012.014-.016.022,0,.006,0,.027-.011.014-.025.007.008.027,0,.019.016s.014,0,.017-.007l-.01,0c.021-.011.037,0,.046-.022l-.011,0C-.034.509-.023.5-.012.52L-.023.53A.11.11,0,0,0,.024.5L.018.5C.034.476.146.418.159.388L.145.379.158.361S.166.408.163.4A2.612,2.612,0,0,1,.434.3C.451.3.444.32.445.323.461.312.447.306.462.3s0,.011,0,.014S.478.314.476.307.463.287.456.278L.475.272l0,.011S.478.25.5.249.565.226.6.216C.6.223.594.229.589.235S.6.23.6.233C.593.225.615.221.607.218.621.184.659.2.673.171.667.147.569-.242.56-.27a.032.032,0,0,1,.016,0,.018.018,0,0,0-.023,0l0,.016C.544-.244.55-.262.535-.256.53-.267.543-.275.554-.28c-.011,0-.025,0-.025.012-.012,0,0-.015-.019-.016S.5-.261.483-.264v0c-.029,0-.031.033-.058.028V-.244c-.01,0-.022.012-.039.01.005,0,.012.008,0,.013S.363-.211.348-.216L.34-.2C.283-.181.063-.081.007-.057l0,0c-.085.039-.264.1-.348.154C-.359.087-.377.1-.392.1c.01,0,.011.011,0,.013-.044.016,0,.009-.043.031a1.49,1.49,0,0,1-.3.1C-.749.267-.785.266-.8.285V.28C-.827.3-.98.335-1.008.353H-1c-.022.02-.026,0-.049,0,.01.018-.008.037-.017.042v0A.479.479,0,0,1-1.125.44l0-.011c-.014.018-.049.026-.061.032a.239.239,0,0,0-.117.033L-1.342.473l0,0s.094.377.174.435l0,.011.01-.005c.015,0,.016-.014.019,0L-1.157.92c.014,0,.007.008,0,.015a.035.035,0,0,1,.016,0c0-.005,0,0-.006-.006s.011-.019.021-.018.007.017.022.013A2.025,2.025,0,0,0-.862.857s0,0,0,.007C-.84.85-.818.844-.8.831A.037.037,0,0,1-.783.844C-.79.836-.668.789-.665.791",
    transform: "translate(1.345 0.284)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4327",
    "data-name": "Group 4327",
    transform: "translate(169.156 54.085)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4324",
    "data-name": "Group 4324",
    transform: "translate(0 0.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5228",
    "data-name": "Path 5228",
    d: "M0-.033a.049.049,0,0,0,.035.017A.04.04,0,0,0,0-.033",
    transform: "translate(0 0.033)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4325",
    "data-name": "Group 4325",
    transform: "translate(2.386 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5229",
    "data-name": "Path 5229",
    d: "M-.009-.009l-.01,0Z",
    transform: "translate(0.019 0.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4326",
    "data-name": "Group 4326",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5230",
    "data-name": "Path 5230",
    d: "M-.673.922V.9c.032,0,.011.023.04.016.01-.029.05,0,.059-.015,0,0,.015,0,.014.011,0-.016.015,0,.023-.009s0,0-.005-.009l.02-.007C-.513.891-.51.9-.519.9A2.319,2.319,0,0,0-.142.875c-.01-.011-.026,0-.036-.017.015-.013.023,0,.029-.011.01.026.034,0,.051.027l0-.016.009.009C-.022.84-.073.857-.012.85.022.842.035.818.055.823c0,0-.012-.008,0-.014C.055.823.074.8.08.809.089.806.117.8.1.786.111.794.137.793.124.8.132.8.141.8.146.8L.135.8C.162.787.181.8.2.778L.184.773C.2.768.216.764.226.781L.209.79A.165.165,0,0,0,.276.765l-.009,0c.027-.024.181-.074.2-.1L.454.652.474.634s0,.048,0,.044C.52.665.778.583.826.575.847.577.836.6.836.6.858.586.842.581.862.576s0,.011,0,.014S.878.588.877.581.864.561.856.552L.881.545l0,.011C.89.555.889.523.914.521.956.511,1,.493,1.04.481c0,.007-.006.013-.013.02S1.04.5,1.047.5C1.033.49,1.061.485,1.052.483c.02-.036.067-.027.086-.055C1.132.4,1.041.012,1.03-.015a.038.038,0,0,1,.018,0c0-.006-.02,0-.026,0l0,.016C1.01.012,1.018-.007,1,0c-.006-.012.01-.02.023-.027-.013,0-.029,0-.029.014-.014,0,0-.015-.021-.015S.957,0,.942,0v0C.909-.009.9.028.874.025V.019C.864.015.849.031.829.03c.006,0,.013.008,0,.013S.8.054.783.049L.773.066C.706.087.441.184.371.2l0,0L-.06.311a.14.14,0,0,0-.061,0c.011,0,.009.013,0,.014-.056.007,0,.009-.058.022a1.545,1.545,0,0,1-.37.029c-.03.021-.069.009-.1.023l0-.005C-.676.4-.861.391-.9.4l0,0C-.927.412-.923.392-.949.386c0,.021-.025.032-.035.034v0a.474.474,0,0,1-.08.023V.428a.211.211,0,0,1-.081.006A.378.378,0,0,0-1.288.418L-1.318.385l-.005,0S-1.4.77-1.337.856l0,.012h.014c.016.006.025-.006.023,0l-.023,0c.017,0,.005.009,0,.015a.058.058,0,0,1,.019.007s0,0-.005-.007.023-.014.034-.008,0,.018.02.02A1.959,1.959,0,0,0-.94.922s0,0,0,.007c.032-.005.062,0,.091-.009A.036.036,0,0,1-.84.935.981.981,0,0,1-.673.922",
    transform: "translate(1.362 0.026)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4332",
    "data-name": "Group 4332",
    transform: "translate(169.105 58.001)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4328",
    "data-name": "Group 4328",
    transform: "translate(0.005 0.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5231",
    "data-name": "Path 5231",
    d: "M0-.03c.007.012.019.014.03.016A.033.033,0,0,0,0-.03",
    transform: "translate(0 0.03)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4329",
    "data-name": "Group 4329",
    transform: "translate(0.035 0.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5232",
    "data-name": "Path 5232",
    d: "M0,0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4330",
    "data-name": "Group 4330",
    transform: "translate(2.352 0.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5233",
    "data-name": "Path 5233",
    d: "M-.01,0-.02,0A.017.017,0,0,0-.01,0",
    transform: "translate(0.02 0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4331",
    "data-name": "Group 4331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5234",
    "data-name": "Path 5234",
    d: "M-.566.135l0-.02c.027,0,.006.024.03.021C-.52.11-.492.144-.481.13s.011,0,.01.014c.005-.016.013,0,.021-.006s0-.005,0-.01l.018,0c.007.006.007.015,0,.016.045.011.26.054.309.056C-.132.184-.148.189-.151.17c.015-.008.019.007.026,0,0,.028.027.011.032.04L-.086.192-.081.2C-.022.2-.067.2-.017.209.012.212.03.193.044.2S.037.192.045.19C.044.2.067.184.069.2S.1.2.1.184C.1.194.118.2.1.208c.008,0,.014.006.019,0L.115.2C.139.206.15.222.169.209L.161.2C.176.2.189.2.191.222l-.016,0a.13.13,0,0,0,.061,0l-.007,0C.257.21.394.224.423.208L.415.19.438.184S.418.227.417.222A2.158,2.158,0,0,1,.723.3c.014.012,0,.025,0,.025C.74.322.732.309.748.315s0,.011-.007.012.013.007.015,0,0-.023,0-.035L.778.3l0,.011S.794.283.813.3.886.317.92.331C.918.337.91.338.9.34s.012,0,.015.008C.911.335.933.345.928.338c.034-.019.06.017.088.006.01-.023.176-.388.188-.415a.046.046,0,0,1,.016.008c0-.007-.013-.015-.023-.013l-.006.014c-.02,0,0-.01-.02-.015,0-.012.02-.01.035-.007C1.194-.089,1.185-.1,1.175-.09,1.165-.1,1.181-.1,1.168-.114s-.029.008-.039,0v0c-.024-.022-.05,0-.072-.016l0,0c-.008-.01-.029-.006-.043-.018,0,0,.006.014-.005.012S.982-.154.97-.168L.953-.16C.886-.183.613-.236.543-.248l0,0A3.406,3.406,0,0,0,.112-.316.132.132,0,0,0,.056-.339c.009.007,0,.015,0,.013C0-.336.048-.318-.008-.322A2.59,2.59,0,0,1-.365-.384c-.032.014-.068,0-.1,0l0,0c-.033,0-.21-.03-.248-.026l0,0C-.736-.4-.73-.418-.754-.425c0,.021-.027.03-.037.031v0A.691.691,0,0,1-.87-.38l0-.011a.2.2,0,0,1-.078,0A.312.312,0,0,0-1.086-.4l-.03-.033,0,0s-.057.384,0,.469l0,.011h.012c.014.006.021-.007.02,0l-.019,0c.014,0,0,.01,0,.015a.042.042,0,0,1,.016.007s0,0,0-.008S-1.08.05-1.07.056s0,.018.017.02c.089.012.175.029.265.033,0,.005,0,0,0,.007l.076,0A.031.031,0,0,1-.705.13.521.521,0,0,1-.566.135",
    transform: "translate(1.146 0.434)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4336",
    "data-name": "Group 4336",
    transform: "translate(170.153 60.064)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4333",
    "data-name": "Group 4333",
    transform: "translate(0.047 0.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5235",
    "data-name": "Path 5235",
    d: "M0-.02a.033.033,0,0,0,.029.012A.028.028,0,0,0,0-.02",
    transform: "translate(0 0.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4334",
    "data-name": "Group 4334",
    transform: "translate(1.965 0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5236",
    "data-name": "Path 5236",
    d: "M-.008,0-.016,0A.015.015,0,0,0-.008,0",
    transform: "translate(0.016 0.003)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4335",
    "data-name": "Group 4335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5237",
    "data-name": "Path 5237",
    d: "M-.556.7V.681c.024,0,.01.022.031.014.005-.029.037,0,.043-.017,0,0,.011,0,.011.011,0-.016.011-.005.017-.01s0,0-.005-.009L-.443.664c.006,0,.009.013,0,.015A1.98,1.98,0,0,0-.158.66C-.165.649-.177.659-.185.641c.011-.012.018,0,.021-.01.008.027.027,0,.039.03V.646l.007.009c.05-.022.011-.009.057-.01C-.033.639-.023.616-.008.622c0,0-.01-.009,0-.014,0,.014.017-.012.022,0C.018.607.04.607.03.589.035.6.055.6.045.609c.006,0,.013,0,.017,0L.053.6C.074.6.088.61.1.592L.092.585C.1.583.115.58.123.6L.11.6A.1.1,0,0,0,.161.587H.155C.176.566.3.538.315.513L.3.5.32.485s0,.047-.006.042A2.437,2.437,0,0,1,.594.494C.609.5.6.516.6.519.616.511.6.5.62.5s0,.012,0,.014S.632.518.632.511.624.489.619.477h.02V.488S.647.457.667.46.734.454.767.453C.767.459.761.464.754.469s.011,0,.015,0C.761.459.782.461.776.457.8.427.83.448.849.427.848.4.847,0,.844-.028a.031.031,0,0,1,.015,0c0-.007-.016-.009-.022,0v.016C.823-.006.833-.023.818-.02c0-.013.012-.017.024-.02C.83-.04.818-.048.815-.033.8-.038.815-.049.8-.053s-.019.018-.03.012v0C.744-.054.735-.02.71-.03l0-.005C.7-.041.688-.029.673-.036c0,0,.009.011,0,.014s-.028,0-.042-.005L.621-.014C.562-.01.333.034.274.043l0,0C.187.057,0,.077-.088.1-.1.094-.124.1-.139.1-.13.1-.131.11-.139.11c-.046,0,0,.009-.048.019a1.422,1.422,0,0,1-.3.022C-.514.173-.547.162-.57.177l0,0c-.026.01-.179.01-.209.02l0,0C-.8.208-.8.188-.819.185c0,.02-.017.034-.025.036v0A.424.424,0,0,1-.908.248V.237C-.925.25-.96.249-.973.252a.237.237,0,0,0-.118,0L-1.12.227l0,0a1.4,1.4,0,0,0,.063.464V.706l.01,0c.014,0,.018-.01.019,0H-1.05c.014,0,.005.009,0,.016a.033.033,0,0,1,.016,0s0,0,0-.007S-1.023.7-1.014.707s0,.018.018.017A1.656,1.656,0,0,0-.756.716s0,0,0,.007C-.734.716-.712.715-.691.707A.035.035,0,0,1-.679.723.431.431,0,0,1-.556.7",
    transform: "translate(1.124 0.053)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4340",
    "data-name": "Group 4340",
    transform: "translate(168.76 64.906)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4337",
    "data-name": "Group 4337",
    transform: "translate(0.063 1.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5238",
    "data-name": "Path 5238",
    d: "M0-.014a.066.066,0,0,0,.048.008A.058.058,0,0,0,0-.014",
    transform: "translate(0 0.016)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4338",
    "data-name": "Group 4338",
    transform: "translate(3.033 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5239",
    "data-name": "Path 5239",
    d: "M-.011-.013l-.012.007Z",
    transform: "translate(0.023 0.013)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4339",
    "data-name": "Group 4339",
    transform: "translate(0 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5240",
    "data-name": "Path 5240",
    d: "M-.918,1.123l0-.02c.04-.01.017.02.053.006.007-.031.062-.012.071-.03,0,0,.019,0,.02.008,0-.016.018-.008.028-.015s0,0-.009-.007l.024-.013c.012,0,.016.011.006.016A4.011,4.011,0,0,0-.258.947C-.271.939-.291.953-.305.938-.289.923-.276.933-.271.92-.255.944-.227.913-.2.935V.919l.012.006C-.111.883-.174.912-.1.891-.056.875-.043.847-.016.847c0,0-.016-.005-.007-.012C-.016.847,0,.816.014.827.024.821.06.812.042.8.051.8.083.8.067.812A.063.063,0,0,0,.1.8H.08C.115.786.139.793.157.769l-.016,0C.162.758.179.75.193.765L.173.777A.27.27,0,0,0,.255.737l-.01,0C.276.709.464.623.489.587L.469.58.493.557S.5.606.491.6C.554.578.872.436.931.416c.026,0,.014.021.014.021C.971.42.951.418.975.409c.008,0,0,.011,0,.014S1,.417.995.411.978.394.968.385L1,.373,1,.384c.007,0,0-.035.036-.043.052-.019.1-.048.156-.069,0,.007-.007.016-.016.024A.049.049,0,0,1,1.2.288C1.186.282,1.221.27,1.209.27c.025-.042.082-.043.107-.075C1.308.171,1.2-.218,1.181-.243A.058.058,0,0,1,1.2-.251c-.006-.006-.026,0-.034.01l.006.015c-.02.016-.01-.006-.032.007-.007-.011.013-.024.03-.034-.017.007-.037.007-.038.022-.018,0-.005-.015-.026-.011s-.023.029-.041.03v0c-.042.006-.048.046-.087.05l0-.006c-.016,0-.035.019-.06.022.007,0,.017.006,0,.013-.028,0-.041.02-.064.019L.852-.1C.765-.059.426.106.336.141l0,0L-.216.361A.239.239,0,0,0-.3.374c.015,0,.013.011,0,.013C-.365.408-.3.4-.366.425a2.741,2.741,0,0,1-.48.125C-.881.578-.935.576-.971.6l0-.005c-.04.018-.284.057-.333.073h.008c-.041.02-.039,0-.075,0,.009.019-.026.038-.04.042v0a.923.923,0,0,1-.1.044V.738a.385.385,0,0,1-.1.028A.661.661,0,0,0-1.8.788L-1.852.763l-.006,0s-.011.393.091.46v.012l.018,0c.022,0,.03-.013.03,0l-.03,0c.022,0,.008.008,0,.016a.072.072,0,0,1,.026,0c0-.005,0,0-.008-.006s.025-.019.04-.016,0,.018.03.015a3.45,3.45,0,0,0,.405-.056s0,0,0,.007c.04-.013.077-.018.113-.032a.042.042,0,0,1,.02.013,1.615,1.615,0,0,1,.206-.055",
    transform: "translate(1.858 0.254)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4341",
    "data-name": "Group 4341",
    transform: "translate(161.869 64.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5241",
    "data-name": "Path 5241",
    d: "M0-.053c.007.014.023.02.038.027A.053.053,0,0,0,0-.053",
    transform: "translate(0 0.053)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4342",
    "data-name": "Group 4342",
    transform: "translate(161.908 64.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5242",
    "data-name": "Path 5242",
    d: "M0,0H0Z",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4343",
    "data-name": "Group 4343",
    transform: "translate(165.147 65.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5243",
    "data-name": "Path 5243",
    d: "M-.013,0-.026,0A.038.038,0,0,0-.013,0",
    transform: "translate(0.026)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4344",
    "data-name": "Group 4344",
    transform: "translate(161.888 64.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5244",
    "data-name": "Path 5244",
    d: "M-.768-.3-.76-.322c.038.01,0,.026.041.03.022-.023.058.02.074.008,0,0,.016.008.013.016.009-.014.019,0,.03,0s0-.005,0-.011l.027,0c.009.007.008.017,0,.016.064.023.371.125.443.137C-.145-.137-.169-.135-.172-.156c.021-.005.026.011.037,0,0,.028.039.018.046.049L-.08-.118l.007.012c.085.007.021,0,.092.022.042.009.067-.006.088.008,0,0-.01-.013,0-.013s.031,0,.033.013.045.013.038-.009c0,.011.033.023.012.025.011,0,.02.009.028.007L.21-.062c.035.007.051.026.078.017L.276-.056c.021.005.039.009.042.028H.3a.274.274,0,0,0,.087.013l-.01,0C.414-.026.611.013.651,0L.639-.019l.032,0S.644.019.643.014c.063.016.39.1.444.121.021.014,0,.023,0,.025.03,0,.016-.011.04,0,.006,0,0,.011-.009.012s.019.009.022,0c-.012-.009,0-.024,0-.037l.03.011,0,.01c.007,0,.026-.025.055-.01.05.019.107.03.157.048C1.37.2,1.357.2,1.346.2c.007,0,.018,0,.023.011-.009-.016.023,0,.016-.01.045-.016.087.022.125.013C1.519.191,1.695-.173,1.7-.2a.057.057,0,0,1,.023.01c0-.008-.02-.017-.032-.016l-.006.015c-.026,0,0-.011-.027-.017,0-.013.025-.009.045,0-.018-.007-.032-.02-.043-.009-.015-.01.006-.014-.013-.025S1.611-.242,1.6-.253v0c-.036-.024-.066,0-.1-.021l.005,0c-.011-.011-.039-.009-.06-.023.006,0,.01.015-.005.013S1.394-.3,1.377-.317l-.022.007C1.263-.339.891-.424.8-.448h0C.657-.483.365-.566.214-.59A.24.24,0,0,0,.14-.625c.012.009.005.016-.006.013C.063-.633.127-.606.053-.621A3.629,3.629,0,0,1-.425-.767C-.47-.76-.516-.788-.559-.788l.006,0C-.6-.8-.832-.88-.884-.887l.006,0c-.046,0-.034-.019-.067-.034C-.945-.9-.985-.895-1-.9l0,0c-.022,0-.075,0-.11-.006l0-.011A.383.383,0,0,1-1.21-.939.639.639,0,0,0-1.392-1l-.033-.042h-.007s-.171.353-.109.456l0,.011.017,0c.018.011.031,0,.027.011l-.027-.009c.019.009,0,.01-.006.014a.081.081,0,0,1,.022.012c.005,0,0-.005,0-.008s.03-.007.041,0,0,.018.02.025c.124.043.243.091.372.124,0,.005,0,0-.006,0,.039.007.074.018.11.023a.034.034,0,0,1,.011.02,1.167,1.167,0,0,1,.2.048",
    transform: "translate(1.554 1.042)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4345",
    "data-name": "Group 4345",
    transform: "translate(162.298 63.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5245",
    "data-name": "Path 5245",
    d: "M0-.033c.006.013.017.015.028.017A.032.032,0,0,0,0-.033",
    transform: "translate(0 0.033)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4346",
    "data-name": "Group 4346",
    transform: "translate(162.326 63.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5246",
    "data-name": "Path 5246",
    d: "M0,0H0Z",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4347",
    "data-name": "Group 4347",
    transform: "translate(164.462 62.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5247",
    "data-name": "Path 5247",
    d: "M-.009,0H-.018A.018.018,0,0,0-.009,0",
    transform: "translate(0.018 0.002)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4348",
    "data-name": "Group 4348",
    transform: "translate(162.299 62.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5248",
    "data-name": "Path 5248",
    d: "M-.54.494l0-.02c.026,0,.006.024.03.02C-.5.465-.467.5-.458.484c0,0,.012,0,.01.013,0-.015.012,0,.02-.007s0-.005,0-.01l.017,0c.007.006.008.015,0,.016a2.275,2.275,0,0,0,.3.032C-.117.512-.132.519-.136.5c.013-.01.018,0,.025-.006,0,.028.027.009.034.036L-.072.516l.006.01C-.01.513-.053.519,0,.525.024.525.039.5.054.513c0,0-.008-.01,0-.013C.054.513.074.49.077.5.083.5.106.506.1.487.1.5.124.5.111.509c.007,0,.014,0,.019,0L.122.5C.145.5.158.518.174.5L.166.494C.18.494.191.493.2.512L.181.517A.115.115,0,0,0,.239.508H.232C.258.491.39.483.414.462L.4.447.425.436S.412.482.411.477a2.824,2.824,0,0,1,.3.016C.728.5.714.516.714.518.733.514.723.5.739.505s0,.012,0,.014.014,0,.015,0S.746.493.743.482l.021,0L.762.5C.767.5.776.465.8.473S.868.478.9.483C.9.489.895.493.887.5S.9.5.9.5C.9.488.919.494.912.488.94.462.971.49.995.473c0-.024.075-.42.076-.449.007,0,.014,0,.016,0S1.072.017,1.065.021l0,.016c-.017,0,0-.01-.02-.01,0-.013.015-.015.029-.015-.012,0-.023-.013-.029,0-.011-.006,0-.015-.011-.022S1.007.006,1,0V0C.971-.02.954.012.931,0l0,0C.925-.014.907-.005.892-.014.9-.011.9,0,.89,0S.86,0,.847-.014L.834,0C.77-.008.52-.006.456-.008l0,0c-.1,0-.3-.013-.4,0C.048-.024.026-.023.01-.027c.008.006.005.014,0,.013-.049,0,0,.009-.054.011A1.645,1.645,0,0,1-.372-.036c-.028.017-.062,0-.089.011l0,0c-.029.005-.191-.022-.224-.017l0,0C-.708-.035-.7-.054-.725-.062c0,.02-.024.031-.034.032v0a.5.5,0,0,1-.072.02l0-.011a.169.169,0,0,1-.072,0A.273.273,0,0,0-1.025-.04l-.026-.033,0,0A1.316,1.316,0,0,0-1.072.4l0,.011h.012c.013.006.02-.007.018,0l-.018,0c.013,0,0,.01,0,.015a.042.042,0,0,1,.015.007s0,0,0-.007.018-.014.027-.008,0,.018.016.02A1.962,1.962,0,0,0-.754.473c0,.005,0,0,0,.007.027,0,.05,0,.074,0A.031.031,0,0,1-.674.493a.48.48,0,0,1,.134,0",
    transform: "translate(1.092 0.073)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4349",
    "data-name": "Group 4349",
    transform: "translate(162.131 60.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5249",
    "data-name": "Path 5249",
    d: "M0-.013a.033.033,0,0,0,.032.006A.029.029,0,0,0,0-.013",
    transform: "translate(0 0.015)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4350",
    "data-name": "Group 4350",
    transform: "translate(163.978 59.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5250",
    "data-name": "Path 5250",
    d: "M-.008-.006-.017,0a.018.018,0,0,0,.009,0",
    transform: "translate(0.017 0.006)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4351",
    "data-name": "Group 4351",
    transform: "translate(161.994 59.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5251",
    "data-name": "Path 5251",
    d: "M-.66.781l0-.02C-.64.754-.65.781-.629.77c0-.03.038-.009.041-.026,0,0,.011,0,.013.008,0-.016.01-.007.016-.013s0,0-.007-.008L-.55.721c.007,0,.012.011.006.015A2.164,2.164,0,0,0-.255.659c-.009-.01-.021,0-.031-.014.009-.014.018,0,.02-.014.013.025.028,0,.046.022l0-.016.009.007C-.166.613-.2.633-.157.623-.131.612-.125.587-.107.59c0,0-.011-.007-.006-.013C-.107.59-.1.562-.09.575c.006,0,.029-.009.016-.024.007.008.027.005.018.016.007,0,.014,0,.018-.006l-.01,0c.022-.01.038,0,.048-.02l-.011,0C0,.528.012.523.023.539L.01.549A.112.112,0,0,0,.062.521l-.007,0C.072.5.191.445.206.416L.191.406.206.389s.005.047,0,.043A2.782,2.782,0,0,1,.491.34C.509.343.5.361.5.363.518.352.5.347.52.342s0,.011,0,.014S.535.355.533.349.522.328.515.319L.535.314l0,.011s0-.033.023-.033.069-.02.1-.028c0,.006,0,.012-.01.018s.011,0,.016,0C.658.271.68.268.673.266.689.232.727.246.743.222.738.2.663-.2.654-.225c.007,0,.013,0,.016,0s-.018-.006-.024,0l0,.015C.636-.2.644-.218.628-.212c0-.012.009-.019.021-.025-.012,0-.026,0-.026.012-.012,0,0-.016-.018-.017S.589-.219.576-.223v0C.546-.23.542-.194.515-.2l0,0C.506-.209.493-.194.476-.2c.005,0,.012.009,0,.014s-.029.009-.044,0L.426-.165c-.06.016-.29.107-.349.127l0,0C-.01-.006-.2.052-.286.1-.3.09-.324.1-.34.1c.01,0,.01.012,0,.014-.047.013,0,.009-.046.028A1.519,1.519,0,0,1-.694.227C-.714.252-.75.249-.772.268v0C-.8.279-.954.31-.984.326l.005,0c-.024.019-.026,0-.05,0,.009.018-.011.037-.02.041v0a.486.486,0,0,1-.059.044l0-.011c-.015.017-.051.023-.064.029A.254.254,0,0,0-1.3.454L-1.332.432l0,0s.073.382.151.443l0,.011.01-.005c.015,0,.016-.013.019,0l-.018,0c.014,0,.007.008,0,.015A.036.036,0,0,1-1.15.9c0-.005,0,0-.006-.006s.012-.019.022-.017.007.017.022.014A1.956,1.956,0,0,0-.864.838s0,0,0,.007C-.842.832-.819.827-.8.815A.034.034,0,0,1-.784.828.474.474,0,0,1-.66.781",
    transform: "translate(1.335 0.241)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4352",
    "data-name": "Group 4352",
    transform: "translate(162.447 57.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5252",
    "data-name": "Path 5252",
    d: "M0,0A.039.039,0,0,0,.035-.006.033.033,0,0,0,0,0",
    transform: "translate(0 0.008)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4353",
    "data-name": "Group 4353",
    transform: "translate(162.482 57.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5253",
    "data-name": "Path 5253",
    d: "M0,0H0Z",
    transform: "translate(0.001)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4354",
    "data-name": "Group 4354",
    transform: "translate(164.534 56.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5254",
    "data-name": "Path 5254",
    d: "M-.01,0-.021,0A.029.029,0,0,0-.01,0",
    transform: "translate(0.021 0.005)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4355",
    "data-name": "Group 4355",
    transform: "translate(162.179 56.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5255",
    "data-name": "Path 5255",
    d: "M-.792.569-.8.55c.025-.013.018.017.039,0,0-.03.039-.017.04-.034,0,0,.012,0,.016.005,0-.016.01-.009.015-.016S-.693.5-.7.5L-.683.486C-.675.488-.669.5-.675.5-.63.483-.416.4-.37.378c-.011-.009-.022,0-.035-.01.009-.015.02,0,.022-.017.015.024.03,0,.05.017l0-.016.01.007c.05-.037.009-.013.06-.028C-.237.318-.231.293-.213.294c0,0-.012-.006-.006-.012C-.213.294-.2.265-.193.277c.007,0,.031-.012.017-.026.007.007.029,0,.02.015.007,0,.015,0,.019-.007l-.011,0C-.125.247-.107.256-.1.235l-.011,0c.014-.006.026-.011.037,0l-.014.01A.129.129,0,0,0-.028.215l-.007,0C-.015.191.117.135.136.107L.121.1.139.079s0,.048,0,.044A1.937,1.937,0,0,1,.459.044c.019,0,.008.024.008.024C.487.058.473.051.491.049s0,.011,0,.014S.5.063.5.056.494.034.488.024l.023,0V.032C.518.032.52,0,.543,0S.622-.011.661-.014C.661-.008.654,0,.647,0S.659,0,.665,0C.653-.007.679-.008.671-.011.7-.043.736-.022.757-.044c0-.025,0-.427,0-.457.008,0,.017,0,.02,0S.756-.508.747-.5v.016C.728-.478.742-.5.722-.492c0-.013.015-.018.031-.021C.738-.512.723-.519.718-.5.7-.508.718-.52.7-.524S.676-.5.662-.51v0C.627-.52.614-.487.583-.495l0,0C.574-.5.555-.492.534-.5c.006,0,.012.01,0,.013S.5-.476.481-.484L.468-.469a4.132,4.132,0,0,0-.441.117l0,0a2.966,2.966,0,0,0-.447.166.173.173,0,0,0-.065.01c.012,0,.012.011,0,.014-.055.02,0,.009-.054.036A3.826,3.826,0,0,1-.9.019C-.919.049-.962.055-.985.08V.075c-.028.02-.208.1-.239.125h.006c-.025.027-.03.008-.057.017.013.016-.007.041-.015.048l0,0c-.013.012-.037.046-.059.064l-.006-.01a.245.245,0,0,1-.067.053.346.346,0,0,0-.13.076L-1.6.436l0,.006s.18.344.279.376l.006.01.009-.008c.016,0,.014-.018.02-.009l-.018.01c.015-.006.009.005.008.013a.053.053,0,0,1,.017,0c0-.006,0,0-.007,0S-1.281.8-1.269.8s.011.015.026.006C-1.161.763-1.078.725-1,.676c0,0,0,0,0,.008L-.933.636A.044.044,0,0,1-.915.645.542.542,0,0,1-.792.569",
    transform: "translate(1.602 0.524)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4356",
    "data-name": "Group 4356",
    transform: "translate(160.889 53.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5256",
    "data-name": "Path 5256",
    d: "M0-.04c.008.013.023.016.037.02A.045.045,0,0,0,0-.04",
    transform: "translate(0 0.04)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4357",
    "data-name": "Group 4357",
    transform: "translate(163.602 53.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5257",
    "data-name": "Path 5257",
    d: "M-.01-.007-.021,0a.026.026,0,0,0,.011,0",
    transform: "translate(0.021 0.007)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4358",
    "data-name": "Group 4358",
    transform: "translate(160.895 53.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5258",
    "data-name": "Path 5258",
    d: "M-.728.833l0-.02c.035,0,.01.023.042.019C-.67.8-.629.835-.617.82c0,0,.015,0,.014.012C-.6.817-.586.829-.576.825s0,0-.006-.009L-.558.81c.009.005.011.014,0,.016a2.711,2.711,0,0,0,.415,0C-.15.813-.17.822-.179.8-.163.793-.153.807-.147.8c.009.027.038,0,.053.03l0-.016.009.009C-.006.8-.064.811,0,.809.041.8.058.78.08.785c0,0-.013-.008,0-.013C.08.785.1.76.108.773c.01,0,.041,0,.029-.021C.144.761.172.761.156.771c.01,0,.019,0,.025,0l-.013,0C.2.757.22.769.239.75L.226.744C.245.74.261.737.271.755L.252.763A.2.2,0,0,0,.328.742H.318C.35.72.523.68.549.651L.533.639.557.623S.552.671.548.667C.605.656.9.59.949.585c.022,0,.009.024.009.024C.982.6.965.591.988.587.994.588.989.6.986.6S1,.6,1,.593.992.573.984.562L1.012.557l0,.012c.007,0,.009-.033.037-.034C1.1.528,1.145.511,1.192.5c0,.007-.008.013-.016.019s.015-.005.022,0C1.184.51,1.215.506,1.205.5c.026-.035.076-.024.1-.05C1.3.428,1.248.029,1.239,0a.062.062,0,0,1,.02,0c0-.006-.022,0-.03,0l0,.016c-.019.011-.008-.008-.027,0C1.2,0,1.218,0,1.234-.01c-.015,0-.032,0-.034.013-.015,0,0-.015-.021-.016s-.022.024-.038.02V0C1.1,0,1.1.039,1.063.034l0-.005c-.013,0-.031.011-.052.008.006,0,.014.009,0,.013s-.037.01-.055,0L.947.07C.87.088.568.171.488.183l0,0L0,.267A.177.177,0,0,0-.067.26c.011,0,.008.014,0,.014-.062,0,0,.009-.066.018A1.889,1.889,0,0,1-.547.3C-.581.315-.624.3-.658.311l0,0C-.691.315-.9.29-.938.294l.006,0C-.97.306-.964.286-.992.278c0,.021-.03.03-.042.031v0a.61.61,0,0,1-.091.017l0-.011a.287.287,0,0,1-.091,0A.471.471,0,0,0-1.371.283L-1.4.247l-.006,0s-.11.375-.044.466l0,.011h.016c.018.008.027,0,.025.007l-.025,0c.018.006,0,.01,0,.015a.069.069,0,0,1,.021.009s0-.005-.005-.008.026-.011.037,0,0,.018.021.022a2.292,2.292,0,0,0,.347.051c0,.005,0,0,0,.007.036,0,.068,0,.1,0A.032.032,0,0,1-.912.834a1.107,1.107,0,0,1,.184,0",
    transform: "translate(1.473 0.013)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4359",
    "data-name": "Group 4359",
    transform: "translate(162.481 50.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5259",
    "data-name": "Path 5259",
    d: "M0-.015A.045.045,0,0,0,.035,0,.034.034,0,0,0,0-.015",
    transform: "translate(0 0.017)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4360",
    "data-name": "Group 4360",
    transform: "translate(164.779 50.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5260",
    "data-name": "Path 5260",
    d: "M-.01,0-.02,0l.01,0",
    transform: "translate(0.02 0.005)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4361",
    "data-name": "Group 4361",
    transform: "translate(162.414 50.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5261",
    "data-name": "Path 5261",
    d: "M-.681.74V.72c.029,0,.012.022.038.012C-.638.7-.6.728-.592.712c0,0,.013,0,.014.01,0-.016.013-.006.021-.011s0,0-.006-.008L-.546.694c.008,0,.011.013,0,.015A2.744,2.744,0,0,0-.2.668C-.21.658-.225.668-.234.651c.012-.012.021,0,.026-.011.01.026.032,0,.047.027l0-.016.009.009C-.092.633-.139.649-.083.644-.052.636-.04.613-.021.618c0,0-.012-.008,0-.014,0,.014.02-.013.026,0C.009.6.036.6.024.582.03.59.054.59.041.6.049.6.057.6.063.6l-.011,0C.077.586.094.6.109.579L.1.573c.015,0,.029-.007.037.01L.12.591A.151.151,0,0,0,.182.57H.174C.2.547.343.51.365.483L.351.471.371.455S.367.5.364.5C.412.489.657.439.7.442.72.447.708.464.708.466.729.457.715.45.734.448s0,.011,0,.014S.748.463.748.456.739.434.732.423l.024,0V.433C.762.432.765.4.789.4.829.4.87.39.91.387.91.393.9.4.895.4S.908.4.913.4C.9.394.929.394.921.39.945.358.986.377,1.009.355,1.007.33,1-.072.992-.1a.034.034,0,0,1,.018,0c0-.007-.019-.008-.027,0v.016C.967-.078.979-.1.961-.092c0-.012.013-.018.028-.021C.975-.112.96-.119.956-.1c-.013,0,0-.016-.017-.019S.917-.1.9-.109v0C.871-.119.86-.084.83-.093l0,0C.822-.1.8-.091.785-.1c.006,0,.012.01,0,.013s-.034.006-.051,0L.723-.069C.653-.061.377,0,.306.015l0,0C.2.035-.021.07-.13.105A.138.138,0,0,0-.191.1c.011,0,.008.013,0,.014-.055.007,0,.009-.057.023A2.069,2.069,0,0,1-.615.184C-.642.207-.683.2-.711.216l0-.005C-.739.223-.923.235-.96.247l.006,0c-.031.017-.03,0-.056-.006.007.02-.019.035-.03.039v0a.552.552,0,0,1-.075.036V.3a.208.208,0,0,1-.078.021.345.345,0,0,0-.142.013L-1.373.309l0,0s.01.389.087.46V.785l.012,0c.016,0,.021-.011.022,0l-.021,0c.016,0,.007.009,0,.016a.036.036,0,0,1,.018,0c0-.005,0,0-.005-.007s.017-.017.028-.014,0,.018.022.016A2.31,2.31,0,0,0-.922.771s0,0,0,.007C-.9.769-.869.766-.843.757A.038.038,0,0,1-.829.771.656.656,0,0,1-.681.74",
    transform: "translate(1.377 0.123)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4362",
    "data-name": "Group 4362",
    transform: "translate(162.062 48.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5262",
    "data-name": "Path 5262",
    d: "M0,0a.034.034,0,0,0,.032,0A.028.028,0,0,0,0,0",
    transform: "translate(0 0.009)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4363",
    "data-name": "Group 4363",
    transform: "translate(163.531 46.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5263",
    "data-name": "Path 5263",
    d: "M-.007-.011l-.007.006A.019.019,0,0,0-.007-.011",
    transform: "translate(0.014 0.011)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4364",
    "data-name": "Group 4364",
    transform: "translate(161.809 46.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5264",
    "data-name": "Path 5264",
    d: "M-.723.83-.733.812C-.712.8-.714.828-.7.811-.7.782-.663.792-.664.776c0,0,.011,0,.015,0C-.654.765-.641.771-.637.763s0,0-.009-.006L-.634.744c.008,0,.015.008.009.013A2.238,2.238,0,0,0-.368.607C-.379.6-.387.614-.4.6-.4.587-.385.6-.386.583c.019.021.027-.009.05.009L-.342.577l.01,0C-.3.539-.326.568-.283.546-.261.529-.262.5-.245.5c0,0-.012,0-.008-.011C-.245.5-.242.472-.232.482-.227.477-.207.466-.223.455-.215.46-.2.453-.2.466c.006,0,.013,0,.015-.011H-.2c.018-.015.036-.01.04-.032l-.011,0c.011-.009.02-.016.034,0L-.142.431A.1.1,0,0,0-.1.391l-.006,0C-.1.366,0,.284.009.252L-.007.246,0,.225S.019.269.015.266A2.655,2.655,0,0,1,.262.1C.279.1.277.122.278.124.291.109.277.107.291.1S.3.109.3.112.308.108.305.1.288.085.279.077L.3.068.3.077S.3.045.316.039.376,0,.406-.014c0,.006,0,.013,0,.02S.411,0,.417,0C.4-.005.426-.014.417-.015.423-.052.464-.048.473-.076.461-.1.283-.458.268-.482A.035.035,0,0,1,.283-.488c-.005,0-.019,0-.023.007l.008.014C.257-.454.26-.473.247-.463.239-.474.25-.484.26-.492c-.011.005-.025,0-.022.018S.231-.488.217-.485.207-.46.193-.46v0c-.03,0-.024.038-.051.04V-.427C.13-.428.122-.411.1-.409.109-.41.118-.4.111-.4S.086-.381.069-.382l0,.017c-.054.031-.25.178-.3.214v0C-.311-.1-.475.007-.547.074-.567.072-.583.085-.6.091-.587.091-.586.1-.591.1c-.041.025,0,.009-.036.039A1.539,1.539,0,0,1-.9.305c-.013.03-.049.036-.064.06V.36c-.02.021-.163.093-.187.116h.005C-1.167.5-1.175.482-1.2.489c.013.016,0,.038-.008.045l0,0a.558.558,0,0,1-.045.058l-.006-.01C-1.267.6-1.3.614-1.311.622A.25.25,0,0,0-1.42.682L-1.46.669l0,0s.171.348.263.387l.005.01.009-.008c.014,0,.012-.017.018-.007l-.016.009c.013,0,.008.006.008.014a.036.036,0,0,1,.016,0c0-.005,0,0-.008,0s.007-.022.017-.022.011.015.025.007A1.914,1.914,0,0,0-.9.938s0,0,0,.007C-.884.927-.863.916-.847.9A.034.034,0,0,1-.829.908C-.838.9-.726.829-.723.83",
    transform: "translate(1.462 0.492)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4365",
    "data-name": "Group 4365",
    transform: "translate(162.065 45.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5265",
    "data-name": "Path 5265",
    d: "M0,0A.045.045,0,0,0,.037-.005.038.038,0,0,0,0,0",
    transform: "translate(0 0.008)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4366",
    "data-name": "Group 4366",
    transform: "translate(163.908 43.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5266",
    "data-name": "Path 5266",
    d: "M-.008-.013l-.009.007.009-.007",
    transform: "translate(0.017 0.013)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4367",
    "data-name": "Group 4367",
    transform: "translate(161.811 43.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5267",
    "data-name": "Path 5267",
    d: "M-.819.9-.828.878C-.8.861-.808.892-.787.873-.793.843-.745.849-.745.832c0,0,.013-.005.017,0C-.733.819-.719.823-.713.815s0,0-.009-.005L-.708.795C-.7.795-.692.8-.7.807A3.274,3.274,0,0,0-.388.622C-.4.616-.411.632-.427.62-.42.6-.406.611-.407.6c.02.02.031-.013.056,0L-.356.588l.011,0C-.3.542-.336.577-.285.548-.258.528-.256.5-.236.5c0,0-.014,0-.008-.011C-.236.5-.23.466-.219.475c.006-.006.03-.02.012-.03.01.006.032,0,.024.01.007,0,.015-.006.018-.013H-.176C-.154.426-.134.43-.127.405H-.14C-.126.395-.115.386-.1.4L-.111.412A.158.158,0,0,0-.06.365l-.007,0C-.052.338.07.24.08.206L.062.2.075.178S.091.223.086.221C.128.192.342.04.387.023.407.02.4.04.4.042.419.025.4.024.42.014s.006.01,0,.014S.439.022.436.016.419,0,.408-.007L.43-.02l.005.01c.005,0,0-.033.02-.041S.528-.1.564-.118c0,.006,0,.014-.007.022S.568-.1.575-.1c-.015,0,.01-.016,0-.016.011-.039.058-.04.07-.07C.634-.212.464-.577.448-.6A.047.047,0,0,1,.467-.609c-.006,0-.021,0-.027.01l.008.014C.434-.57.438-.59.423-.579.415-.589.428-.6.441-.611.428-.6.411-.6.414-.59.4-.587.406-.6.39-.6S.376-.571.361-.57v0C.326-.566.33-.529.3-.524V-.53C.285-.53.273-.51.253-.507c.006,0,.015,0,.007.012s-.031.02-.05.02L.2-.456C.14-.417-.1-.241-.162-.2v0c-.094.068-.292.2-.383.275A.15.15,0,0,0-.6.1C-.593.1-.591.1-.6.109c-.05.031,0,.01-.046.046a2.272,2.272,0,0,1-.334.2c-.018.033-.059.043-.079.07V.421c-.025.024-.2.115-.226.142h.006c-.023.028-.03.009-.057.018.015.016,0,.041-.013.049l0,0a.63.63,0,0,1-.057.066l-.006-.01c-.013.023-.053.043-.067.053a.372.372,0,0,0-.131.074L-1.653.8l0,.006s.165.353.266.385l.006.01.01-.009c.017,0,.016-.019.021-.009l-.019.011c.016-.006.01.006.008.014A.046.046,0,0,1-1.346,1.2c0-.005,0,0-.008,0s.01-.024.022-.025.011.015.028.006a3.006,3.006,0,0,0,.267-.15s0,0,0,.007c.024-.021.048-.034.069-.054A.034.034,0,0,1-.949.989.736.736,0,0,1-.819.9",
    transform: "translate(1.656 0.611)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4368",
    "data-name": "Group 4368",
    transform: "translate(163.101 42.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5268",
    "data-name": "Path 5268",
    d: "M0-.007a.02.02,0,0,0,.022,0C.011-.012,0-.012,0-.007",
    transform: "translate(0 0.011)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4369",
    "data-name": "Group 4369",
    transform: "translate(163.122 42.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5269",
    "data-name": "Path 5269",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4370",
    "data-name": "Group 4370",
    transform: "translate(163.634 41.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5270",
    "data-name": "Path 5270",
    d: "M0-.007l0,0a0,0,0,0,0,0,0",
    transform: "translate(0.006 0.007)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4371",
    "data-name": "Group 4371",
    transform: "translate(162.791 41.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5271",
    "data-name": "Path 5271",
    d: "M-.559.682-.571.665c.01-.009.018.015.024,0C-.562.643-.528.657-.535.642c0,0,.007,0,.012.006-.008-.013,0-.007,0-.013s0,0-.008-.006l0-.01c.006,0,.013.008.011.012A.689.689,0,0,0-.38.533C-.39.526-.391.537-.405.526S-.4.522-.4.512c.02.019.016,0,.038.013L-.372.512l.009.005C-.35.485-.362.506-.34.492s0-.033.013-.033-.01,0-.01-.01c.01.01,0-.015.012-.006s.013-.011,0-.022c.008.006.019,0,.019.012S-.3.431-.3.427H-.308C-.3.415-.285.422-.29.4L-.3.4c0-.006.009-.011.023,0l0,.009A.04.04,0,0,0-.261.382l0,0c0-.023.042-.08.036-.106L-.241.271V.255s.027.039.023.036A.853.853,0,0,1-.1.182C-.084.183-.08.2-.079.2s-.007-.014,0-.019S-.071.19-.07.192s.008,0,0-.008S-.084.169-.093.162l.01-.007.007.009s-.015-.028,0-.03A.513.513,0,0,0-.032.1a.022.022,0,0,1,0,.017s0-.005.009,0C-.031.106-.019.1-.025.1-.032.07,0,.077,0,.055S-.261-.284-.28-.306c0,0,.006,0,.009,0a.007.007,0,0,0-.013,0l.01.013c0,.01-.008-.006-.014,0a.015.015,0,0,1,0-.022c-.006,0-.017,0-.01.013-.009,0-.01-.013-.019-.012s0,.02-.008.018l0,0c-.02,0,0,.029-.023.028l0,0c-.008,0-.009.011-.021.011,0,0,.012.007.009.011s-.013.011-.025.008l0,.014C-.413-.21-.5-.108-.529-.084v0A1.368,1.368,0,0,0-.677.07c-.015,0-.021.006-.03.009C-.7.08-.7.087-.7.09-.72.106-.7.1-.712.119A.484.484,0,0,1-.854.225c0,.023-.022.025-.026.043l0,0C-.889.279-.968.324-.977.34h0c0,.019-.016,0-.029.006A.035.035,0,0,1-.993.383l0,0A.19.19,0,0,1-1.01.423L-1.017.414c0,.016-.019.025-.024.031s-.05.011-.058.037L-1.131.468v0A2.4,2.4,0,0,0-.821.823l.007.009,0-.005c.009,0,0-.013.01,0L-.808.829C-.8.826-.8.834-.8.841a.018.018,0,0,1,.011,0s0,0-.007,0S-.8.819-.79.819s.012.014.02.009A.6.6,0,0,0-.653.752s0,0,0,.006c.008-.013.018-.02.025-.032A.041.041,0,0,1-.61.735C-.617.729-.562.681-.559.682",
    transform: "translate(1.131 0.315)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4372",
    "data-name": "Group 4372",
    transform: "translate(171.075 38.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5272",
    "data-name": "Path 5272",
    d: "M0,0A.041.041,0,0,0,.036-.005.036.036,0,0,0,0,0",
    transform: "translate(0 0.007)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4373",
    "data-name": "Group 4373",
    transform: "translate(172.781 36.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5273",
    "data-name": "Path 5273",
    d: "M-.008-.013l-.008.007.008-.007",
    transform: "translate(0.016 0.013)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4374",
    "data-name": "Group 4374",
    transform: "translate(170.811 36.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5274",
    "data-name": "Path 5274",
    d: "M-.8.886-.809.868c.024-.017.02.014.04-.006C-.777.833-.73.839-.731.821c0,0,.013-.005.017,0C-.72.809-.7.813-.7.806S-.7.8-.709.8L-.7.785c.009,0,.016.006.01.013A3.127,3.127,0,0,0-.393.612c-.013-.006-.022.01-.037,0C-.425.593-.411.6-.412.589c.02.019.029-.013.054,0L-.364.578l.012,0C-.309.533-.345.567-.3.538-.271.518-.271.491-.251.488c0,0-.014,0-.009-.011.009.011.013-.021.024-.012.006-.006.029-.02.011-.03.009.005.031-.005.024.01C-.2.441-.187.439-.185.433H-.2C-.175.416-.155.42-.15.4H-.162C-.15.385-.139.377-.123.388L-.135.4A.144.144,0,0,0-.087.356l-.007,0C-.08.328.033.231.042.2L.024.192.036.17S.054.214.049.212c.039-.028.24-.18.282-.2C.35.01.347.031.348.033.363.016.347.015.363.006s.006.01,0,.013S.382.012.379.007.361-.009.351-.016L.372-.029l.006.01S.371-.051.393-.06.463-.106.5-.127C.5-.121.5-.112.491-.1S.5-.113.508-.112c-.015,0,.01-.016,0-.016C.517-.168.562-.168.573-.2.561-.22.379-.579.363-.6A.042.042,0,0,1,.38-.61c-.006,0-.021,0-.025.01l.008.014C.349-.571.353-.592.338-.58.33-.59.343-.6.354-.612.343-.605.326-.605.329-.591.315-.588.322-.6.306-.6S.294-.572.279-.571v0C.245-.566.25-.53.219-.525V-.53C.207-.531.2-.511.177-.508c.006,0,.015,0,.007.012s-.029.02-.047.02L.132-.457C.071-.418-.154-.242-.212-.2v0c-.087.067-.275.2-.359.274A.147.147,0,0,0-.627.1c.011,0,.013.008.007.012-.047.031,0,.01-.042.046a2.058,2.058,0,0,1-.315.2c-.015.033-.055.043-.074.07V.419c-.023.024-.186.115-.213.142h.006C-1.28.589-1.288.57-1.313.58c.015.015,0,.041-.01.048l0,0a.594.594,0,0,1-.053.066l-.005-.01C-1.4.7-1.433.722-1.446.732a.33.33,0,0,0-.124.074L-1.614.8l0,.006s.175.347.277.378l.005.01.01-.009c.016,0,.014-.019.02-.009l-.018.011c.015-.006.009.005.008.014A.042.042,0,0,1-1.3,1.192c0-.005,0,0-.008,0s.009-.023.02-.025.011.014.027,0a2.591,2.591,0,0,0,.252-.15s0,0,0,.007C-.982,1-.959.991-.94.972A.036.036,0,0,1-.921.979.65.65,0,0,1-.8.886",
    transform: "translate(1.616 0.612)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4375",
    "data-name": "Group 4375",
    transform: "translate(170.708 36.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5275",
    "data-name": "Path 5275",
    d: "M0-.009a.017.017,0,0,0,.02,0C.01-.012,0-.013,0-.009",
    transform: "translate(0 0.011)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4376",
    "data-name": "Group 4376",
    transform: "translate(171.121 35.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5276",
    "data-name": "Path 5276",
    d: "M0-.006l0,0a0,0,0,0,0,0,0",
    transform: "translate(0.006 0.006)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4377",
    "data-name": "Group 4377",
    transform: "translate(170.403 35.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5277",
    "data-name": "Path 5277",
    d: "M-.523.658-.535.641c.009-.008.017.016.023.005C-.528.622-.5.637-.5.623c0,0,.006,0,.012.006C-.5.616-.49.623-.49.617s0,0-.007-.006l0-.009c.005,0,.012.008.01.012A.514.514,0,0,0-.369.535c-.01-.008-.01,0-.023-.01s.009,0,0-.013c.019.02.014,0,.035.016L-.362.515l.009.006C-.345.492-.355.51-.335.5s0-.031.011-.029S-.334.465-.334.46c.01.01,0-.013.011,0s.011-.01,0-.021c.007.006.017,0,.018.013S-.3.446-.3.442L-.31.44C-.3.431-.289.438-.295.421L-.3.418c0-.005.007-.01.021,0l0,.009A.033.033,0,0,0-.27.4l0,0c0-.022.033-.071.027-.1L-.259.3V.287s.026.038.022.035a.635.635,0,0,1,.1-.091c.011,0,.016.017.017.019s-.007-.014,0-.018.007.009.007.011.007,0,0-.007S-.122.22-.131.212L-.122.207l.007.009S-.131.189-.12.187A.342.342,0,0,0-.079.159a.023.023,0,0,1,0,.016s0,0,.008,0,0-.011-.005-.013C-.081.131-.053.141-.057.12S-.311-.22-.33-.242c0,0,.006,0,.008,0s-.012,0-.012,0l.01.012c0,.009-.008-.006-.013,0a.015.015,0,0,1,0-.021c-.005,0-.015,0-.008.011-.008,0-.01-.013-.018-.013s0,.019-.006.016l0,0c-.018,0,0,.027-.019.024l0,0c-.008,0-.008.01-.018.008S-.4-.2-.4-.2s-.011.009-.022.005l0,.014c-.024.017-.1.1-.121.124v0A1.015,1.015,0,0,0-.668.075C-.681.07-.687.078-.7.08s.012.009.009.011C-.705.1-.682.1-.7.117A.345.345,0,0,1-.82.2c0,.022-.019.022-.021.038l0,0C-.849.252-.916.287-.925.3h0c0,.017-.014,0-.027,0A.036.036,0,0,1-.937.34l0,0c0,.007,0,.03-.01.039L-.956.367c0,.015-.016.022-.02.027s-.045.006-.051.03L-1.057.407v0a2.823,2.823,0,0,0,.3.356l.007.009,0,0c.009,0,0-.012.009,0l-.008,0c.007,0,.008.006.01.012a.012.012,0,0,1,.009,0s0,0-.006,0,0-.016,0-.015.012.014.019.01A.454.454,0,0,0-.6.715s0,0,0,.006S-.584.7-.579.694A.039.039,0,0,1-.565.7C-.573.7-.525.657-.523.658",
    transform: "translate(1.057 0.253)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4381",
    "data-name": "Group 4381",
    transform: "translate(162.488 37.841)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4378",
    "data-name": "Group 4378",
    transform: "translate(0 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5278",
    "data-name": "Path 5278",
    d: "M0-.053a.025.025,0,0,0,0,.027C0-.038,0-.046,0-.053",
    transform: "translate(0.009 0.053)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(1.414 0.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5279",
    "data-name": "Path 5279",
    d: "M-.005,0-.011,0Z",
    transform: "translate(0.011)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4380",
    "data-name": "Group 4380",
    transform: "translate(0.004 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5280",
    "data-name": "Path 5280",
    d: "M-.2-.768l.017-.012c.013.015-.015.019,0,.03.027-.013.017.025.033.021a.012.012,0,0,1,0,.014c.014-.008.008.005.015.007s0,0,.005-.008l.013.006C-.121-.7-.127-.7-.132-.7a1,1,0,0,0,.145.183C.019-.527,0-.53.016-.546c.014,0,.007.013.018.009-.017.021.01.02-.006.044L.041-.5l0,.01c.041.019.012,0,.036.031.017.014.039.006.042.02s0-.012.009-.011c-.009.011.018,0,.01.015s.016.016.025,0c0,.009,0,.022-.008.022,0,0,.006.01.011.009l0-.008c.015.01.012.027.032.023V-.4C.2-.395.21-.389.2-.373l-.012,0a.069.069,0,0,0,.039.021l0,0c.027,0,.11.054.138.047l0-.016H.385S.349-.3.351-.3c.025.02.159.117.178.141S.516-.14.516-.14s.014-.008.023,0S.532-.131.529-.13s.006.009.011,0S.551-.147.555-.158l.012.011L.56-.139S.585-.158.594-.144s.044.032.064.05c0,.006-.011.006-.018.006s.008,0,.008.01c0-.013.013,0,.012-.007C.691-.1.7-.063.722-.069L1-.427s.008.006.007.009A.01.01,0,0,0,1-.432L.99-.419c-.013,0,0-.009-.007-.014.007-.011.016-.008.024,0S1-.455.991-.445c0-.008.009-.013,0-.022S.974-.462.972-.472l0,0C.967-.495.94-.473.935-.493l0,0C.938-.505.924-.5.92-.516c0,0,0,.013-.009.011S.9-.517.894-.53L.88-.525l-.2-.139h0C.627-.7.531-.789.474-.824c0-.016-.01-.024-.015-.034,0,.008-.008.013-.011.009C.427-.873.441-.844.414-.864a.6.6,0,0,1-.135-.169c-.026,0-.029-.028-.049-.035h0c-.018-.01-.07-.106-.087-.119v0C.126-1.194.144-1.2.14-1.22a.032.032,0,0,1-.039,0l0,0C.1-1.225.068-1.232.057-1.244L.066-1.25c-.017,0-.027-.027-.033-.034S.023-1.343,0-1.36l.017-.033h0a1.738,1.738,0,0,0-.392.256l-.01.006.006.006c0,.012.014.009,0,.014L-.39-1.124c0,.011-.006.008-.013.008A.029.029,0,0,1-.4-1.1s0,0,0-.006.02,0,.019.012-.015.01-.009.021A.892.892,0,0,0-.293-.9s0,0-.006,0c.016.014.025.029.039.041a.035.035,0,0,1-.009.016c.006-.008.069.077.069.077",
    transform: "translate(0.403 1.393)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4385",
    "data-name": "Group 4385",
    transform: "translate(163.696 36.798)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4382",
    "data-name": "Group 4382",
    transform: "translate(0 0.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5281",
    "data-name": "Path 5281",
    d: "M-.006-.058c-.009.01-.006.02,0,.029a.025.025,0,0,0,0-.029",
    transform: "translate(0.012 0.058)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4383",
    "data-name": "Group 4383",
    transform: "translate(1.493 1.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5282",
    "data-name": "Path 5282",
    d: "M-.005,0-.011,0Z",
    transform: "translate(0.011)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4384",
    "data-name": "Group 4384",
    transform: "translate(0.003 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5283",
    "data-name": "Path 5283",
    d: "M-.194-.965l.018-.01c.013.018-.015.018,0,.032.028-.01.018.03.034.027a.013.013,0,0,1,0,.015c.014-.007.009.007.016.01s0,0,.006-.009l.013.009c0,.008-.007.014-.012.01a1.136,1.136,0,0,0,.156.214C.038-.679.024-.683.034-.7c.015,0,.008.014.019.011-.018.021.012.022,0,.047L.064-.649l0,.011C.1-.614.072-.636.1-.6c.019.016.042.01.046.025,0,0,0-.012.009-.01-.009.01.019.005.011.017s.018.019.027,0c0,.009.006.025-.008.023,0,0,.007.011.012.011l0-.009c.017.012.015.03.036.027V-.527c.01.008.018.014.009.03L.227-.5A.088.088,0,0,0,.27-.476l0,0c.028,0,.121.065.152.059l0-.017.021,0s-.036.03-.035.026c.028.023.183.13.206.155C.619-.241.6-.234.6-.234c.017.005.015-.009.025,0s-.007.009-.01.009.008.01.012,0,.01-.021.013-.033l.014.012L.647-.232s.026-.019.036,0S.735-.2.759-.185c0,.006-.012.006-.019.006s.009,0,.01.011c0-.014.015,0,.013-.007.032-.012.044.023.07.017s.247-.346.259-.373c0,0,.009.006.009.009a.011.011,0,0,0-.011-.013L1.08-.523c-.013,0,0-.01-.009-.014.006-.012.017-.009.026-.005-.007-.006-.01-.018-.019-.008,0-.009.008-.013,0-.023s-.022.007-.024,0l0,0c-.01-.021-.036,0-.043-.019l0,0C1.017-.609,1-.608,1-.621c0,0,0,.013-.008.011S.971-.621.969-.635L.954-.629C.918-.655.764-.745.729-.776h0L.511-.953C.512-.969.5-.978.493-.989c0,.008-.007.013-.01.009C.46-1.008.475-.976.447-1a.651.651,0,0,1-.141-.19C.279-1.2.278-1.224.257-1.233h0c-.019-.013-.069-.12-.086-.138v0c-.021-.013,0-.02,0-.038a.032.032,0,0,1-.04,0l0,0C.125-1.416.1-1.428.087-1.442L.1-1.447C.079-1.453.071-1.48.065-1.489S.059-1.553.032-1.575l.02-.032h0A1.547,1.547,0,0,0-.372-1.4l-.01,0,.006.009c0,.013.014.012,0,.016l-.006-.015c0,.012-.007.007-.015.006a.029.029,0,0,1,0,.015c.005,0,0,0,.005-.006s.02.007.019.016-.016.009-.011.022a.953.953,0,0,0,.091.205s0,0-.007,0c.016.017.024.036.04.051a.036.036,0,0,1-.009.016c.006-.008.071.094.071.094",
    transform: "translate(0.393 1.608)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4393",
    "data-name": "Group 4393",
    transform: "translate(156.907 41.5)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4390",
    "data-name": "Group 4390",
    transform: "translate(0 0.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5287",
    "data-name": "Path 5287",
    d: "M0-.038a.024.024,0,0,0,.016.019C.013-.031.008-.038,0-.038",
    transform: "translate(0 0.038)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4391",
    "data-name": "Group 4391",
    transform: "translate(1.544 0.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5288",
    "data-name": "Path 5288",
    d: "M-.006,0h0",
    transform: "translate(0.013 0.001)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4397",
    "data-name": "Group 4397",
    transform: "translate(157.05 38.901)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4394",
    "data-name": "Group 4394",
    transform: "translate(0.132 1.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5290",
    "data-name": "Path 5290",
    d: "M0-.014a.029.029,0,0,0,.028.008A.025.025,0,0,0,0-.014",
    transform: "translate(0 0.016)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4395",
    "data-name": "Group 4395",
    transform: "translate(1.719 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5291",
    "data-name": "Path 5291",
    d: "M-.007-.006-.014,0l.007,0",
    transform: "translate(0.014 0.006)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4401",
    "data-name": "Group 4401",
    transform: "translate(156.548 47.243)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4398",
    "data-name": "Group 4398",
    transform: "translate(0.077 0.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5293",
    "data-name": "Path 5293",
    d: "M0-.016a.028.028,0,0,0,.027.011C.018-.016.01-.019,0-.016",
    transform: "translate(0 0.017)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4399",
    "data-name": "Group 4399",
    transform: "translate(1.723 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5294",
    "data-name": "Path 5294",
    d: "M-.007,0-.014,0l.007,0",
    transform: "translate(0.014 0.004)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4406",
    "data-name": "Group 4406",
    transform: "translate(157.4 48.937)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4402",
    "data-name": "Group 4402",
    transform: "translate(0.195 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5296",
    "data-name": "Path 5296",
    d: "M0-.014c.008.01.013.009.018.009S0-.018,0-.014",
    transform: "translate(0 0.016)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4403",
    "data-name": "Group 4403",
    transform: "translate(0.213 0.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5297",
    "data-name": "Path 5297",
    d: "M0,0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4404",
    "data-name": "Group 4404",
    transform: "translate(0.807 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5298",
    "data-name": "Path 5298",
    d: "M0,0l0,0L0,0",
    transform: "translate(0.007 0.005)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4410",
    "data-name": "Group 4410",
    transform: "translate(157.416 52.824)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4407",
    "data-name": "Group 4407",
    transform: "translate(0 0.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5300",
    "data-name": "Path 5300",
    d: "M0-.039a.021.021,0,0,0,.012.02c0-.012,0-.019-.012-.02",
    transform: "translate(0 0.039)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4408",
    "data-name": "Group 4408",
    transform: "translate(1.367 0.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5301",
    "data-name": "Path 5301",
    d: "M-.005,0h0",
    transform: "translate(0.011 0.001)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4414",
    "data-name": "Group 4414",
    transform: "translate(157.487 56.202)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4411",
    "data-name": "Group 4411",
    transform: "translate(0.178 1.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5303",
    "data-name": "Path 5303",
    d: "M0-.012a.023.023,0,0,0,.023.007C.014-.014.007-.017,0-.012",
    transform: "translate(0 0.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4412",
    "data-name": "Group 4412",
    transform: "translate(1.262 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5304",
    "data-name": "Path 5304",
    d: "M-.005-.006-.011,0a.009.009,0,0,0,.006,0",
    transform: "translate(0.011 0.006)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4418",
    "data-name": "Group 4418",
    transform: "translate(158.093 58.468)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4415",
    "data-name": "Group 4415",
    transform: "translate(0.035 0.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5306",
    "data-name": "Path 5306",
    d: "M0-.023A.022.022,0,0,0,.02-.01C.014-.021.008-.025,0-.023",
    transform: "translate(0 0.024)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4416",
    "data-name": "Group 4416",
    transform: "translate(0.962 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5307",
    "data-name": "Path 5307",
    d: "M0-.007l0,0Z",
    transform: "translate(0.006 0.007)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4423",
    "data-name": "Group 4423",
    transform: "translate(157.62 62.543)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4419",
    "data-name": "Group 4419",
    transform: "translate(0 0.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5309",
    "data-name": "Path 5309",
    d: "M0-.043a.024.024,0,0,0,.011.022c0-.013,0-.02-.011-.022",
    transform: "translate(0 0.043)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4420",
    "data-name": "Group 4420",
    transform: "translate(0.011 0.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5310",
    "data-name": "Path 5310",
    d: "M0,0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4421",
    "data-name": "Group 4421",
    transform: "translate(1.422 0.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5311",
    "data-name": "Path 5311",
    d: "M-.005,0-.011,0l.006,0",
    transform: "translate(0.011)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4422",
    "data-name": "Group 4422",
    transform: "translate(0.011 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5312",
    "data-name": "Path 5312",
    d: "M-.279.069-.27.051c.015.006,0,.023.011.024.017-.024.021.012.032,0s.005.006,0,.014c.008-.013.008,0,.014,0s0-.005,0-.01H-.2C-.2.083-.2.092-.2.091A.893.893,0,0,0-.037.178c0-.013-.01-.009-.006-.027s.009.008.017,0c-.009.026.013.013.008.04L-.01.177v.01C.027.186,0,.184.027.2S.059.187.066.2s0-.012,0-.013.016,0,.012.01S.1.2.1.183C.1.192.111.2.1.206s.007.006.011,0L.108.2c.015,0,.016.02.031.008L.138.2C.146.2.153.206.15.224l-.011,0a.049.049,0,0,0,.037,0l0,0C.194.216.274.234.3.219V.2L.312.2S.288.237.289.232A1.046,1.046,0,0,1,.462.3C.467.315.454.325.453.327S.464.315.473.321s0,.01-.007.012.006.006.009,0S.481.31.484.3L.495.305l0,.01S.509.29.518.3s.041.019.06.03A.022.022,0,0,1,.564.34s.008,0,.008.007c0-.013.011,0,.01-.01C.607.318.616.35.636.337s.2-.377.207-.4c0,0,.007,0,.007.007A.009.009,0,0,0,.84-.07L.833-.056c-.012,0,0-.01-.008-.013S.839-.08.847-.077s-.01-.016-.018,0c0-.007.008-.014,0-.022s-.019.01-.022,0v0C.8-.125.778-.1.769-.117l0,0c0-.009-.016,0-.022-.015s0,.013-.006.012S.727-.131.724-.143L.712-.134C.677-.152.528-.2.491-.211h0A1.885,1.885,0,0,0,.259-.289C.256-.3.242-.306.234-.313S.232-.3.228-.3C.2-.315.223-.294.193-.3A.632.632,0,0,1,.011-.393C-.011-.383-.025-.4-.045-.4l0,0c-.019,0-.1-.056-.126-.058l0,0c-.021,0-.011-.014-.022-.026A.033.033,0,0,1-.219-.46l0,0a.269.269,0,0,1-.05.005l.006-.01C-.278-.463-.3-.477-.306-.48S-.343-.522-.373-.519l0-.036,0,0a2.1,2.1,0,0,0-.179.432l0,.01h.007c.006.009.015,0,.01.009l-.01-.006c.007.006,0,.01-.007.014a.017.017,0,0,1,.006.009s0-.005,0-.007.016-.01.019,0-.006.017,0,.022A.773.773,0,0,0-.4.009c0,.005,0,0,0,.006.017,0,.029.009.045.01a.041.041,0,0,1,0,.018c0-.009.079.023.079.026",
    transform: "translate(0.564 0.555)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4428",
    "data-name": "Group 4428",
    transform: "translate(158.38 65.276)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4424",
    "data-name": "Group 4424",
    transform: "translate(0.074 0.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5313",
    "data-name": "Path 5313",
    d: "M0-.019a.021.021,0,0,0,.021.012C.014-.017.008-.021,0-.019",
    transform: "translate(0 0.019)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4425",
    "data-name": "Group 4425",
    transform: "translate(0.095 0.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5314",
    "data-name": "Path 5314",
    d: "M0,0H0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4426",
    "data-name": "Group 4426",
    transform: "translate(1.347 0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5315",
    "data-name": "Path 5315",
    d: "M-.005,0-.011,0l.006,0",
    transform: "translate(0.011 0.004)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4427",
    "data-name": "Group 4427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5316",
    "data-name": "Path 5316",
    d: "M-.428.7l0-.02c.016,0,.009.022.023.014,0-.029.026,0,.029-.017,0,0,.008,0,.009.011,0-.016.008-.005.012-.01s0,0,0-.009l.01-.007c.005,0,.008.013,0,.015a.993.993,0,0,0,.2-.02C-.159.646-.167.656-.174.638s.013,0,.014-.01c.008.027.019,0,.029.03V.643l.006.009C-.092.63-.118.642-.086.641-.069.635-.063.612-.052.619S-.059.61-.055.605c0,.014.012-.012.016,0,0,0,.019,0,.011-.021,0,.009.018.011.011.019s.01,0,.012,0L-.012.6C0,.594.014.606.021.588L.014.582C.023.579.03.577.037.594L.028.6A.053.053,0,0,0,.063.584h0C.071.563.152.535.163.509L.154.5.164.482s0,.047,0,.042A1.235,1.235,0,0,1,.357.49C.368.5.362.512.362.514S.365.5.376.5s0,.011,0,.013S.385.513.384.506.377.484.373.473H.386V.483S.39.452.4.456.451.449.473.448A.02.02,0,0,1,.467.464s.007,0,.011,0C.47.455.486.457.48.452.492.422.517.444.529.423S.49,0,.486-.029a.017.017,0,0,1,.011,0,.01.01,0,0,0-.016,0l0,.015c-.01.008,0-.009-.015-.006,0-.012.007-.017.015-.019-.008,0-.017-.008-.018.006-.009,0,0-.015-.012-.019s-.011.018-.02.012v0C.414-.055.41-.021.392-.031v0C.386-.042.377-.03.365-.036c0,0,.008.011,0,.013S.347-.02.337-.028L.331-.015c-.04,0-.2.049-.238.057l0,0A2.037,2.037,0,0,0-.153.1C-.165.094-.178.1-.189.1c.006,0,.006.013,0,.014-.032,0,0,.008-.032.019A.683.683,0,0,1-.43.153C-.444.174-.469.164-.483.179v0c-.018.01-.124.01-.145.02l0,0C-.64.21-.641.19-.656.187A.034.034,0,0,1-.671.224v0C-.68.224-.7.245-.712.25V.239C-.724.253-.749.252-.758.254S-.814.24-.84.259L-.862.23l0,0A1.994,1.994,0,0,0-.78.694V.705l.007,0c.01,0,.012-.01.013,0H-.771c.01,0,0,.009,0,.016a.017.017,0,0,1,.011,0s0,0,0-.007S-.754.7-.747.706s0,.018.014.017A.8.8,0,0,0-.566.715a.007.007,0,0,1,0,.007C-.55.714-.535.713-.521.706a.035.035,0,0,1,.01.015C-.516.712-.429.7-.428.7",
    transform: "translate(0.865 0.054)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4431",
    "data-name": "Group 4431",
    transform: "translate(158.728 68.855)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4429",
    "data-name": "Group 4429",
    transform: "translate(0.143 0.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5317",
    "data-name": "Path 5317",
    d: "M0-.015a.021.021,0,0,0,.021.01C.013-.015.006-.019,0-.015",
    transform: "translate(0 0.017)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4430",
    "data-name": "Group 4430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5318",
    "data-name": "Path 5318",
    d: "M-.465.574l0-.02c.015,0,.009.022.022.014,0-.029.024,0,.025-.018A.013.013,0,0,1-.413.561c0-.016.007-.006.01-.01s0,0,0-.009L-.4.535c.005,0,.007.013,0,.015A1.027,1.027,0,0,0-.215.535C-.22.524-.228.533-.233.516s.011,0,.013-.009c.006.027.017,0,.026.031V.522l.005.009c.03-.02.007-.009.035-.008S-.131.5-.12.5-.127.494-.123.49c0,.014.011-.011.014,0,0,0,.018,0,.012-.02,0,.009.016.012.009.021s.009,0,.012,0l-.006,0c.014,0,.023.01.03-.008L-.057.472c.008,0,.015,0,.02.015L-.046.493A.049.049,0,0,0-.012.479h0C0,.46.074.44.088.417L.081.4.093.391A.388.388,0,0,1,.087.433.736.736,0,0,1,.27.43c.01.008,0,.025,0,.025S.277.44.286.441s0,.012,0,.014.009,0,.009,0,0-.023,0-.035L.3.419V.43S.308.4.321.406A.582.582,0,0,0,.386.414.022.022,0,0,1,.376.427s.008,0,.01,0C.381.419.394.424.391.419.409.392.427.419.442.4s.066-.419.07-.448c0,0,.01,0,.011,0A.011.011,0,0,0,.508-.05l0,.016c-.012,0,0-.01-.013-.01S.5-.059.513-.059C.5-.061.5-.071.493-.058.485-.064.494-.073.486-.079S.469-.064.462-.072v0c-.018-.015-.03.017-.047,0l0,0C.411-.084.4-.074.388-.083s.005.013,0,.014-.021,0-.03-.012l-.01.013a2.181,2.181,0,0,0-.262.015l0,0a1.448,1.448,0,0,0-.273.04C-.2-.027-.214-.023-.225-.025c.007,0,.005.014,0,.014-.034,0,0,.009-.035.018A.951.951,0,0,1-.484.028C-.5.049-.525.04-.541.056V.051c-.019.01-.131.018-.153.03l0,0C-.706.1-.708.079-.725.077A.032.032,0,0,1-.738.115v0C-.747.116-.765.139-.779.146l0-.011C-.791.15-.817.153-.826.156S-.887.149-.911.172L-.939.148l0,0a2.126,2.126,0,0,0,.15.443l0,.011.006,0c.01,0,.01-.011.012,0L-.781.6c.009,0,.005.008,0,.015a.017.017,0,0,1,.011,0s0,0,0-.006S-.765.6-.758.6s.006.017.015.015A.944.944,0,0,0-.591.6s0,0,0,.007l.04-.018A.035.035,0,0,1-.541.6c0-.009.073-.028.075-.025",
    transform: "translate(0.941 0.083)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4435",
    "data-name": "Group 4435",
    transform: "translate(181.288 36.755)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4432",
    "data-name": "Group 4432",
    transform: "translate(0.153 1.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5319",
    "data-name": "Path 5319",
    d: "M0-.01a.039.039,0,0,0,.035,0A.033.033,0,0,0,0-.01",
    transform: "translate(0 0.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4433",
    "data-name": "Group 4433",
    transform: "translate(2.162 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5320",
    "data-name": "Path 5320",
    d: "M-.009-.008-.018,0l.009,0",
    transform: "translate(0.018 0.008)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4434",
    "data-name": "Group 4434",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5321",
    "data-name": "Path 5321",
    d: "M-.724.809-.729.789C-.7.78-.713.808-.691.795c0-.03.041-.012.045-.029,0,0,.013,0,.016.008,0-.016.011-.008.017-.014s0,0-.007-.008L-.6.741c.009,0,.014.01.007.015a2.668,2.668,0,0,0,.316-.1c-.01-.009-.023,0-.034-.011C-.308.631-.3.642-.295.63c.014.024.03,0,.049.019l0-.016.01.007C-.186.6-.227.627-.176.613-.147.6-.141.576-.122.577c0,0-.012-.006-.006-.013.006.013.017-.016.025,0C-.1.556-.072.549-.086.534c.007.008.029,0,.02.016.007,0,.015,0,.019-.008l-.012,0c.024-.012.041,0,.052-.024l-.012,0C0,.507.008.5.02.517L.007.527A.135.135,0,0,0,.062.5L.054.5C.074.471.2.41.218.379L.2.37.219.351S.225.4.221.395C.264.378.487.288.53.283.549.284.54.3.541.305.559.293.544.288.562.283s0,.011,0,.014S.578.295.576.289.563.269.555.259L.577.253l0,.011c.005,0,0-.033.025-.035S.68.2.717.193C.719.2.712.206.706.212S.718.207.724.21C.711.2.736.2.728.195.745.16.787.171.8.146.8.121.713-.272.7-.3.71-.3.718-.3.72-.3S.7-.305.7-.3l0,.015c-.015.011-.007-.008-.023,0C.67-.3.684-.3.7-.31c-.013,0-.028,0-.029.013-.013,0,0-.015-.02-.015s-.017.024-.031.02v0C.585-.3.581-.26.551-.264l0-.005c-.011,0-.025.012-.044.01.006,0,.013.008,0,.013S.481-.235.464-.239L.455-.223C.389-.2.139-.095.075-.07l0,0c-.1.041-.3.112-.4.165A.125.125,0,0,0-.379.1c.011,0,.01.011,0,.013-.051.016,0,.009-.05.032a1.9,1.9,0,0,1-.34.107C-.787.279-.827.279-.851.3l0-.006c-.027.017-.2.06-.232.078h.006c-.026.021-.029,0-.055,0,.01.018-.012.038-.021.043l0,0a.541.541,0,0,1-.064.048l0-.011a.205.205,0,0,1-.07.034.306.306,0,0,0-.132.037L-1.46.5l0,0s.082.38.169.437l0,.011L-1.281.95c.016,0,.019-.015.021,0L-1.28.952c.015,0,.007.007,0,.015a.055.055,0,0,1,.018,0c0-.005,0,0-.007-.005s.013-.02.024-.018.007.017.024.012A2.272,2.272,0,0,0-.946.88s0,0,0,.007C-.922.873-.9.867-.875.853A.033.033,0,0,1-.859.865.6.6,0,0,1-.724.809",
    transform: "translate(1.464 0.312)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4439",
    "data-name": "Group 4439",
    transform: "translate(182.779 38.207)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4436",
    "data-name": "Group 4436",
    transform: "translate(0.077 0.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5322",
    "data-name": "Path 5322",
    d: "M0-.015a.035.035,0,0,0,.031.01A.03.03,0,0,0,0-.015",
    transform: "translate(0 0.017)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4437",
    "data-name": "Group 4437",
    transform: "translate(2.1 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M-.009,0-.018,0l.009,0",
    transform: "translate(0.018 0.004)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4438",
    "data-name": "Group 4438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    "data-name": "Path 5324",
    d: "M-.624.739l0-.02c.025,0,.012.021.034.012,0-.03.04,0,.046-.02,0,0,.012,0,.013.01C-.532.7-.522.715-.515.71s0,0-.006-.009L-.505.693C-.5.7-.494.705-.5.708A2.26,2.26,0,0,0-.2.667C-.206.656-.218.667-.227.65-.217.637-.209.65-.2.638c.01.026.029,0,.043.027V.65l.008.008C-.1.632-.142.648-.092.643-.065.635-.056.612-.038.617c0,0-.01-.008,0-.013,0,.013.018-.013.024,0C-.012.6.012.6,0,.581.006.589.028.59.017.6.024.6.031.6.035.6l-.01,0C.049.585.064.6.076.578L.066.572C.08.569.092.565.1.582L.087.59A.126.126,0,0,0,.142.569H.135C.156.547.283.509.3.482L.289.47.306.454S.305.5.3.5A2.9,2.9,0,0,1,.6.441C.619.446.609.464.609.466.627.457.614.449.631.447s0,.011,0,.014S.644.462.643.455.634.434.629.423l.021,0V.432S.657.4.679.4.751.39.786.386C.787.393.78.4.774.4S.785.4.79.4C.779.394.8.393.8.39.817.358.854.377.873.355.871.33.846-.071.841-.1a.031.031,0,0,1,.017,0c0-.007-.018-.007-.024,0l0,.016C.82-.077.83-.094.814-.09c0-.013.011-.018.025-.022C.826-.111.813-.118.811-.1c-.012,0,0-.016-.016-.019S.775-.1.763-.107v0C.733-.118.725-.083.7-.092l0,0C.69-.1.674-.089.657-.094c.005,0,.011.01,0,.013s-.03.006-.045,0L.6-.068C.54-.06.295,0,.232.016l0,0C.14.036-.058.071-.154.106-.171.1-.192.1-.209.1c.01,0,.008.013,0,.014-.049.007,0,.009-.05.023A1.682,1.682,0,0,1-.585.185C-.609.208-.645.2-.669.216l0,0C-.695.223-.859.235-.891.248l0,0c-.027.016-.026,0-.05-.006.007.02-.016.035-.025.038v0a.531.531,0,0,1-.066.036l0-.011A.177.177,0,0,1-1.1.323a.267.267,0,0,0-.126.013L-1.258.31l0,0s.023.388.095.459V.784l.011,0c.015,0,.019-.011.02,0l-.019,0c.015,0,.006.009,0,.016a.035.035,0,0,1,.017,0s0,0-.005-.006.015-.018.024-.014S-1.113.8-1.1.8A1.929,1.929,0,0,0-.838.77s0,0,0,.007c.025-.01.049-.012.072-.021A.038.038,0,0,1-.755.77.5.5,0,0,1-.624.739",
    transform: "translate(1.262 0.122)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(184.245 40.877)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4440",
    "data-name": "Group 4440",
    transform: "translate(0.2 0.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5325",
    "data-name": "Path 5325",
    d: "M0-.011a.025.025,0,0,0,.026.005C.016-.015.008-.016,0-.011",
    transform: "translate(0 0.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4441",
    "data-name": "Group 4441",
    transform: "translate(1.65 0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    "data-name": "Path 5326",
    d: "M-.007,0-.015,0A.019.019,0,0,0-.007,0",
    transform: "translate(0.015 0.003)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4442",
    "data-name": "Group 4442",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5327",
    "data-name": "Path 5327",
    d: "M-.584.627-.59.607c.018-.007.014.02.028.009,0-.029.028-.008.029-.024A.012.012,0,0,1-.522.6c0-.016.007-.006.011-.012s0,0-.006-.008l.01-.009C-.5.575-.5.584-.5.587A1.741,1.741,0,0,0-.286.53C-.294.52-.3.531-.311.514-.3.5-.3.514-.3.5c.012.025.022,0,.036.025l0-.016L-.255.52C-.22.493-.248.509-.213.5-.193.5-.189.472-.176.477S-.185.469-.18.464c0,.013.011-.013.017,0C-.158.46-.141.457-.152.44c.006.008.021.008.015.018s.011,0,.013,0l-.008,0C-.116.444-.1.456-.1.437L-.1.431c.01,0,.018-.008.027.01L-.087.449A.067.067,0,0,0-.048.427H-.053C-.04.406.051.369.063.343L.052.331.064.316a.247.247,0,0,1,0,.043A1.2,1.2,0,0,1,.285.314C.3.32.29.339.29.339s0-.016.016-.017,0,.012,0,.014.01,0,.01-.005S.309.309.3.3H.319l0,.011s0-.032.02-.028S.4.273.421.272c0,.007,0,.011-.009.016s.008,0,.012,0C.416.279.434.28.428.276.444.246.471.268.486.247.485.223.472-.177.471-.207c.006,0,.012,0,.014,0a.013.013,0,0,0-.019,0v.016C.453-.186.461-.2.448-.2c0-.013.01-.017.021-.019-.01,0-.021-.009-.023.006-.01,0,0-.015-.012-.02S.416-.214.407-.221v0C.382-.234.375-.2.353-.21l0,0C.347-.22.334-.209.32-.215c0,0,.009.011,0,.014S.3-.2.284-.206L.275-.192c-.052,0-.251.058-.3.072l0,0a2,2,0,0,0-.308.1c-.015-.008-.031,0-.045,0,.009,0,.009.013,0,.014C-.413,0-.375,0-.412.014A1.334,1.334,0,0,1-.67.085C-.685.109-.716.106-.732.124V.119C-.751.133-.881.164-.9.182h0c-.018.019-.022,0-.042,0A.034.034,0,0,1-.952.225v0C-.963.228-.98.254-1,.265l0-.011c-.01.018-.039.025-.05.031-.026.006-.071.006-.1.034L-1.18.3l0,0A1.757,1.757,0,0,0-.973.723l0,.01.007,0c.012,0,.01-.013.014,0l-.013,0c.01,0,.007.007.006.014a.027.027,0,0,1,.013,0s0,0-.006-.005S-.942.721-.933.723s.008.016.019.012A1.47,1.47,0,0,0-.734.678s0,0,0,.007L-.686.656A.043.043,0,0,1-.673.669C-.679.661-.587.625-.584.627",
    transform: "translate(1.182 0.233)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4447",
    "data-name": "Group 4447",
    transform: "translate(184.605 43.113)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444",
    transform: "translate(0.109 1.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M0-.014a.037.037,0,0,0,.033.008A.033.033,0,0,0,0-.014",
    transform: "translate(0 0.016)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4445",
    "data-name": "Group 4445",
    transform: "translate(2.168 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5329",
    "data-name": "Path 5329",
    d: "M-.009-.006-.018,0a.019.019,0,0,0,.009,0",
    transform: "translate(0.018 0.006)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5330",
    "data-name": "Path 5330",
    d: "M-.677.771l0-.02c.026-.007.014.021.036.01C-.641.731-.6.754-.6.737c0,0,.013,0,.015.009,0-.016.011-.007.018-.012s0,0-.007-.008l.016-.01c.008,0,.012.012.005.015A2.6,2.6,0,0,0-.236.665C-.245.655-.258.667-.268.65c.01-.013.02,0,.023-.013.012.025.03,0,.046.024V.645L-.19.653c.053-.03.011-.011.062-.02C-.1.623-.091.6-.073.6c0,0-.011-.007,0-.013,0,.013.018-.015.025,0,.007,0,.031-.008.019-.024.006.008.028.007.018.018C-.009.579,0,.58,0,.575l-.011,0C.016.564.033.574.045.553l-.011,0C.048.544.06.54.07.556L.056.565A.127.127,0,0,0,.112.539L.1.541C.126.517.257.468.274.44L.26.429.277.412s0,.048,0,.043A3.055,3.055,0,0,1,.585.375C.6.378.593.4.594.4.612.389.6.382.616.378s0,.011,0,.014S.63.392.629.385.619.364.612.354l.022,0,0,.011S.64.329.662.329C.7.325.737.311.774.3.775.311.768.317.762.323s.012,0,.018,0C.767.313.792.311.784.308.8.274.844.29.863.266.859.242.809-.157.8-.185a.035.035,0,0,1,.017,0c0-.006-.019-.006-.025,0l0,.016c-.016.01-.007-.008-.023,0C.77-.186.785-.192.8-.2c-.013,0-.027,0-.029.01C.757-.189.767-.2.752-.2S.733-.182.72-.187v0C.688-.195.681-.16.653-.166l0,0C.643-.176.628-.162.611-.165c.005,0,.011.01,0,.013s-.032.008-.048,0l-.01.016c-.066.014-.318.1-.382.114l0,0c-.1.031-.3.081-.4.124A.123.123,0,0,0-.282.1c.011,0,.01.012,0,.013-.05.012,0,.009-.051.027A1.827,1.827,0,0,1-.67.214c-.023.025-.062.02-.086.038l0-.005C-.782.262-.953.287-.986.3l.005,0c-.027.019-.028,0-.053,0,.008.019-.015.037-.024.041v0a.5.5,0,0,1-.066.041l0-.011A.185.185,0,0,1-1.2.394a.3.3,0,0,0-.131.023L-1.365.394l0,0s.048.386.126.451l0,.011.011,0c.016,0,.019-.013.021,0l-.02,0c.015,0,.007.008,0,.016a.039.039,0,0,1,.017,0c0-.005,0,0-.006-.006S-1.2.85-1.19.853s.006.018.022.014A2.116,2.116,0,0,0-.9.82s0,0,0,.007C-.875.815-.85.811-.827.8A.028.028,0,0,1-.813.813.578.578,0,0,1-.677.771",
    transform: "translate(1.369 0.204)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4451",
    "data-name": "Group 4451",
    transform: "translate(185.151 45.174)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4448",
    "data-name": "Group 4448",
    transform: "translate(0.08 0.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5331",
    "data-name": "Path 5331",
    d: "M0-.015a.043.043,0,0,0,.035.009A.035.035,0,0,0,0-.015",
    transform: "translate(0 0.016)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4449",
    "data-name": "Group 4449",
    transform: "translate(2.401 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5332",
    "data-name": "Path 5332",
    d: "M-.01,0-.02,0l.01,0",
    transform: "translate(0.02 0.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4450",
    "data-name": "Group 4450",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5333",
    "data-name": "Path 5333",
    d: "M-.7.757l0-.02c.029-.006.013.021.039.011.005-.03.046-.006.052-.022,0,0,.014,0,.014.01C-.6.719-.588.729-.58.723s0,0-.007-.009L-.568.706c.008,0,.012.012,0,.016A3.112,3.112,0,0,0-.217.669c-.01-.01-.024,0-.034-.016C-.239.64-.23.652-.226.64c.011.026.033,0,.049.026V.651l.009.008C-.107.63-.154.648-.1.641-.066.632-.055.609-.036.613c0,0-.011-.008,0-.013,0,.013.021-.014.027,0C0,.6.022.592.01.576.017.584.041.583.028.594c.009,0,.017,0,.022-.005l-.011,0C.065.578.082.589.1.57L.085.564C.1.56.114.556.124.573L.108.582A.146.146,0,0,0,.171.558H.163C.188.536.333.493.355.465L.34.453.36.438s0,.048-.005.043C.4.471.651.412.7.414.717.418.7.436.7.438.725.429.712.421.73.419s0,.011,0,.014S.745.433.744.426.735.4.728.394l.024,0V.4C.759.4.761.37.785.371c.04,0,.082-.015.123-.02C.908.358.9.364.893.369s.014,0,.019,0C.9.359.928.358.92.355.943.322.986.34,1.008.317c0-.024-.023-.426-.029-.456A.056.056,0,0,1,1-.139c0-.006-.02-.007-.027,0l0,.016c-.018.009-.006-.008-.024,0,0-.013.013-.019.028-.022-.014,0-.029-.006-.032.009-.014,0,0-.016-.018-.018S.9-.138.889-.143v0C.856-.153.845-.118.815-.125l0,0c-.012-.006-.029.008-.049,0,.006,0,.012.01,0,.014s-.035.007-.052,0L.707-.1C.634-.087.355-.016.283,0l0,0C.176.024-.049.065-.159.1A.146.146,0,0,0-.222.1c.012,0,.01.012,0,.014-.056.009,0,.009-.058.025A2.114,2.114,0,0,1-.651.2c-.027.023-.068.017-.1.034l0,0C-.777.241-.965.259-1,.272l.006,0c-.031.018-.03,0-.057,0,.007.02-.019.036-.03.04v0a.57.57,0,0,1-.075.038V.332a.218.218,0,0,1-.079.023.357.357,0,0,0-.145.018L-1.421.348l0,0s.02.389.1.457V.82l.013,0c.017,0,.021-.012.022,0l-.021,0c.016,0,.006.008,0,.015a.049.049,0,0,1,.019,0c0-.005,0,0-.006-.007s.017-.018.028-.015,0,.018.023.015A2.535,2.535,0,0,0-.949.8s0,0,0,.007C-.923.792-.9.789-.87.778A.036.036,0,0,1-.855.793.678.678,0,0,1-.7.757",
    transform: "translate(1.425 0.159)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4456",
    "data-name": "Group 4456",
    transform: "translate(185.7 48.057)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    "data-name": "Group 4452",
    transform: "translate(0.045 0.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5334",
    "data-name": "Path 5334",
    d: "M0-.02c.008.012.019.011.031.012A.031.031,0,0,0,0-.02",
    transform: "translate(0 0.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4453",
    "data-name": "Group 4453",
    transform: "translate(0.075 0.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5335",
    "data-name": "Path 5335",
    d: "M0,0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4454",
    "data-name": "Group 4454",
    transform: "translate(2.104 0.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5336",
    "data-name": "Path 5336",
    d: "M-.009,0-.018,0A.019.019,0,0,0-.009,0",
    transform: "translate(0.018 0.003)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4455",
    "data-name": "Group 4455",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5337",
    "data-name": "Path 5337",
    d: "M-.589.705V.685c.026,0,.011.022.033.015C-.55.671-.517.7-.51.683c0,0,.012,0,.012.011,0-.016.012-.005.019-.01s0,0-.005-.009L-.468.668c.007,0,.01.013,0,.016a2.278,2.278,0,0,0,.3-.02c-.008-.011-.021,0-.029-.02.012-.012.019,0,.023-.01.008.027.028,0,.04.03l0-.016.008.009c.053-.022.011-.01.061-.011C-.031.641-.019.618,0,.624c0,0-.009-.009,0-.013C0,.624.013.6.018.612c.007,0,.03,0,.02-.021C.043.6.064.6.053.611c.007,0,.014,0,.019,0L.062.6C.086.6.1.612.113.593L.1.587C.118.584.129.582.137.6L.123.607A.12.12,0,0,0,.179.589H.172C.194.568.322.539.343.514L.33.5.349.487s0,.048-.007.043a2.674,2.674,0,0,1,.3-.035C.658.5.646.516.646.519.665.511.654.5.67.5s0,.011,0,.014S.682.517.682.511.674.489.669.477H.69V.488S.7.456.72.46.792.453.827.452C.827.459.82.463.813.468s.012,0,.017,0C.82.459.844.46.837.456.859.426.9.448.915.426c0-.025,0-.426,0-.455a.029.029,0,0,1,.016,0c0-.007-.016-.008-.023,0v.016C.892-.008.9-.024.887-.021c0-.013.012-.017.026-.02C.9-.041.888-.049.884-.034c-.012,0,0-.016-.014-.02S.849-.036.837-.042v0C.809-.055.8-.021.772-.031l0,0C.765-.042.749-.03.732-.036c0,0,.01.011,0,.014S.7-.02.688-.028L.677-.014C.614-.01.368.035.305.044l0,0c-.1.016-.293.037-.39.065A.11.11,0,0,0-.136.1c.009,0,.007.013,0,.014-.049,0,0,.009-.052.019A1.628,1.628,0,0,1-.513.155C-.538.176-.574.166-.6.181l0,0C-.624.186-.788.187-.82.2l.005,0C-.843.213-.842.193-.865.189c.006.02-.018.034-.028.037V.221A.446.446,0,0,1-.96.253V.242a.185.185,0,0,1-.07.016.27.27,0,0,0-.126,0L-1.187.233l0,0A1.313,1.313,0,0,0-1.128.7V.712l.011,0c.014,0,.019-.01.019,0h-.019c.014,0,.005.009,0,.015a.035.035,0,0,1,.016,0s0,0,0-.007.016-.017.025-.012,0,.018.019.017A1.9,1.9,0,0,0-.8.721s0,0,0,.007C-.78.721-.757.72-.733.712A.032.032,0,0,1-.721.727.519.519,0,0,1-.589.705",
    transform: "translate(1.191 0.054)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4460",
    "data-name": "Group 4460",
    transform: "translate(186.132 50.268)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457",
    transform: "translate(0 0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5338",
    "data-name": "Path 5338",
    d: "M0-.043c0,.013.016.017.028.022A.036.036,0,0,0,0-.043",
    transform: "translate(0 0.043)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4458",
    "data-name": "Group 4458",
    transform: "translate(2.41 0.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5339",
    "data-name": "Path 5339",
    d: "M-.009.006-.019,0Z",
    transform: "translate(0.019)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4459",
    "data-name": "Group 4459",
    transform: "translate(0.014 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5340",
    "data-name": "Path 5340",
    d: "M-.541-.631-.532-.65c.026.008,0,.025.026.028.019-.024.039.016.053,0s.011.007.007.015c.009-.014.013,0,.022,0s0-.006,0-.011h.019C-.4-.6-.4-.6-.41-.6c.043.021.25.117.3.132,0-.013-.019-.012-.018-.031.017,0,.018.011.027,0-.006.027.025.018.023.048l.01-.013,0,.011c.061.01.016,0,.062.023.028.011.051,0,.063.012,0,0,0-.013,0-.013s.023,0,.021.014.03.015.03-.006c0,.01.018.024,0,.025.006,0,.012.01.018.009L.128-.391c.024.009.03.028.053.021L.176-.382C.19-.376.2-.371.2-.352l-.016,0a.142.142,0,0,0,.06.018l-.007,0c.033,0,.165.05.2.043l0-.018H.456S.424-.28.424-.285a1.988,1.988,0,0,1,.283.169C.717-.1.7-.094.7-.094c.02.007.016-.008.03,0S.719-.081.715-.081s.011.011.016.006S.738-.1.741-.11L.76-.1.752-.087S.78-.106.8-.088.86-.041.89-.017c0,.005-.013,0-.022,0S.88-.009.881,0C.88-.017.9,0,.9-.008.934-.014.949.029.98.029L1.3-.3c.006.006.013.011.013.015S1.3-.305,1.291-.307L1.281-.3c-.02-.008,0-.01-.015-.021.007-.011.023,0,.036.007-.01-.01-.016-.026-.029-.018-.008-.013.011-.012,0-.026s-.032,0-.037-.017l0,0C1.219-.4,1.187-.388,1.17-.415l.005,0c0-.012-.027-.016-.038-.033,0,.006,0,.016-.008.011S1.1-.46,1.091-.477l-.02,0A4.374,4.374,0,0,0,.681-.7h0A3.077,3.077,0,0,0,.256-.9C.245-.915.221-.923.2-.935c.007.01,0,.016-.007.012C.145-.948.191-.916.135-.935a3.728,3.728,0,0,1-.355-.155c-.036.006-.07-.02-.1-.019l0,0c-.034-.006-.212-.079-.253-.083l0,0c-.036,0-.026-.017-.051-.03,0,.021-.034.024-.045.023l0,0c-.017,0-.059.006-.086,0l0-.01a.239.239,0,0,1-.083-.013.345.345,0,0,0-.144-.042L-1-1.3-1-1.3s-.126.367-.081.461l0,.011.012,0c.014.009.023,0,.02.008l-.02-.006c.014.007,0,.01,0,.016A.048.048,0,0,1-1.064-.8s0-.005,0-.007.022-.011.03,0,0,.018.014.023c.089.028.173.063.263.085,0,.005,0,0,0,.006l.078.014A.035.035,0,0,1-.68-.667a.509.509,0,0,1,.139.036",
    transform: "translate(1.094 1.305)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4464",
    "data-name": "Group 4464",
    transform: "translate(186.368 52.426)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4461",
    "data-name": "Group 4461",
    transform: "translate(0 0.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5341",
    "data-name": "Path 5341",
    d: "M0-.038c0,.013.015.016.025.019C.019-.031.011-.038,0-.038",
    transform: "translate(0 0.038)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4462",
    "data-name": "Group 4462",
    transform: "translate(2.046 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5342",
    "data-name": "Path 5342",
    d: "M-.008,0H-.017A.013.013,0,0,0-.008,0",
    transform: "translate(0.017 0.002)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4463",
    "data-name": "Group 4463",
    transform: "translate(0.011 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5343",
    "data-name": "Path 5343",
    d: "M-.484.347l.005-.02c.024,0,0,.024.026.022C-.44.322-.417.358-.407.344c0,0,.01,0,.008.014.006-.015.012,0,.019-.005s0,0,0-.01l.017,0c.005.006.006.015,0,.016A2,2,0,0,0-.089.411C-.093.4-.108.4-.11.385c.014-.008.017.006.023,0,0,.028.025.011.029.039L-.052.405l0,.011C.006.407-.035.41.01.421.036.422.052.4.065.412.063.412.058.4.066.4c0,.013.02-.007.021.007S.115.41.111.391c0,.01.021.017.008.023.007,0,.013.006.018,0L.129.409c.022,0,.032.017.049,0L.171.4C.184.4.195.4.2.423l-.015,0a.1.1,0,0,0,.055,0l-.007,0C.257.406.38.41.4.39L.4.375.416.365S.4.41.4.4A2.611,2.611,0,0,1,.679.444c.013.01,0,.023,0,.025C.7.467.687.456.7.459S.7.47.7.472s.012.005.014,0,0-.024,0-.035l.019,0,0,.011S.74.422.758.431s.067.011.1.019C.855.456.848.459.84.462s.012,0,.015.005C.849.454.869.462.864.456.892.432.919.462.942.446.948.422,1.05.034,1.055.005c.007,0,.013,0,.014.006S1.057,0,1.049,0l0,.016c-.016,0,0-.01-.018-.011,0-.013.016-.013.028-.013-.011,0-.02-.014-.027,0-.009-.007,0-.015-.008-.023S1-.017.988-.026v0c-.023-.017-.041.013-.062,0l0,0C.923-.044.905-.037.892-.046c0,0,.006.013,0,.013S.861-.038.85-.049l-.014.01C.779-.05.546-.067.487-.074l0,0C.4-.083.217-.111.122-.108.11-.123.089-.123.075-.129c.008.006,0,.015,0,.013-.046-.009,0,.008-.051.007a1.417,1.417,0,0,1-.3-.058c-.027.015-.057,0-.083,0l0,0C-.388-.164-.535-.2-.566-.2l0,0C-.591-.192-.584-.211-.6-.22c0,.02-.025.029-.034.029v0a.45.45,0,0,1-.068.014l0-.011a.143.143,0,0,1-.066,0A.233.233,0,0,0-.885-.222L-.906-.257l0,0A1.409,1.409,0,0,0-.969.21l0,.011h.011c.011.007.019-.005.017.006l-.017,0c.012.006,0,.01,0,.015A.032.032,0,0,1-.951.247s0-.005,0-.008S-.936.227-.928.233s0,.018.013.021A1.7,1.7,0,0,0-.681.31c0,.005,0,0,0,.006.024,0,.046,0,.068,0A.039.039,0,0,1-.608.336.41.41,0,0,1-.484.347",
    transform: "translate(0.979 0.257)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469",
    transform: "translate(187.289 55.833)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4465",
    "data-name": "Group 4465",
    transform: "translate(0.226 1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5344",
    "data-name": "Path 5344",
    d: "M0-.01a.026.026,0,0,0,.028,0C.016-.015.008-.015,0-.01",
    transform: "translate(0 0.013)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4466",
    "data-name": "Group 4466",
    transform: "translate(0.253 1.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5345",
    "data-name": "Path 5345",
    d: "M0,0H0Z",
    transform: "translate(0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4467",
    "data-name": "Group 4467",
    transform: "translate(1.482 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5346",
    "data-name": "Path 5346",
    d: "M-.006-.008-.012,0a.012.012,0,0,0,.006,0",
    transform: "translate(0.012 0.008)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4468",
    "data-name": "Group 4468",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5347",
    "data-name": "Path 5347",
    d: "M-.63.778-.639.759c.019-.011.017.017.031,0C-.615.735-.578.75-.58.734c0,0,.01,0,.014.007C-.571.725-.56.732-.557.725s0,0-.007-.006L-.554.708c.008,0,.013.009.009.014A1.507,1.507,0,0,0-.325.614C-.335.606-.341.619-.354.6c0-.014.015,0,.013-.016C-.324.611-.318.584-.3.6L-.3.589-.293.6C-.262.56-.288.583-.252.568-.233.555-.233.53-.219.531c0,0-.011-.005-.007-.012C-.219.531-.217.5-.208.514S-.186.5-.2.489C-.193.5-.177.491-.181.5S-.17.5-.169.494H-.177c.015-.012.031,0,.034-.024l-.01,0c.01-.007.018-.013.03,0l-.008.01A.078.078,0,0,0-.1.446L-.1.448c.009-.026.094-.09.1-.12L-.015.32-.008.3S.008.346,0,.343A1.745,1.745,0,0,1,.217.222C.232.223.23.241.231.243S.23.227.242.221s0,.011,0,.013S.257.232.255.226.24.208.231.2L.247.192l0,.01S.245.171.263.168.315.14.341.129c0,.006,0,.013,0,.019S.345.142.35.145C.338.137.357.132.35.13.355.1.391.106.4.08.387.058.227-.31.214-.335c.005,0,.01,0,.013,0s-.016,0-.019,0l.007.014C.2-.309.206-.328.2-.32.189-.331.2-.339.207-.346c-.009,0-.022,0-.019.015-.01,0-.007-.015-.019-.014s-.008.023-.02.021v0c-.026,0-.02.033-.044.032V-.3c-.01,0-.017.013-.032.012,0,0,.011.007.005.012S.056-.265.042-.268l0,.016c-.046.023-.214.136-.259.162v0c-.065.043-.207.12-.269.174C-.5.077-.519.088-.532.091c.009,0,.011.01.006.012-.035.018,0,.009-.03.033A1.063,1.063,0,0,1-.795.253C-.805.28-.836.281-.85.3V.3c-.017.017-.14.066-.161.084h0c-.015.021-.022,0-.041.006A.034.034,0,0,1-1.054.43l0,0a.369.369,0,0,1-.038.048L-1.1.464c-.008.018-.037.029-.047.035-.025.009-.07.011-.094.041L-1.274.522v0a1.609,1.609,0,0,0,.234.406l0,.01.008-.006c.012,0,.01-.014.015,0l-.014.006c.011,0,.008.007.007.014a.031.031,0,0,1,.014,0s0,0-.006,0S-1.008.928-1,.929s.01.015.021.01A1.146,1.146,0,0,0-.787.855s0,0,0,.007C-.768.848-.751.84-.737.827a.03.03,0,0,1,.015.01C-.728.83-.633.776-.63.778",
    transform: "translate(1.275 0.346)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474",
    transform: "translate(187.938 58.572)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470",
    transform: "translate(0.159 1.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5348",
    "data-name": "Path 5348",
    d: "M0-.011a.034.034,0,0,0,.033,0A.029.029,0,0,0,0-.011",
    transform: "translate(0 0.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(0.193 1.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5349",
    "data-name": "Path 5349",
    d: "M0,0H0Z",
    transform: "translate(0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4472",
    "data-name": "Group 4472",
    transform: "translate(2.017 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5350",
    "data-name": "Path 5350",
    d: "M-.008-.008-.017,0a.015.015,0,0,0,.009,0",
    transform: "translate(0.017 0.008)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4473",
    "data-name": "Group 4473",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5351",
    "data-name": "Path 5351",
    d: "M-.694.8-.7.782c.025-.01.016.019.037.006,0-.03.038-.012.041-.029,0,0,.012,0,.014.008,0-.016.01-.008.016-.014s0,0-.007-.007L-.584.734c.008,0,.013.01.006.014a2.306,2.306,0,0,0,.3-.1C-.292.644-.3.657-.315.642-.307.627-.3.638-.295.626c.014.024.029,0,.048.019l0-.016L-.24.636C-.193.6-.23.624-.182.61-.156.6-.151.573-.133.575c0,0-.012-.006-.006-.013.006.013.015-.016.023,0C-.109.554-.086.547-.1.532c.007.007.028,0,.019.015.007,0,.014,0,.018-.008l-.01,0c.022-.011.039,0,.048-.023l-.011,0C-.023.506-.012.5,0,.516l-.012.01A.122.122,0,0,0,.038.495L.031.5C.049.471.169.41.182.38L.167.37.182.352S.189.4.186.4A2.949,2.949,0,0,1,.474.286c.018,0,.011.02.011.023C.5.3.488.291.5.287S.507.3.505.3.519.3.517.292.5.272.5.263L.517.257l0,.011c.005,0,0-.033.023-.034S.613.208.647.2C.649.2.644.211.638.217s.011-.006.017,0C.643.207.666.2.658.2.673.165.714.177.728.152.722.127.628-.263.618-.29a.032.032,0,0,1,.017,0c0-.006-.018,0-.024,0l0,.015C.6-.264.607-.283.592-.276.587-.288.6-.3.613-.3.6-.3.586-.3.586-.288.574-.289.582-.3.567-.3s-.016.023-.029.02v0C.507-.289.5-.253.476-.256V-.262c-.011,0-.023.012-.041.01.005,0,.012.009,0,.013S.41-.228.394-.233L.386-.217C.325-.2.092-.091.032-.067v0c-.09.04-.281.11-.37.161A.118.118,0,0,0-.392.1c.01,0,.01.011,0,.013-.048.016,0,.009-.046.031a1.632,1.632,0,0,1-.318.1C-.772.274-.81.274-.831.294V.289c-.025.017-.187.059-.216.076h0c-.023.021-.027,0-.051,0,.01.019-.01.038-.019.043v0a.514.514,0,0,1-.059.047l0-.011a.18.18,0,0,1-.065.033.275.275,0,0,0-.124.036L-1.4.493l0,0s.091.378.174.435l0,.011.011-.005c.015,0,.016-.014.02,0l-.019.005c.014,0,.007.008,0,.015a.039.039,0,0,1,.017,0c0-.005,0,0-.007-.005s.012-.02.022-.018.007.017.023.012A2.081,2.081,0,0,0-.9.871s0,0,0,.007C-.88.863-.856.857-.835.844A.043.043,0,0,1-.82.855.529.529,0,0,1-.694.8",
    transform: "translate(1.404 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478",
    transform: "translate(188.437 61.461)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475",
    transform: "translate(0 0.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5352",
    "data-name": "Path 5352",
    d: "M0-.046a.026.026,0,0,0,.012.023c0-.013,0-.02-.012-.023",
    transform: "translate(0 0.046)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476",
    transform: "translate(1.598 0.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5353",
    "data-name": "Path 5353",
    d: "M-.006,0-.012,0A.007.007,0,0,0-.006,0",
    transform: "translate(0.012 0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477",
    transform: "translate(0.012 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5354",
    "data-name": "Path 5354",
    d: "M-.314-.127-.3-.144c.017.008-.006.023.012.027.019-.023.024.015.036,0s.006.007,0,.015c.01-.013.01,0,.016,0s0-.005,0-.01h.014c0,.007,0,.015-.007.014A1.135,1.135,0,0,0-.042.013C-.041,0-.054,0-.049-.015s.011.009.019,0C-.04.012-.016,0-.022.029l.01-.013V.027C.029.03,0,.024.028.043s.037-.008.044,0,0-.012.005-.013S.094.032.09.045s.02.01.023-.01c0,.01.01.02,0,.023,0,0,.007.008.012.006l0-.008C.137.061.139.079.156.068l0-.01c.009,0,.018.006.013.024H.155A.064.064,0,0,0,.2.092l0,0C.216.08.307.108.331.095V.079L.349.074S.323.113.323.108A1.4,1.4,0,0,1,.517.2C.523.214.509.223.508.225c.015,0,.012-.011.022,0S.524.23.521.231s.008.008.011,0S.539.211.542.2L.555.207.549.217S.57.193.581.205.627.229.648.243A.02.02,0,0,1,.632.251S.64.253.641.26c0-.014.013,0,.011-.009C.68.234.69.267.712.258s.22-.363.234-.389c0,0,.009.006.009.008S.95-.137.943-.137L.935-.123c-.014,0,0-.01-.01-.014C.931-.148.942-.146.951-.143.944-.148.941-.16.931-.15c-.005-.009.008-.014,0-.023s-.022.008-.026,0l0,0C.9-.2.873-.173.863-.192l0,0C.865-.205.85-.2.843-.214c0,0,0,.013-.007.012S.817-.212.813-.225L.8-.218C.76-.241.592-.3.551-.322h0A2.707,2.707,0,0,0,.291-.43c0-.016-.019-.02-.028-.028,0,.007,0,.014-.007.011-.031-.017-.006.007-.04,0a.8.8,0,0,1-.2-.115C-.013-.559-.029-.581-.05-.58l0,0c-.022,0-.117-.07-.142-.075l0,0c-.024,0-.012-.016-.024-.029a.033.033,0,0,1-.035.02l0,0a.357.357,0,0,1-.056,0l.006-.01c-.018,0-.039-.012-.049-.015S-.385-.74-.42-.741l0-.037,0,0a1.817,1.817,0,0,0-.2.422l-.006.01.008,0c.007.01.016,0,.011.01L-.627-.34c.007.008,0,.01-.008.014a.017.017,0,0,1,.008.01s0,0,0-.008.017-.007.021,0S-.613-.307-.6-.3a.982.982,0,0,0,.155.1s0,0,0,0c.019,0,.033.013.05.017a.034.034,0,0,1,0,.018c0-.01.089.033.089.036",
    transform: "translate(0.635 0.778)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483",
    transform: "translate(189.021 64.837)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479",
    transform: "translate(0 0.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5355",
    "data-name": "Path 5355",
    d: "M-.005-.046a.021.021,0,0,0,0,.023C0-.034,0-.04-.005-.046",
    transform: "translate(0.011 0.046)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480",
    transform: "translate(0.002 0.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5356",
    "data-name": "Path 5356",
    d: "M0,0H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481",
    transform: "translate(1.132 1.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5357",
    "data-name": "Path 5357",
    d: "M0,0l0,0A.007.007,0,0,0,0,0",
    transform: "translate(0.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482",
    transform: "translate(0.003 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    "data-name": "Path 5358",
    d: "M-.135-.818l.017-.01c.009.013-.017.017-.005.025.027-.011.01.021.025.017,0,0,0,.008-.006.012.014-.007.007,0,.012.006s0,0,.007-.007l.01.006c0,.006-.009.012-.013.009A.828.828,0,0,0,0-.6c.008-.01,0-.013.01-.025s0,.011.014.008C0-.6.025-.6,0-.583L.019-.589.013-.581c.031.019.011,0,.023.028s.033.008.031.02S.073-.542.079-.541c-.012.008.014,0,0,.013s.01.015.023,0C.1-.519.1-.507.092-.509S.094-.5.1-.5l0-.008C.11-.5.1-.483.121-.484l0-.008c.005.006.01.011,0,.024l-.01,0A.049.049,0,0,0,.14-.45l0,0c.023,0,.077.059.1.058L.252-.408l.016,0S.226-.385.23-.388a1.006,1.006,0,0,1,.1.148c0,.012-.018.014-.02.015s.015,0,.019.005-.01.005-.012.005,0,.009.007.005S.34-.225.349-.233l.006.011-.01.006s.03-.011.031,0a.539.539,0,0,0,.031.056.019.019,0,0,1-.017,0s.005.005,0,.01.011,0,.013,0c.032,0,.021.028.044.029s.372-.2.4-.221c0,0,0,.008,0,.01a.009.009,0,0,0,0-.015L.832-.339c-.01-.005.007-.007,0-.015.011-.008.018,0,.023.005s0-.018-.012-.013S.857-.37.858-.379s-.021,0-.018-.012h0c0-.021-.03-.01-.027-.029h0c0-.008-.011-.012-.009-.024C.81-.443.8-.436.8-.44S.789-.455.793-.467H.779C.76-.5.666-.614.644-.644h0A1.691,1.691,0,0,0,.5-.828C.507-.842.5-.851.5-.861c0,.008-.01.011-.012.007C.469-.879.475-.851.455-.873a.58.58,0,0,1-.094-.169c-.024,0-.023-.028-.041-.035h0c-.015-.011-.053-.1-.069-.113v0c-.019-.009,0-.017,0-.032a.034.034,0,0,1-.039,0l0,0C.209-1.225.184-1.231.174-1.241l.01-.006c-.017,0-.024-.024-.03-.03S.148-1.332.122-1.346L.14-1.376h0a2.2,2.2,0,0,0-.389.259l-.01.006.005.005c0,.01.013.006,0,.011l-.005-.01c0,.008-.007.007-.013.008a.017.017,0,0,1,0,.011s0,0,0-.006.018,0,.017.009-.016.01-.011.019A.688.688,0,0,0-.2-.929s0,0-.007,0c.013.011.018.023.03.032A.041.041,0,0,1-.185-.88c.007-.007.051.06.05.062",
    transform: "translate(0.274 1.377)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488",
    transform: "translate(188.329 67.446)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484",
    transform: "translate(0.001 0.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    "data-name": "Path 5359",
    d: "M-.008-.062a.032.032,0,0,0-.008.031A.029.029,0,0,0-.008-.062",
    transform: "translate(0.017 0.062)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485",
    transform: "translate(0.002 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5360",
    "data-name": "Path 5360",
    d: "M0,0H0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486",
    transform: "translate(1.069 2.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5361",
    "data-name": "Path 5361",
    d: "M0,.008l0-.008A.022.022,0,0,0,0,.008",
    transform: "translate(0.006)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5362",
    "data-name": "Path 5362",
    d: "M-.1-2.163l.02,0c.007.025-.02.014-.009.035.03,0,.007.038.024.042,0,0,0,.012-.009.013.016,0,.006.01.012.016s0,0,.008-.006l.009.015c0,.007-.011.011-.015,0a2.272,2.272,0,0,0,.066.294c.009-.009,0-.021.014-.031.014.01,0,.019.014.021-.025.012,0,.028-.024.044H.025L.017-1.71c.03.048.011.01.02.057.01.027.034.034.03.051,0,0,.007-.011.013,0-.013,0,.015.016,0,.023,0,.007.008.029.024.017C.1-1.561.1-1.54.089-1.549c0,.007,0,.014.006.018l0-.01c.009.022,0,.038.018.049l0-.01c.005.013.01.024-.007.034L.1-1.482a.114.114,0,0,0,.026.052l0-.007c.024.019.073.14.1.155l.011-.014.017.016s-.048,0-.043,0a2.649,2.649,0,0,1,.08.287c0,.018-.021.009-.023.009.01.017.017,0,.02.02s-.011,0-.014,0,0,.014.007.013S.306-.961.315-.968l0,.021-.011,0s.032,0,.032.025.018.07.024.1C.358-.816.352-.822.347-.827s0,.011,0,.016c.009-.011.011.012.015,0C.4-.789.38-.751.4-.734.428-.739.824-.8.853-.806c0,.006,0,.013,0,.016s.006-.018,0-.024l-.016,0c-.009-.015.008-.007,0-.022.012,0,.019.009.023.022,0-.013,0-.026-.01-.027,0-.012.015,0,.017-.017S.85-.871.854-.884h0C.862-.913.827-.919.834-.946l0,0c0-.01-.009-.024-.006-.041,0,.005-.01.011-.014,0s-.008-.029,0-.044L.8-1.036C.789-1.1.707-1.331.688-1.392l0,0C.66-1.48.61-1.67.567-1.761c.008-.018,0-.037,0-.054,0,.01-.012.01-.013,0-.012-.047-.009,0-.027-.047a1.558,1.558,0,0,1-.072-.316C.429-2.2.434-2.232.415-2.255l.005,0C.406-2.279.381-2.439.366-2.469l0,0c-.018-.025,0-.026,0-.05-.019.008-.036-.013-.04-.021h0A.559.559,0,0,1,.288-2.6L.3-2.6C.283-2.615.278-2.652.273-2.665A.25.25,0,0,0,.25-2.787l.024-.035,0,0a1.33,1.33,0,0,0-.448.134l-.012,0,0,.011c0,.014.012.017,0,.019l0-.019c0,.014-.008.007-.015,0a.033.033,0,0,1,0,.017c.005,0,0,0,.006-.006s.019.013.016.023S-.2-2.636-.2-2.62a1.828,1.828,0,0,0,.048.25s0,0-.007,0c.012.024.016.047.027.068a.04.04,0,0,1-.013.014A.485.485,0,0,1-.1-2.163",
    transform: "translate(0.205 2.826)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    transform: "translate(187.57 70.007)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    transform: "translate(0.452 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5363",
    "data-name": "Path 5363",
    d: "M-.019,0a.017.017,0,0,0-.02,0q.017.007.02,0",
    transform: "translate(0.039 0.004)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490",
    transform: "translate(0.358 1.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5364",
    "data-name": "Path 5364",
    d: "M0,0,0,0A.005.005,0,0,0,0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5365",
    "data-name": "Path 5365",
    d: "M-.286-1.551l.015.013c-.006.009-.02-.012-.022,0,.02.021-.012.011,0,.023s-.005,0-.012,0c.011.01,0,.006,0,.011s0,0,.009,0V-1.5C-.3-1.5-.311-1.5-.311-1.506A.389.389,0,0,0-.4-1.417c.011,0,.009,0,.024,0s-.008,0,0,.013c-.023-.015-.012.005-.036-.01L-.4-1.4l-.009,0c0,.028,0,.009-.012.022s.009.028,0,.028.01,0,.011.008,0,.013-.009.005-.007.01.01.019c-.009,0-.017,0-.02-.009s-.007,0,0,.007h.007c0,.009-.018,0-.009.02l.009,0c0,.006,0,.01-.021,0v-.009a.026.026,0,0,0-.006.026l0,0c.008.019-.013.07,0,.092l.014.006,0,.014s-.034-.031-.03-.03a.455.455,0,0,1-.072.1c-.011,0-.019-.014-.021-.015s.01.012.005.017-.009-.008-.01-.01-.006,0,0,.007.019.013.03.018l-.007.006-.009-.007s.021.022.012.025-.019.023-.029.032a.018.018,0,0,1-.008-.014s0,.005-.007,0c.011,0,0,.009.009.01.015.025-.013.02,0,.039s.322.275.345.294c0,0,0,0-.007,0s.012,0,.011,0L-.237-.71c0-.009.008,0,.012,0s.009.014.007.019.014,0,0-.011c.007,0,.012.01.02.009s-.008-.017,0-.016h0c.017,0-.005-.025.012-.025l0,0c.008,0,0-.01.015-.01s-.011,0-.01-.009.007-.01.019-.008L-.161-.769A1.478,1.478,0,0,0-.082-.9v0A.807.807,0,0,0,0-1.038c.014,0,.017-.006.023-.009s-.012-.007-.01-.009-.006-.006,0-.025a.261.261,0,0,1,.091-.1C.1-1.2.117-1.2.115-1.216l0,0c0-.013.055-.055.058-.07h0c0-.016.013,0,.024-.006a.037.037,0,0,1-.019-.031l0,0c0-.007-.006-.028,0-.037l.008.007c0-.014.009-.023.012-.027s.039-.012.038-.035L.27-1.4l0,0A3.221,3.221,0,0,0-.1-1.684l-.008-.007,0,0c-.008,0,0,.012-.008,0l.006-.005c-.006,0-.008,0-.012-.01a.012.012,0,0,1-.008,0s0,0,.007,0,.007.014,0,.014-.015-.011-.02-.007a.327.327,0,0,0-.078.07s0,0,0-.005-.01.018-.012.028A.045.045,0,0,1-.259-1.6c.008,0-.025.049-.027.048",
    transform: "translate(0.579 1.698)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(185.343 70.922)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(0.588 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5366",
    "data-name": "Path 5366",
    d: "M-.023-.035c-.013,0-.018.01-.024.018.013,0,.021-.008.024-.018",
    transform: "translate(0.047 0.035)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494",
    transform: "translate(0.587 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5367",
    "data-name": "Path 5367",
    d: "M0,0H0Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    transform: "translate(0.418 1.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5368",
    "data-name": "Path 5368",
    d: "M0,.008,0,0A.011.011,0,0,0,0,.008",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496",
    transform: "translate(0 0.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5369",
    "data-name": "Path 5369",
    d: "M-.377-2.537l.018.009c-.008.021-.024,0-.027.019.024.018-.015.031,0,.044s-.007.008-.015,0c.014.009,0,.012,0,.019s.005,0,.01,0v.016c-.007,0-.016,0-.015-.005a1.668,1.668,0,0,0-.109.243c.013,0,.01-.016.029-.013s-.009.014,0,.022c-.027-.006-.015.02-.044.018l.014.009-.011,0c0,.051,0,.013-.016.052s.009.043,0,.053.012,0,.013,0,0,.02-.011.018S-.559-2-.539-2c-.01,0-.02.015-.024,0,0,.006-.008.011-.006.016l.008-.006c-.005.02-.023.026-.012.044l.01,0c0,.012-.006.022-.025.02v-.014A.1.1,0,0,0-.6-1.892l0-.005c.009.027-.019.139,0,.166l.017,0,0,.02s-.04-.025-.035-.025a2.023,2.023,0,0,1-.094.247C-.718-1.481-.727-1.5-.729-1.5c0,.018.011.012,0,.025s-.01-.005-.011-.008-.008.01,0,.013.023,0,.035.006l-.008.016-.011,0s.025.021.013.035-.024.059-.038.087c-.006,0-.007-.011-.009-.018s0,.01-.009.012c.014,0,0,.015.01.011.017.031-.017.049-.007.074.022.01.378.195.406.2,0,.006-.006.012-.009.013s.015-.01.014-.017l-.015-.006c0-.016.011,0,.015-.014.012,0,.01.018.007.029.006-.01.018-.016.007-.025.009-.008.014.007.024,0s-.009-.024,0-.03h0c.021-.018-.005-.041.015-.057l0,0c.009,0,.006-.022.018-.032,0,0-.014,0-.012-.006s.01-.025.023-.032l-.008-.015c.023-.051.086-.26.1-.313v0c.025-.081.09-.243.106-.331.016-.008.021-.026.029-.038-.008.006-.015,0-.012-.006.017-.039-.007-.006,0-.049A1.228,1.228,0,0,1,.081-2.23C.073-2.258.1-2.281.095-2.307l0,0c0-.026.071-.153.076-.182l0,0c0-.027.016-.017.029-.033a.035.035,0,0,1-.021-.038l0,0a.411.411,0,0,1,0-.066l.011,0c-.005-.02.011-.049.015-.061s.049-.059.05-.1l.038-.011,0,0a1.491,1.491,0,0,0-.439-.161l-.01-.005,0,.01c-.01.01,0,.02-.01.015l.008-.015c-.008.01-.01,0-.014-.006a.026.026,0,0,1-.011.01s.005,0,.008,0,.008.02,0,.025S-.2-2.924-.2-2.911a1.5,1.5,0,0,0-.1.2s0,0,0-.005c0,.023-.014.041-.017.063a.031.031,0,0,1-.019,0c.01,0-.032.112-.035.112",
    transform: "translate(0.763 2.956)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502",
    transform: "translate(182.455 71.538)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498",
    transform: "translate(1.264 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5370",
    "data-name": "Path 5370",
    d: "M-.034-.033c-.014,0-.024.009-.034.018A.039.039,0,0,0-.034-.033",
    transform: "translate(0.068 0.033)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    transform: "translate(1.263 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M0,0H0Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500",
    transform: "translate(0.397 2.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5372",
    "data-name": "Path 5372",
    d: "M0,.01,0,0A.025.025,0,0,0,0,.01",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501",
    transform: "translate(0 0.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5373",
    "data-name": "Path 5373",
    d: "M-.821-3.37l.016.013c-.018.027-.025-.006-.037.022.017.026-.031.039-.024.056,0,0-.01.01-.017,0,.01.013-.006.015-.008.024s.006,0,.011,0l-.008.021c-.009,0-.017,0-.014-.008a2.746,2.746,0,0,0-.218.31c.014,0,.017-.02.036-.016,0,.019-.015.018-.009.029-.027-.009-.024.026-.054.021l.011.012-.012,0c-.023.067,0,.017-.037.067-.016.032-.006.058-.024.07,0,0,.014,0,.013.006-.013-.006,0,.026-.018.023s-.02.032,0,.033c-.011,0-.027.02-.026,0-.005.008-.012.013-.012.021l.011-.007c-.013.027-.033.034-.028.059l.012-.006c-.008.016-.014.029-.034.026l0-.018a.171.171,0,0,0-.026.067l0-.007c0,.036-.065.185-.058.221l.019-.005V-2.3s-.035-.032-.03-.032c-.024.046-.141.294-.169.334C-1.561-1.981-1.57-2-1.57-2c-.006.024.009.016,0,.034s-.01-.006-.01-.01-.01.014-.005.018.024,0,.036.005l-.013.023-.01-.006c0,.005.021.027,0,.047-.023.037-.039.081-.06.119-.006,0-.005-.013-.005-.023,0,.005-.005.014-.012.017.015,0,0,.02.008.014.011.04-.028.067-.023.1.021.013.363.227.389.238,0,.007-.008.015-.011.016s.017-.012.017-.022l-.014-.008c0-.021.011,0,.018-.019.012,0,.008.022,0,.037.007-.013.021-.021.011-.032.011-.01.014.008.026-.005s0-.03.008-.039h0c.025-.023,0-.052.026-.073l0,0c.011-.006.011-.028.026-.042,0,0-.015,0-.012-.007s.015-.033.031-.042l-.005-.019c.03-.063.158-.342.186-.4v0c.048-.1.164-.308.211-.418.02-.009.031-.032.043-.047-.01.006-.015,0-.011-.008.032-.049-.005-.008.022-.061a1.822,1.822,0,0,1,.22-.318c0-.037.038-.062.046-.1l0,.005c.013-.032.139-.179.157-.214l-.005,0c.011-.034.025-.019.046-.037-.019-.009-.011-.04-.005-.05l0,0A.555.555,0,0,1-.195-3.4l.009.008A.249.249,0,0,1-.141-3.46a.38.38,0,0,0,.1-.111L0-3.578v-.006s-.265-.286-.373-.283l-.008-.008-.008.012c-.015.01-.009.024-.017.017l.015-.018c-.013.012-.01,0-.011-.011a.052.052,0,0,1-.017.012c0,.005.005,0,.009,0s0,.026-.013.032-.015-.011-.029,0a2.293,2.293,0,0,0-.21.242c-.005,0,0,0,0-.007-.016.029-.034.052-.048.079a.035.035,0,0,1-.021,0,1.01,1.01,0,0,1-.092.141",
    transform: "translate(1.66 3.874)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507",
    transform: "translate(179.528 71.47)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(1.753 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M-.037-.041A.055.055,0,0,0-.074-.02.049.049,0,0,0-.037-.041",
    transform: "translate(0.074 0.041)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504",
    transform: "translate(1.753 0.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5375",
    "data-name": "Path 5375",
    d: "M0,0H0Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505",
    transform: "translate(0.309 2.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M0,.01.007,0A.036.036,0,0,0,0,.01",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506",
    transform: "translate(0 0.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M-1.232-3.534l.014.014c-.023.028-.025-.006-.042.022.014.028-.037.04-.032.059,0,0-.013.011-.019,0,.009.014-.008.015-.011.025s.005,0,.011,0l-.011.021c-.01,0-.018,0-.013-.009-.043.043-.242.26-.278.316.015,0,.022-.02.04-.014,0,.02-.019.018-.015.031-.026-.013-.03.025-.059.018l.008.014h-.013c-.036.069-.005.018-.051.068-.023.032-.019.06-.038.072,0,0,.015,0,.012.007-.012-.007-.01.027-.023.022s-.027.033-.006.036c-.01,0-.032.018-.027,0-.006.007-.015.013-.016.02l.012-.006c-.019.026-.042.031-.042.059l.013-.005c-.012.016-.021.03-.04.024l.008-.019a.219.219,0,0,0-.041.069l.007-.008C-1.894-2.654-2-2.5-2-2.466l.02,0-.008.029s-.028-.04-.022-.039c-.036.047-.222.288-.264.324-.02.012-.02-.011-.022-.013-.013.024,0,.019-.011.035s-.008-.008-.008-.012-.015.013-.01.018.022.009.034.013l-.02.021L-2.317-2.1s.014.032-.01.051c-.034.034-.065.076-.1.112,0-.005,0-.015,0-.026,0,.005-.009.014-.017.015.017,0-.007.021,0,.017,0,.044-.05.064-.056.1.017.018.283.322.306.34a.044.044,0,0,1-.017.015c.007,0,.021-.01.025-.02l-.011-.011c.011-.022.011,0,.025-.017.011.007,0,.025-.012.04.012-.012.029-.019.023-.033.014-.008.011.012.027,0s.008-.034.023-.041l0,0c.034-.02.022-.056.054-.074v.005c.014,0,.021-.029.041-.041-.006,0-.016,0-.01-.01.022-.014.027-.033.047-.04l0-.022c.058-.066.264-.344.319-.413v0c.08-.107.256-.318.331-.436.023-.009.04-.033.057-.048-.012.006-.016,0-.009-.01.044-.052,0-.009.036-.066a3.162,3.162,0,0,1,.3-.341c.01-.04.051-.068.066-.1v.006c.02-.035.176-.2.2-.238l-.006,0c.017-.038.029-.021.054-.041-.019-.01-.006-.044,0-.056l0,0a.783.783,0,0,1,.043-.091l.008.008a.325.325,0,0,1,.057-.081.505.505,0,0,0,.118-.128l.05-.01,0-.006S-.6-4.076-.71-4.067l-.008-.008-.009.013c-.016.012-.012.026-.02.018l.017-.019c-.014.013-.01,0-.011-.011a.072.072,0,0,1-.019.013c0,.006.006,0,.009,0s0,.028-.016.034-.015-.011-.03.006c-.082.086-.166.167-.241.262-.006,0,0,0,0-.008-.02.031-.041.055-.059.083a.032.032,0,0,1-.022,0,.974.974,0,0,1-.113.148",
    transform: "translate(2.492 4.075)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511",
    transform: "translate(177.443 71.687)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508",
    transform: "translate(1.034 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M-.026-.01c-.012-.005-.019,0-.027.006C-.04,0-.032,0-.026-.01",
    transform: "translate(0.053 0.012)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(0.31 1.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M0,.006,0,0A.008.008,0,0,0,0,.006",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510",
    transform: "translate(0 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M-.711-2.284l.014.015c-.013.015-.021-.012-.029.006.016.025-.024.02-.017.035,0,0-.009,0-.015,0,.01.013,0,.01-.005.017s0,0,.009,0L-.76-2.2c-.007,0-.015-.005-.012-.011a1.369,1.369,0,0,0-.17.164c.012,0,.014-.009.03,0,0,.014-.013.008-.008.018-.023-.016-.02.011-.045,0l.01.012-.011,0c-.017.042,0,.013-.03.038-.013.018,0,.04-.019.043,0,0,.012,0,.011.009-.011-.009,0,.018-.015.011s-.017.017,0,.025c-.009,0-.022.005-.022-.007,0,0-.01.005-.01.011l.009,0c-.011.016-.028.013-.024.033h.01c-.006.009-.012.017-.028.007l0-.012a.08.08,0,0,0-.022.04l0,0c0,.027-.058.112-.054.141l.016,0,0,.019S-1.165-1.7-1.16-1.7a1.679,1.679,0,0,1-.158.173c-.015,0-.018-.014-.02-.016-.006.015.007.015,0,.023s-.008-.008-.008-.011-.01.006-.006.011.02.013.03.018l-.012.011-.008-.008s.016.028,0,.035-.039.041-.06.059c-.005-.005,0-.012,0-.019s-.005.008-.011.007c.014,0,0,.014.005.013.007.033-.029.035-.027.061s.283.317.3.337c0,0-.009.007-.011.007S-1.13-1-1.129-1l-.011-.012c.005-.014.009,0,.017-.006.01.009,0,.019,0,.028C-1.118-1-1.1-1-1.112-1.011c.01,0,.011.011.022.007s0-.024.011-.025l0,0c.024-.006.008-.037.031-.042l0,0c.01,0,.012-.017.026-.02,0,0-.013,0-.009-.01s.016-.018.031-.018l0-.016c.035-.034.155-.188.187-.226v0a2.848,2.848,0,0,0,.194-.24c.017,0,.026-.014.038-.021-.009,0-.014-.007-.01-.01.027-.027,0-.008.018-.04a.963.963,0,0,1,.184-.177c0-.028.029-.038.035-.061l0,0c.01-.021.109-.1.122-.125h0c.007-.024.019-.008.036-.017a.033.033,0,0,1-.008-.041l0,0a.329.329,0,0,1,.02-.056l.008.008c0-.019.025-.037.031-.046s.062-.03.074-.065l.038.006v0s-.258-.29-.348-.313l-.008-.008-.005.008c-.012,0-.005.017-.013.008l.011-.009c-.01.005-.009,0-.011-.012a.022.022,0,0,1-.013.005s0,0,.008,0,0,.02-.008.021-.014-.012-.023,0A1.177,1.177,0,0,0-.592-2.4s0,0,0-.006c-.01.018-.024.03-.033.047a.035.035,0,0,1-.018-.006c.009,0-.063.082-.066.081",
    transform: "translate(1.439 2.559)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    transform: "translate(175.889 71.537)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512",
    transform: "translate(0.886 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M-.025-.012A.024.024,0,0,0-.05-.005c.013,0,.021,0,.025-.007",
    transform: "translate(0.05 0.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513",
    transform: "translate(0.336 1.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M0,.006,0,0A.012.012,0,0,0,0,.006",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514",
    transform: "translate(0 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M-.6-2.221l.015.014c-.012.015-.022-.01-.028.007.018.023-.021.02-.013.034,0,0-.008,0-.014,0,.01.012,0,.01,0,.016s0,0,.01,0l0,.013c-.007,0-.014,0-.013-.01A1.257,1.257,0,0,0-.8-1.98c.012,0,.013-.01.029,0s-.011.008-.006.018c-.023-.015-.018.012-.044,0l.011.012-.011,0c-.013.041,0,.013-.024.038s0,.039-.015.043.012,0,.012.008,0,.017-.014.011-.014.017,0,.024c-.009,0-.022.006-.022-.006,0,0-.009.006-.008.011l.008,0c-.009.015-.025.014-.02.033h.01c-.006.009-.011.016-.027.008l0-.012a.067.067,0,0,0-.018.04l0,0c0,.026-.046.11-.039.138l.017,0V-1.6s-.032-.035-.027-.033a1.492,1.492,0,0,1-.137.173c-.013,0-.019-.013-.021-.014,0,.014.008.014,0,.023s-.008-.008-.009-.011-.009.006,0,.011.02.012.031.017l-.011.011-.008-.007s.018.026,0,.034-.034.04-.052.059c-.005,0,0-.011,0-.018s0,.008-.011.007c.014,0,0,.013.007.012.01.032-.025.035-.021.06s.306.294.329.313c0,0-.008.007-.01.007A.011.011,0,0,0-.882-.97L-.894-.981c0-.013.009,0,.016-.007.011.008.006.018,0,.026s.02-.006.011-.018c.009,0,.011.011.022.007S-.847-1-.836-1l0,0c.023-.007,0-.035.026-.041l0,0c.01,0,.01-.017.023-.021,0,0-.013,0-.01-.009s.014-.017.028-.018l0-.015c.031-.035.132-.187.16-.225v0a2.661,2.661,0,0,0,.165-.239c.017,0,.024-.015.034-.021-.009,0-.014-.006-.01-.009.024-.027-.005-.008.014-.039A.887.887,0,0,1-.246-1.8c0-.027.025-.037.028-.06l0,0c.008-.021.1-.1.107-.125h0c.005-.024.018-.009.034-.018a.032.032,0,0,1-.012-.039l0,0a.256.256,0,0,1,.014-.055l.009.008c0-.019.021-.037.026-.046S.018-2.164.026-2.2l.038,0v0a1.774,1.774,0,0,0-.369-.288l-.008-.008,0,.008c-.011,0,0,.016-.012.008l.01-.01c-.009.006-.009,0-.012-.011a.019.019,0,0,1-.012.006s0,0,.007,0,0,.019,0,.021-.015-.011-.023,0A1.036,1.036,0,0,0-.5-2.338s0,0,0-.006c-.008.018-.02.029-.027.047a.037.037,0,0,1-.018,0c.009,0-.053.081-.056.081",
    transform: "translate(1.217 2.498)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519",
    transform: "translate(174.192 71.412)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516",
    transform: "translate(0.628 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M-.021-.044c-.013,0-.017.013-.021.022.013,0,.02-.012.021-.022",
    transform: "translate(0.042 0.044)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517",
    transform: "translate(0.374 2.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M0,.009,0,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518",
    transform: "translate(0 0.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M-.456-2.681l.019.008c-.007.023-.024,0-.026.022.025.017-.014.033,0,.045S-.471-2.6-.48-2.6c.014.009,0,.012,0,.02s.005,0,.01,0v.017c-.007,0-.016,0-.016,0-.018.037-.1.215-.106.257.013,0,.011-.016.03-.014s-.01.014,0,.023c-.027-.006-.015.021-.044.019l.013.009-.011,0c0,.053,0,.014-.017.054-.008.025.007.044-.006.055s.012,0,.013,0,0,.021-.012.018-.011.026.01.027c-.01,0-.021.016-.024,0,0,.006-.008.011-.006.016L-.636-2.1c-.006.021-.024.026-.015.046l.01,0c0,.012-.007.023-.026.02v-.015A.094.094,0,0,0-.677-2l0-.006c.008.028-.028.144-.018.173l.017,0,0,.022S-.71-1.844-.7-1.843a1.75,1.75,0,0,1-.123.251c-.014.01-.023-.009-.023-.009,0,.018.01.014,0,.027s-.01-.006-.011-.009-.009.009,0,.013.023.007.035.009l-.011.016-.01-.006s.022.024.007.038-.033.059-.052.085c-.006,0-.006-.012-.006-.02s0,.011-.01.012c.014,0,0,.016.007.013.012.034-.026.049-.02.076l.367.27c0,.006-.009.012-.012.012s.017-.008.017-.017L-.563-1.09c0-.017.011,0,.018-.013.012.006.006.02,0,.032.008-.01.021-.015.012-.026.01-.008.013.009.024,0s0-.028.01-.034h0c.025-.017,0-.045.028-.061l0,.005c.011,0,.01-.024.025-.034,0,0-.015,0-.011-.008s.015-.027.03-.033l0-.018c.033-.054.132-.284.156-.342v0a2.877,2.877,0,0,0,.14-.369C-.115-2-.109-2.017-.1-2.03c-.008.007-.015,0-.012-.006.019-.044-.007-.006.006-.054a2.043,2.043,0,0,1,.123-.3c-.009-.031.015-.059.012-.088l0,0C.035-2.5.1-2.654.1-2.689l0,0c0-.031.015-.022.027-.042C.1-2.73.1-2.756.1-2.765l0,0a.594.594,0,0,1,0-.074l.011,0C.1-2.856.117-2.89.119-2.9a.25.25,0,0,0,.038-.119L.2-3.043l0-.005a1.4,1.4,0,0,0-.459-.093l-.011,0v.011c-.009.011,0,.02-.008.016l.006-.017c-.006.012-.01,0-.015,0A.043.043,0,0,1-.3-3.125s.005,0,.007,0,.011.019,0,.026-.018,0-.022.011c-.027.075-.059.147-.078.223-.005,0,0,0-.006,0-.006.038,0,.028-.011.067a.034.034,0,0,1-.018,0,.41.41,0,0,1-.029.119",
    transform: "translate(0.922 3.146)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520",
    transform: "translate(173.856 68.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M0-.044a.023.023,0,0,0,.01.022c0-.013,0-.02-.01-.022",
    transform: "translate(0 0.044)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    transform: "translate(175.128 69.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M0,.008,0,0A.015.015,0,0,0,0,.008",
    transform: "translate(0.003)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522",
    transform: "translate(173.866 67.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M-.243-.9-.23-.916c.013.01-.012.02,0,.026.023-.017.016.019.03.011a.012.012,0,0,1,0,.013c.012-.01.008,0,.014,0s0,0,.005-.008l.012,0c0,.007-.007.014-.011.012.016.023.093.128.114.148.007-.01,0-.013.008-.027s0,.012.015.008c-.02.019,0,.018-.014.039L-.045-.7-.05-.687c.033.018.012,0,.026.028s.034.009.032.021S.014-.648.02-.646c-.012.008.015.005,0,.014s.011.016.024,0c-.007.007,0,.02-.014.018S.035-.6.04-.6l0-.008c.01.012,0,.026.02.026l0-.009c.006.008.011.014,0,.025L.053-.573a.052.052,0,0,0,.028.026l0,0c.023.005.074.073.1.079L.19-.485l.016.008a.289.289,0,0,1-.041.01.648.648,0,0,1,.066.183C.226-.274.208-.278.208-.278s.016,0,.018.012-.011,0-.014,0,0,.009.006.008S.239-.266.25-.271l0,.013-.011,0s.032,0,.029.015a.634.634,0,0,0,.01.069A.021.021,0,0,1,.263-.178s0,.007,0,.011.01.008.014,0c.03.012.007.037.028.05L.757-.125a.029.029,0,0,1,0,.015c.006,0,.008-.015,0-.021H.744C.737-.146.753-.136.75-.15c.013,0,.017.012.02.023C.77-.138.778-.15.763-.153c0-.011.016,0,.02-.013S.764-.184.771-.2h0C.783-.222.75-.23.758-.254l.005,0C.769-.261.756-.275.761-.29c0,0-.01.009-.013,0S.742-.316.75-.329L.736-.338A1.581,1.581,0,0,0,.617-.65l0,0A1.207,1.207,0,0,0,.436-.941c0-.018-.01-.032-.015-.046,0,.01-.009.012-.012.007C.385-1.015.4-.977.371-1.008S.221-1.192.2-1.229c-.028,0-.041-.033-.067-.041H.134A1.936,1.936,0,0,0-.014-1.4l0,0c-.027-.005-.013-.02-.026-.036-.009.018-.034.015-.041.012l0,0c-.012,0-.044-.006-.064-.013l.007-.009c-.021,0-.046-.019-.057-.024s-.051-.056-.091-.059l-.008-.04,0,0a1.972,1.972,0,0,0-.192.427l-.006.01.007,0c.006.009.015,0,.009.009l-.01-.007c.007.007,0,.01-.007.014a.021.021,0,0,1,.006.01s0,0,0-.008.016-.008.019,0-.008.016,0,.022c.043.032.079.068.124.1,0,0,0,0-.006,0l.041.019a.043.043,0,0,1-.006.017c0-.009.07.041.068.045",
    transform: "translate(0.492 1.565)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    transform: "translate(175.698 67.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M-.005-.062a.032.032,0,0,0,0,.031.027.027,0,0,0,0-.031",
    transform: "translate(0.011 0.062)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524",
    transform: "translate(175.7 67.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M0,0H0Z",
    transform: "translate(0 0.001)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    transform: "translate(177.016 68.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M0,.008l0-.008A.015.015,0,0,0,0,.008",
    transform: "translate(0.009)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4526",
    "data-name": "Group 4526",
    transform: "translate(175.7 66.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M-.17-1.788-.15-1.8c.011.022-.018.017,0,.035.03,0,.013.035.03.035,0,0,0,.011-.007.014.015,0,.008.009.015.014s0,0,.007-.008l.012.012c0,.008-.01.013-.015.008a2.124,2.124,0,0,0,.107.264C0-1.432-.011-1.44,0-1.454c.014.007,0,.017.016.018C0-1.42.025-1.41,0-1.39l.016,0-.007.01c.037.04.013.007.028.05.013.023.038.026.037.042,0,0,.006-.011.012-.007-.012.007.016.013.005.022,0,.005.012.025.026.011-.007.008,0,.027-.014.019s0,.014.008.016v-.01c.012.019,0,.036.025.042l0-.011c.007.012.013.021,0,.034l-.011-.01a.1.1,0,0,0,.032.044l0-.006c.027.014.092.118.122.128l.009-.015.019.012s-.047.011-.042.008a2.6,2.6,0,0,1,.12.256c0,.017-.02.012-.022.013s.017,0,.022.015-.011,0-.014,0,0,.013.009.011S.4-.731.411-.739l.007.018-.01,0s.032,0,.035.017.027.062.038.094c-.007,0-.013,0-.019-.007S.469-.6.466-.6c.007-.013.013.009.015,0,.035.011.025.049.051.061.023-.009.4-.135.43-.147,0,.006,0,.012,0,.015s0-.018,0-.022L.947-.685C.936-.7.954-.692.947-.705c.011-.007.02.005.026.016,0-.011,0-.025-.014-.023,0-.012.015-.006.015-.019S.949-.744.952-.757h0C.956-.786.92-.785.923-.811H.928c0-.011-.013-.021-.012-.038,0,.005-.007.013-.012.005S.892-.87.9-.885L.879-.891C.856-.945.743-1.15.716-1.2h0C.676-1.282.6-1.452.544-1.529.549-1.548.538-1.565.536-1.58c0,.01-.011.011-.013.005C.5-1.617.514-1.574.49-1.614A1.405,1.405,0,0,1,.373-1.9c-.027-.016-.028-.05-.049-.068h0C.312-1.988.263-2.133.245-2.158v0c-.022-.02,0-.024-.005-.047C.221-2.19.2-2.206.2-2.214l0,0a.456.456,0,0,1-.049-.05l.01,0C.142-2.281.133-2.314.126-2.326a.241.241,0,0,0-.04-.111L.1-2.474l0,0s-.368.122-.421.205l-.01,0,.005.009c0,.014.015.014,0,.018l-.006-.017c0,.014-.007.008-.015.006a.04.04,0,0,1,0,.016c.005,0,0,0,0-.006s.02.009.019.019-.016.008-.011.023a1.756,1.756,0,0,0,.083.226s0,0-.007,0c.014.021.022.041.036.059A.032.032,0,0,1-.229-1.9c.007-.007.061.108.059.111",
    transform: "translate(0.343 2.476)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527",
    transform: "translate(177.17 66.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M0-.063A.031.031,0,0,0,0-.031.028.028,0,0,0,0-.063",
    transform: "translate(0.009 0.063)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528",
    transform: "translate(177.174 66.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M0,0H0",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4529",
    "data-name": "Group 4529",
    transform: "translate(178.625 68.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5396",
    "data-name": "Path 5396",
    d: "M0,.007l0-.007A.013.013,0,0,0,0,.007",
    transform: "translate(0.009)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4530",
    "data-name": "Group 4530",
    transform: "translate(177.174 66.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5397",
    "data-name": "Path 5397",
    d: "M-.208-1.739l.019-.009c.012.022-.017.018,0,.035.029-.006.016.035.033.035,0,0,0,.012-.006.015.015,0,.009.009.016.013s0,0,.007-.008l.012.012c0,.008-.008.014-.013.008a2.13,2.13,0,0,0,.129.265c.008-.011-.006-.02.007-.033C.01-1.4,0-1.389.012-1.39c-.022.018.007.027-.014.048l.015,0-.005.01c.04.039.013.007.032.05.015.023.04.024.04.041,0,0,0-.012.012-.007-.012.007.018.012.007.022,0,.005.014.026.027.01-.007.008,0,.027-.013.02,0,.007,0,.014.009.016v-.011c.014.019.007.037.029.042l0-.011c.007.011.014.021,0,.034l-.012-.01a.108.108,0,0,0,.037.043l0-.006c.027.012.1.116.132.125L.318-.992l.02.011S.292-.967.3-.971a2.5,2.5,0,0,1,.142.255C.438-.7.419-.7.416-.7.43-.688.434-.7.44-.687s-.01.005-.013,0,0,.013.01.011S.455-.688.463-.7l.009.019-.011,0s.033,0,.037.016S.531-.6.544-.565c-.006,0-.013,0-.02-.006s.007.009,0,.015c.007-.013.014.008.015,0C.58-.546.573-.506.6-.5c.022-.01.394-.161.42-.175a.045.045,0,0,1,0,.016A.018.018,0,0,0,1.02-.677L1-.671c-.013-.012.007-.008,0-.022.011-.007.02.005.027.016,0-.011,0-.026-.016-.023,0-.013.014-.007.013-.021S1-.732,1-.745h0C1-.776.97-.772.97-.8H.975C.978-.81.961-.82.96-.837c0,.006-.007.013-.013.006S.934-.858.937-.874l-.017,0C.893-.934.762-1.137.73-1.19l0,0c-.05-.079-.141-.249-.2-.326,0-.019-.009-.036-.013-.051,0,.01-.01.012-.013.005C.484-1.6.5-1.559.469-1.6a1.5,1.5,0,0,1-.141-.284C.3-1.9.3-1.933.273-1.95H.278C.259-1.971.2-2.117.178-2.142v.006c-.023-.02,0-.026-.009-.049-.017.013-.038,0-.044-.01l0,0a.529.529,0,0,1-.053-.049l.01,0C.065-2.262.053-2.3.045-2.307a.246.246,0,0,0-.05-.112L.01-2.458l-.005,0s-.36.146-.406.234l-.01,0,.006.009c0,.015.016.014.006.018l-.008-.017C-.4-2.2-.412-2.2-.42-2.2a.037.037,0,0,1,0,.016c.005,0,0,0,0-.007s.021.008.02.018-.015.01-.009.024a1.862,1.862,0,0,0,.1.227s0,0-.007,0c.016.02.026.04.041.058a.031.031,0,0,1-.01.017c.007-.008.07.107.069.111",
    transform: "translate(0.42 2.46)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4531",
    "data-name": "Group 4531",
    transform: "translate(179.181 65.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5398",
    "data-name": "Path 5398",
    d: "M0-.063A.034.034,0,0,0,0-.031.029.029,0,0,0,0-.063",
    transform: "translate(0.004 0.063)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4532",
    "data-name": "Group 4532",
    transform: "translate(180.562 67.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5399",
    "data-name": "Path 5399",
    d: "M0,.01,0,0A.033.033,0,0,0,0,.01",
    transform: "translate(0.005)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4533",
    "data-name": "Group 4533",
    transform: "translate(179.189 65.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5400",
    "data-name": "Path 5400",
    d: "M-.27-1.971l.018-.01c.014.022-.016.019,0,.036.029-.007.018.035.035.034,0,0,0,.012,0,.015.015,0,.009.009.016.013s0,0,.006-.008l.013.012c0,.008-.009.014-.013.009.017.04.1.231.126.271.008-.01-.005-.02.009-.033.015.007,0,.018.016.018-.022.016.006.028-.015.048l.015,0-.006.009c.037.043.013.008.029.054.013.025.038.029.037.046,0,0,.005-.012.012-.007-.012.007.016.014.005.023,0,.006.012.028.026.014-.007.007,0,.028-.015.019,0,.007,0,.014.008.018l0-.011c.011.021,0,.038.023.047l0-.011c.006.013.012.023,0,.035L.063-1.344A.115.115,0,0,0,.094-1.3l0-.007c.026.017.083.136.111.151l.01-.015.017.016a.213.213,0,0,1-.043,0,1.609,1.609,0,0,1,.081.292c0,.017-.023.008-.023.008.009.018.016.005.019.021s-.011,0-.014,0,0,.014.007.013.021-.01.031-.016l0,.021-.011,0S.314-.8.312-.782s.013.072.017.107C.322-.674.317-.68.311-.687s0,.012,0,.016.011.014.014.006c.032.021.011.058.033.078L.815-.6a.052.052,0,0,1,0,.019c.006,0,.007-.019,0-.027H.8C.792-.625.809-.612.805-.63c.013,0,.018.014.021.029,0-.014.007-.029-.008-.032,0-.014.016,0,.019-.018S.817-.674.823-.688h0C.834-.72.8-.732.807-.761l.005,0C.817-.77.8-.788.808-.807.807-.8.8-.8.794-.805S.788-.84.795-.856L.78-.868a3.478,3.478,0,0,0-.123-.41l0,0a2.5,2.5,0,0,0-.175-.411.144.144,0,0,0-.012-.061c0,.012-.01.012-.013,0-.022-.051-.009,0-.038-.049a3.522,3.522,0,0,1-.157-.333C.235-2.142.227-2.181.2-2.2H.207C.186-2.226.1-2.388.074-2.416v.006C.046-2.43.065-2.438.056-2.463c-.015.015-.041,0-.048-.009l0,0C0-2.486-.036-2.505-.054-2.524l.009-.006C-.068-2.54-.089-2.576-.1-2.588A.3.3,0,0,0-.18-2.7l0-.045-.006,0s-.324.214-.35.311l-.009.007.008.008c0,.014.019.01.01.017l-.011-.015c.006.013,0,.009-.013.009A.033.033,0,0,1-.54-2.4c.006,0,0,0,0-.007s.022,0,.024.014-.014.012,0,.025c.047.072.086.145.137.214,0,0,0,0-.007,0L-.34-2.1a.032.032,0,0,1-.008.018c.005-.009.08.1.078.107",
    transform: "translate(0.546 2.75)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4534",
    "data-name": "Group 4534",
    transform: "translate(181.529 65.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5401",
    "data-name": "Path 5401",
    d: "M0-.063A.032.032,0,0,0,0-.031.028.028,0,0,0,0-.063",
    transform: "translate(0.007 0.063)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4535",
    "data-name": "Group 4535",
    transform: "translate(182.849 67.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5402",
    "data-name": "Path 5402",
    d: "M0,.009l0-.009A.014.014,0,0,0,0,.009",
    transform: "translate(0.006)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4536",
    "data-name": "Group 4536",
    transform: "translate(181.533 65.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5403",
    "data-name": "Path 5403",
    d: "M-.216-1.912-.2-1.92c.012.022-.017.017,0,.035.03-.005.015.035.032.035,0,0,0,.011-.007.014.016,0,.009.009.015.014s0,0,.007-.008l.012.012c0,.008-.009.014-.014.008.014.04.088.231.112.27.008-.01,0-.02.01-.032.015.007,0,.018.016.018-.023.015,0,.027-.018.047l.016,0L-.024-1.5c.036.042.012.008.027.053.012.024.037.028.036.046,0,0,.006-.012.012-.007-.012.007.017.014.005.022,0,.006.012.027.026.013-.007.007,0,.027-.015.019s0,.014.007.017l0-.01c.011.02,0,.037.023.045l0-.011c.006.012.011.022,0,.034L.088-1.29a.11.11,0,0,0,.03.048l0-.006c.026.016.084.129.113.144l.01-.015.018.015a.225.225,0,0,1-.043,0,1.949,1.949,0,0,1,.093.278c0,.018-.023.01-.023.01C.294-.8.3-.811.3-.8s-.011,0-.013,0,0,.014.007.012S.318-.793.328-.8l0,.02-.011,0s.033,0,.033.024.018.069.024.1c-.007,0-.013,0-.018-.01s0,.011,0,.016c.009-.011.011.012.015,0,.033.017.016.055.04.071L.867-.632a.043.043,0,0,1,0,.017c.006,0,.006-.018,0-.024l-.016,0c-.01-.016.008-.006,0-.022.013,0,.019.01.024.023,0-.012,0-.026-.011-.028,0-.013.016,0,.018-.018S.864-.7.869-.714h0C.876-.745.841-.752.847-.78l0,0C.856-.789.842-.8.845-.823c0,.006-.009.012-.013,0s-.009-.03,0-.047L.814-.876C.8-.941.7-1.186.679-1.247l0,0a2.866,2.866,0,0,0-.167-.378.122.122,0,0,0-.009-.056c0,.011-.011.011-.013,0-.019-.048-.009,0-.035-.046a2.319,2.319,0,0,1-.131-.314C.3-2.052.293-2.09.27-2.109H.276C.257-2.133.193-2.29.169-2.317v.006C.144-2.332.164-2.339.158-2.363c-.016.013-.039,0-.046-.012l0,0A.658.658,0,0,1,.06-2.428l.01,0C.048-2.445.034-2.48.025-2.492a.27.27,0,0,0-.06-.117l.012-.042-.005,0s-.35.167-.39.259l-.01.006.007.008c0,.015.016.013.006.018l-.008-.016c0,.013-.006.009-.014.008a.036.036,0,0,1,0,.016c.005,0,0,0,0-.008s.022.007.022.018-.015.01-.008.024c.036.075.066.151.109.223,0,0,0,0-.007,0l.041.058a.034.034,0,0,1-.01.017c.007-.008.069.107.067.11",
    transform: "translate(0.437 2.652)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4537",
    "data-name": "Group 4537",
    transform: "translate(183.521 65.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5404",
    "data-name": "Path 5404",
    d: "M0-.057A.027.027,0,0,0,0-.028C0-.041,0-.049,0-.057",
    transform: "translate(0.008 0.057)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4538",
    "data-name": "Group 4538",
    transform: "translate(183.525 65.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5405",
    "data-name": "Path 5405",
    d: "M0,0H0Z",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4539",
    "data-name": "Group 4539",
    transform: "translate(184.76 67.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5406",
    "data-name": "Path 5406",
    d: "M0,.008l0-.008A.014.014,0,0,0,0,.008",
    transform: "translate(0.006)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540",
    transform: "translate(183.526 65.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5407",
    "data-name": "Path 5407",
    d: "M-.191-1.534l.018-.009c.011.019-.017.017,0,.031.029-.007.014.03.03.028a.013.013,0,0,1-.007.014c.015-.005.008.007.015.01s0,0,.007-.007l.011.009c0,.008-.01.013-.014.009a2.082,2.082,0,0,0,.1.227c.008-.009,0-.017.011-.029.014,0,0,.015.015.015-.023.015,0,.023-.018.042l.016,0-.007.009c.033.034.012.006.025.044.012.02.036.021.033.036,0,0,.007-.011.012-.007-.012.007.016.011,0,.019,0,0,.01.023.025.01-.008.007,0,.024-.015.018s0,.012.007.014l0-.009c.01.017,0,.032.021.037l0-.01c.006.011.011.019,0,.03l-.01-.009a.08.08,0,0,0,.029.039l0-.006c.024.012.078.107.106.116l.01-.013.017.011S.2-.859.2-.862a1.391,1.391,0,0,1,.084.235c0,.015-.023.009-.023.009s.017,0,.02.016S.272-.6.269-.6s0,.012.007.01S.3-.6.307-.609l0,.017L.3-.589s.032,0,.031.018.016.058.022.087c-.007,0-.012,0-.018-.008s0,.009,0,.013.011.01.014,0c.033.013.016.047.038.06L.837-.491a.031.031,0,0,1,0,.015.016.016,0,0,0,0-.022l-.016,0C.813-.509.831-.5.826-.515c.012,0,.018.009.023.02,0-.011,0-.024-.01-.025,0-.012.015,0,.017-.016S.835-.552.84-.563h0C.848-.591.813-.595.819-.62l.005,0C.83-.628.815-.64.819-.657c0,0-.009.011-.013,0S.8-.68.8-.7L.789-.7C.775-.758.687-.967.663-1.019h0A2.316,2.316,0,0,0,.511-1.34C.516-1.357.506-1.374.5-1.389c0,.01-.01.011-.012,0-.018-.04-.009,0-.033-.037a1.626,1.626,0,0,1-.12-.269C.311-1.7.308-1.737.286-1.752H.291c-.018-.02-.075-.155-.1-.177v.005c-.023-.017,0-.024-.01-.045a.035.035,0,0,1-.043-.007l0,0a.639.639,0,0,1-.053-.041L.1-2.024C.082-2.032.068-2.063.06-2.073a.2.2,0,0,0-.054-.1l.012-.038,0,0a1.57,1.57,0,0,0-.382.272l-.009.006.007.007c0,.013.015.01.005.015l-.007-.013c0,.011-.006.008-.014.008a.034.034,0,0,1,0,.014s0,0,0-.007.02,0,.02.013-.015.011-.009.022a1.862,1.862,0,0,0,.1.187s0,0-.007,0l.038.047a.034.034,0,0,1-.01.016c.007-.007.063.088.061.091",
    transform: "translate(0.386 2.213)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541",
    transform: "translate(184.418 63.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5408",
    "data-name": "Path 5408",
    d: "M0-.053a.027.027,0,0,0,.009.027C.01-.04.008-.048,0-.053",
    transform: "translate(0.002 0.053)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542",
    transform: "translate(184.428 63.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M0,0H0Z",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4543",
    "data-name": "Group 4543",
    transform: "translate(186.105 63.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M-.006,0-.013,0A.013.013,0,0,0-.006,0",
    transform: "translate(0.013)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544",
    transform: "translate(184.429 62.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5411",
    "data-name": "Path 5411",
    d: "M-.307-.634l.013-.015c.017.013-.009.022.009.03.024-.018.024.022.038.014,0,0,.006.008,0,.015.012-.011.01,0,.017,0s0,0,0-.01l.015,0c0,.008,0,.015-.009.013a1.491,1.491,0,0,0,.186.161c0-.013-.011-.014,0-.031.015,0,.01.012.02.007-.014.024.014.019,0,.046l.012-.011,0,.011c.045.015.013,0,.041.027s.041,0,.047.017c0,0,0-.012.007-.012S.108-.363.1-.35s.02.015.025,0c0,.009.008.023,0,.023,0,0,.007.009.013.008l0-.008c.017.009.016.027.036.022V-.319c.01.007.019.011.011.028l-.013,0a.079.079,0,0,0,.043.019l0,0c.027,0,.12.051.149.044l0-.017h.02S.341-.219.342-.223a1.855,1.855,0,0,1,.195.148c.005.014-.012.02-.014.021.016.005.015-.008.024,0S.54-.045.537-.045s.007.01.011,0S.559-.061.564-.072L.576-.06.569-.052S.6-.07.6-.055.651-.018.671,0c0,.005-.012,0-.019,0S.661.01.661.016c0-.014.014,0,.013-.007C.707,0,.713.037.739.033s.291-.31.309-.333c0,0,.008.008.008.011a.014.014,0,0,0-.011-.017l-.011.012c-.014,0,0-.01-.008-.017.007-.011.018-.005.027,0-.006-.007-.008-.02-.02-.012,0-.01.011-.012.005-.023s-.024,0-.027-.01l0,0C1.005-.38.975-.361.968-.384l0,0C.971-.4.954-.4.948-.411c0,0,0,.014-.009.011S.92-.416.918-.431L.9-.427C.863-.46.693-.57.651-.6h0C.588-.643.462-.743.388-.778.386-.8.37-.8.362-.815c0,.008-.005.014-.009.01C.323-.83.346-.8.311-.82a1.072,1.072,0,0,1-.2-.172c-.028,0-.042-.027-.066-.031l0,0c-.022-.009-.115-.1-.141-.115l0,0c-.026-.006-.011-.019-.022-.035a.033.033,0,0,1-.04.011l0,0a.427.427,0,0,1-.06-.016L-.2-1.188c-.02,0-.04-.023-.051-.029s-.038-.06-.074-.07l0-.039h0a1.622,1.622,0,0,0-.28.376l-.008.009.008,0c.006.011.018,0,.01.013L-.612-.935c.007.01,0,.01-.01.012a.026.026,0,0,1,.007.012s0,0,0-.007.02,0,.022.005-.01.015,0,.024A1.3,1.3,0,0,0-.44-.747c0,.005,0,0-.006,0,.02.009.033.022.052.03a.029.029,0,0,1,0,.018c0-.009.091.058.091.061",
    transform: "translate(0.622 1.326)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    transform: "translate(184.035 61.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5412",
    "data-name": "Path 5412",
    d: "M0-.027c.005.012.013.013.022.015C.015-.023.009-.029,0-.027",
    transform: "translate(0 0.027)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546",
    transform: "translate(185.622 61.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5413",
    "data-name": "Path 5413",
    d: "M-.007,0h0",
    transform: "translate(0.014 0.002)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4547",
    "data-name": "Group 4547",
    transform: "translate(184.027 61.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5414",
    "data-name": "Path 5414",
    d: "M-.412.59l0-.02c.019,0,.006.023.023.018.007-.029.029,0,.035-.012,0,0,.009,0,.008.012,0-.015.009,0,.015-.008s0,0,0-.009L-.319.565c0,.005.006.014,0,.016A1.335,1.335,0,0,0-.093.594c0-.012-.015,0-.019-.022S-.1.575-.094.564c0,.028.021.007.028.035l0-.016.005.01c.041-.016.01-.008.046,0C.008.586.018.564.029.572S.023.562.028.558c0,.014.014-.01.017,0C.051.56.068.562.062.544c0,.01.019.014.009.021.006,0,.011,0,.014,0L.079.559C.1.556.106.571.118.554L.111.546c.011,0,.019,0,.023.016L.124.568A.071.071,0,0,0,.167.557H.161C.18.537.277.522.294.5L.286.485.3.473S.294.519.293.515a1.516,1.516,0,0,1,.224,0c.012.008,0,.023,0,.025S.525.521.538.523s0,.012,0,.014.011,0,.011,0S.542.51.539.5L.555.5V.511S.563.48.578.487s.054,0,.08,0C.658.5.652.5.647.5s.009,0,.012,0C.652.5.67.5.665.5.684.468.709.493.726.474.727.45.762.051.762.021c.006,0,.011,0,.013,0A.012.012,0,0,0,.757.018V.034C.743.04.753.025.74.026S.751.01.761.009C.752.008.743,0,.739.012.731.007.74,0,.731-.009S.714.008.705,0V0C.686-.016.675.017.656,0l0,0C.652-.008.639,0,.628-.006s.006.012,0,.014S.6.008.594,0L.585.01C.537.008.351.026.3.028l0,0A2.658,2.658,0,0,0,.012.049C0,.036-.016.039-.028.035c.007.005,0,.014,0,.014-.036,0,0,.008-.039.014A.909.909,0,0,1-.312.051c-.02.018-.046,0-.066.016l0,0C-.4.069-.518.053-.542.059l0,0C-.561.073-.558.053-.575.047A.032.032,0,0,1-.6.08v0A.347.347,0,0,1-.651.1V.089C-.665.1-.693.1-.7.1S-.764.073-.8.088L-.818.055l0,0a1.748,1.748,0,0,0,.01.468V.538H-.8c.01.005.015-.008.014,0L-.8.539c.01,0,0,.01,0,.016A.035.035,0,0,1-.793.56s0,0,0-.007.013-.015.02-.01,0,.018.013.019A1.061,1.061,0,0,0-.572.582s0,0,0,.007c.019-.005.036,0,.054-.008A.039.039,0,0,1-.512.6c0-.009.1-.01.1-.008",
    transform: "translate(0.833 0.009)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4548",
    "data-name": "Group 4548",
    transform: "translate(182.641 59.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5415",
    "data-name": "Path 5415",
    d: "M0-.015a.028.028,0,0,0,.026.01C.017-.015.009-.019,0-.015",
    transform: "translate(0 0.017)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549",
    transform: "translate(183.929 58.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M0-.008-.01,0Z",
    transform: "translate(0.01 0.008)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    transform: "translate(182.542 58.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M-.538.88-.543.86c.02-.008.014.02.03.009,0-.029.031-.007.033-.024,0,0,.011,0,.013.009,0-.016.008-.006.013-.012s0,0-.007-.008l.012-.01c.007,0,.011.011.006.015A1.235,1.235,0,0,0-.206.762C-.215.753-.223.764-.235.749c.005-.013.015,0,.015-.014.014.024.024,0,.041.02l0-.015.009.007C-.137.714-.166.736-.128.723c.02-.012.022-.036.037-.034C-.091.689-.1.683-.1.677c.007.012.011-.016.019,0,0,0,.023-.01.009-.024.007.007.024,0,.018.015s.011,0,.013-.007l-.009,0c.017-.011.032,0,.036-.023l-.01,0c.01-.006.019-.012.03,0L0,.642A.077.077,0,0,0,.039.612l-.006,0C.044.588.132.528.137.5L.123.49.132.472S.147.516.143.513C.173.5.323.4.355.392c.015,0,.015.02.015.02S.367.4.379.391.384.4.383.4.4.4.392.395.377.377.368.368L.383.361l.006.01S.381.341.4.337.448.307.473.294a.021.021,0,0,1,0,.019s.008-.006.013,0C.471.3.49.3.482.295.485.26.521.267.526.241l-.22-.4c.005,0,.009,0,.012,0a.011.011,0,0,0-.017,0l.008.014C.3-.131.3-.148.292-.141.284-.151.292-.16.3-.166c-.008,0-.021,0-.016.014-.01,0-.008-.014-.019-.013s0,.022-.015.02v0c-.023,0-.015.033-.037.031v0C.2-.123.2-.108.182-.108c0,0,.012.007.007.012S.17-.085.157-.089l0,.016L-.072.076v0C-.13.112-.26.174-.319.218c-.016-.007-.028,0-.04,0,.008,0,.009.012,0,.013-.033.012,0,.009-.03.027A.71.71,0,0,1-.612.336C-.625.36-.653.355-.668.372V.367C-.685.382-.8.4-.825.413l0,0c-.017.016-.02,0-.037-.005A.033.033,0,0,1-.871.448v0C-.882.45-.9.474-.916.481l0-.011C-.929.486-.957.488-.967.491S-1.031.482-1.059.5L-1.085.477l0,0A1.627,1.627,0,0,0-.976.935l0,.012.008,0c.012,0,.015-.011.016,0l-.015,0c.012,0,.006.008,0,.015a.028.028,0,0,1,.014,0c0-.005,0,0-.005-.007S-.943.94-.934.943s0,.017.018.016A.96.96,0,0,0-.709.924s0,0,0,.008C-.69.921-.671.918-.654.907A.036.036,0,0,1-.641.92c-.006-.008.1-.04.1-.04",
    transform: "translate(1.088 0.166)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4551",
    "data-name": "Group 4551",
    transform: "translate(182.285 58.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M0-.01a.035.035,0,0,0,.034,0A.032.032,0,0,0,0-.01",
    transform: "translate(0 0.014)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4552",
    "data-name": "Group 4552",
    transform: "translate(182.319 58.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M0,0H0Z",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4553",
    "data-name": "Group 4553",
    transform: "translate(183.818 56.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5420",
    "data-name": "Path 5420",
    d: "M-.006-.013l-.006.007Z",
    transform: "translate(0.012 0.013)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4554",
    "data-name": "Group 4554",
    transform: "translate(182.126 56.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M-.705,1.011-.713.992c.024-.013.018.017.038,0,0-.03.039-.016.04-.034,0,0,.012,0,.016.006,0-.016.01-.009.015-.016s0,0-.008-.007L-.6.929c.009,0,.014.008.009.013A1.787,1.787,0,0,0-.3.794C-.314.788-.323.8-.337.79-.332.774-.319.783-.319.77-.3.791-.291.761-.268.779l0-.015.011,0C-.22.724-.254.756-.208.73-.184.712-.184.686-.165.684c0,0-.013,0-.008-.011.008.011.012-.019.023-.01.005-.006.027-.018.01-.029.009.006.029,0,.023.01C-.112.642-.1.64-.1.633H-.113C-.094.618-.074.622-.07.6H-.082C-.07.589-.061.58-.045.592l-.01.013A.123.123,0,0,0-.011.562l-.007,0C-.006.536.1.443.1.41L.084.4.094.382s.02.043.015.041C.145.4.32.244.356.223c.018,0,.018.018.018.018C.387.223.372.223.385.213S.392.222.391.225.4.219.4.213.382.2.371.193L.389.18.4.189S.385.158.405.148.463.1.492.075C.5.081.493.089.49.1S.5.088.505.089C.49.086.511.072.5.073.5.034.546.029.551,0L.274-.362A.029.029,0,0,1,.288-.37c-.006,0-.018,0-.02.011l.01.012c-.008.016-.009,0-.02.008-.009-.008,0-.02.008-.03-.01.007-.024.008-.018.021-.012,0-.01-.013-.023-.008s0,.027-.017.029l0,0C.177-.322.19-.288.163-.283v0c-.012,0-.017.019-.033.023.005,0,.014,0,.008.011S.115-.235.1-.233v.017c-.046.038-.22.2-.268.241v0c-.07.061-.227.17-.3.235-.019,0-.035.011-.05.017.01,0,.013.009.006.012-.041.023,0,.009-.036.039A1.185,1.185,0,0,1-.829.469C-.843.5-.879.5-.9.522V.517c-.022.02-.17.072-.2.091h.005c-.021.022-.026,0-.049.005.011.018-.006.038-.014.043l0,0A.37.37,0,0,1-1.206.7l0-.011c-.013.018-.049.027-.061.034A.269.269,0,0,0-1.388.76L-1.424.74l0,0s.089.379.173.434l0,.011.011-.006c.016,0,.017-.015.02,0l-.019.006c.015,0,.008.007,0,.015a.042.042,0,0,1,.018,0c0-.005,0,0-.007-.005s.012-.02.023-.019.008.017.024.012A1.585,1.585,0,0,0-.916,1.1s0,0,0,.007c.024-.016.048-.024.068-.039a.034.034,0,0,1,.017.011c-.008-.007.126-.069.126-.069",
    transform: "translate(1.427 0.371)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4555",
    "data-name": "Group 4555",
    transform: "translate(181.905 55.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M0,0a.029.029,0,0,0,.03,0A.025.025,0,0,0,0,0",
    transform: "translate(0 0.01)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4556",
    "data-name": "Group 4556",
    transform: "translate(183.111 54.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M-.006-.011l-.006.006A.016.016,0,0,0-.006-.011",
    transform: "translate(0.012 0.011)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557",
    transform: "translate(181.625 54.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M-.691.806-.7.789c.018-.014.019.015.033,0C-.679.759-.638.769-.641.752c0,0,.01,0,.015,0C-.633.742-.62.747-.617.74s0,0-.009-.006L-.617.721c.008,0,.015.007.01.012A1.8,1.8,0,0,0-.383.584C-.394.577-.4.592-.415.58-.412.565-.4.573-.4.561c.02.02.024-.009.047.008L-.361.555l.01,0c.03-.042,0-.013.041-.036C-.291.507-.294.482-.279.48c0,0-.012,0-.009-.01C-.279.48-.28.452-.268.461S-.247.445-.263.434c.008.005.025,0,.021.01.005,0,.012,0,.013-.01H-.238C-.223.42-.205.425-.2.4L-.215.4C-.206.393-.2.386-.183.4L-.19.41A.1.1,0,0,0-.156.371l-.006,0C-.154.346-.07.265-.068.234L-.084.228l.007-.02s.021.042.017.04A2.278,2.278,0,0,1,.153.086C.169.085.169.1.17.105.181.091.167.089.18.081s.006.01.005.013S.2.089.193.083.176.068.166.06L.183.051.188.06S.179.029.2.023.249-.014.276-.03c0,.005,0,.013,0,.02S.281-.018.287-.017C.274-.022.293-.03.285-.031c0-.036.04-.033.046-.06C.318-.112.114-.457.1-.481A.024.024,0,0,1,.11-.487a.015.015,0,0,0-.02.008L.1-.466C.09-.453.09-.471.078-.462c-.008-.01,0-.02.01-.028-.01.005-.024,0-.019.018C.058-.471.061-.486.049-.483S.042-.458.03-.458l0,0C0-.457.011-.423-.015-.42V-.425c-.011,0-.017.016-.033.018,0,0,.013,0,.007.011s-.022.016-.037.015l0,.017c-.047.031-.214.177-.258.212v0C-.4-.1-.545.005-.606.071c-.018,0-.032.012-.046.018.01,0,.013.008.008.012-.036.024,0,.008-.03.039A1.254,1.254,0,0,1-.914.3C-.923.331-.956.338-.968.361V.356c-.016.021-.142.093-.162.116h0C-1.14.5-1.149.478-1.169.484a.035.035,0,0,1,0,.044l0,0A.391.391,0,0,1-1.21.581l-.006-.01c-.007.02-.036.035-.046.044-.026.013-.073.024-.1.059L-1.4.663V.668s.2.334.287.37l.006.01.007-.008c.014,0,.01-.016.016-.007l-.014.009c.012-.005.009.005.009.013a.029.029,0,0,1,.015,0s0,0-.008,0,0-.021.014-.022.011.014.024.006A1.47,1.47,0,0,0-.848.914s0,0,0,.007C-.83.9-.812.892-.8.875A.032.032,0,0,1-.782.883C-.79.878-.694.805-.691.806",
    transform: "translate(1.397 0.49)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558",
    transform: "translate(181.649 53.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M0-.006a.027.027,0,0,0,.028,0C.016-.012.008-.013,0-.006",
    transform: "translate(0 0.011)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(182.803 52.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M-.005-.009-.011,0a.01.01,0,0,0,.006,0",
    transform: "translate(0.011 0.009)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560",
    transform: "translate(181.398 52.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M-.639.777-.649.759c.018-.012.018.016.031,0C-.627.733-.589.747-.592.73c0,0,.009,0,.013.006C-.584.721-.572.728-.569.721s0,0-.008-.006L-.568.7c.007,0,.013.009.009.013A1.405,1.405,0,0,0-.348.6C-.358.591-.364.6-.377.59c0-.014.014-.005.012-.016C-.347.6-.343.568-.322.587L-.328.573l.01.005c.028-.037,0-.012.039-.029C-.262.534-.264.51-.249.51-.25.511-.26.505-.257.5-.249.51-.249.483-.239.493S-.219.48-.234.467c.007.006.024,0,.02.013C-.209.477-.2.477-.2.472H-.21C-.2.458-.18.465-.179.444l-.01,0c.009-.007.016-.013.029,0L-.165.452A.076.076,0,0,0-.133.418l-.005,0C-.131.395-.051.326-.048.3L-.062.289-.056.271s.018.043.015.04A1.738,1.738,0,0,1,.161.18C.175.18.174.2.176.2s0-.016.009-.022S.19.188.19.191.2.188.2.182.182.165.173.157L.188.149l.005.01S.185.128.2.124.252.094.277.082A.021.021,0,0,1,.274.1S.282.094.287.1C.275.09.293.084.286.082.288.048.324.055.329.03.317.008.136-.35.12-.374c.005,0,.01-.005.013,0a.013.013,0,0,0-.019,0L.122-.36C.113-.348.114-.366.1-.358.1-.368.105-.377.113-.384.1-.38.091-.383.1-.369S.088-.382.076-.381.069-.358.058-.36v0c-.026,0-.018.034-.041.033v0C0-.335,0-.32-.016-.32c0,0,.013.007.007.012S-.03-.3-.044-.3l0,.016c-.044.025-.2.146-.245.175v0A3.115,3.115,0,0,0-.544.077c-.017,0-.03.008-.042.012C-.578.09-.576.1-.581.1c-.033.02,0,.009-.028.034A1.022,1.022,0,0,1-.836.264c-.008.027-.039.03-.051.051V.31C-.9.328-1.021.383-1.04.4h0c-.014.022-.022,0-.04.008a.034.034,0,0,1,0,.042l0,0A.408.408,0,0,1-1.116.5l-.006-.01c-.007.019-.034.03-.043.037-.024.01-.069.015-.09.046L-1.291.556v0a1.64,1.64,0,0,0,.258.391l.006.01.007-.006c.013,0,.01-.015.015-.005L-1.02.957c.011,0,.008.006.008.014A.025.025,0,0,1-1,.97c0-.005,0,0-.007,0s0-.02.013-.019.01.015.022.01A1.273,1.273,0,0,0-.788.862s0,0,0,.007C-.771.853-.755.845-.741.831A.039.039,0,0,1-.725.84C-.733.834-.642.775-.639.777",
    transform: "translate(1.292 0.384)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561",
    transform: "translate(181.393 51.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M0-.009a.03.03,0,0,0,.03,0C.018-.014.009-.015,0-.009",
    transform: "translate(0 0.013)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562",
    transform: "translate(181.424 51.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563",
    transform: "translate(182.515 50.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M0-.011-.01-.005A.019.019,0,0,0,0-.011",
    transform: "translate(0.01 0.011)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564",
    transform: "translate(181.178 50.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M-.651.885-.66.867c.019-.013.018.016.033,0C-.635.839-.6.851-.6.835A.014.014,0,0,1-.583.84C-.589.825-.577.831-.573.824s0,0-.008-.006L-.572.805c.008,0,.014.008.01.013A1.428,1.428,0,0,0-.334.677C-.345.671-.351.685-.366.672c0-.015.016-.007.013-.018.019.02.024-.009.047.009L-.313.649l.01,0C-.273.611-.3.64-.261.618-.243.6-.246.576-.23.574c0,0-.012,0-.009-.011C-.23.574-.231.546-.22.555S-.2.538-.216.528c.009.006.025,0,.022.01.005,0,.012,0,.013-.011h-.01C-.177.514-.159.518-.158.5H-.169C-.16.486-.153.479-.137.49L-.144.5A.088.088,0,0,0-.112.462l-.005,0C-.111.438-.032.354-.032.323L-.048.318-.043.3s.024.041.019.038C0,.312.142.178.173.16c.015,0,.019.017.019.017C.2.162.186.161.2.153S.2.161.2.164.216.159.212.154.192.139.182.133L.2.122.2.131S.19.1.207.094.254.051.278.032c0,0,0,.012,0,.02S.285.043.29.044C.277.04.294.03.287.03c0-.036.035-.038.036-.065L.03-.383S.039-.39.042-.389a.013.013,0,0,0-.018.008l.01.012c-.005.013-.009,0-.017.006-.009-.009,0-.019,0-.027S0-.385.007-.372C0-.37,0-.384-.015-.381s0,.024-.013.025l0,0c-.024.006-.01.037-.033.041l0,0c-.01,0-.013.016-.028.019,0,0,.014,0,.009.011S-.1-.274-.115-.274v.016l-.213.213v0c-.055.056-.18.154-.234.215-.018,0-.03.01-.042.015.009,0,.012.009.007.012C-.628.216-.592.2-.622.23A.9.9,0,0,1-.846.37C-.853.4-.885.4-.9.422V.417c-.016.019-.137.073-.156.092h0c-.015.021-.022,0-.041.007a.034.034,0,0,1-.005.042l0,0A.285.285,0,0,1-1.134.6L-1.14.593c-.008.018-.036.029-.046.035-.025.01-.07.011-.094.04L-1.314.65l0,0a1.5,1.5,0,0,0,.225.41l0,.011.008-.006c.013,0,.012-.015.017,0l-.016.007c.013,0,.008.007.007.014a.038.038,0,0,1,.015,0c0-.005,0,0-.007,0s.007-.02.016-.019.009.016.023.01A1.162,1.162,0,0,0-.817.977s0,0,0,.007C-.8.968-.78.959-.764.944a.039.039,0,0,1,.017.01c-.008-.006.094-.069.1-.068",
    transform: "translate(1.316 0.391)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565",
    transform: "translate(181.515 49.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M0-.016c.007.011.012.01.017.011S0-.019,0-.016",
    transform: "translate(0 0.017)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566",
    transform: "translate(181.532 49.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(182.166 49.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M0,0l0,0A0,0,0,0,0,0,0",
    transform: "translate(0.006 0.004)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568",
    transform: "translate(181.354 49.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M-.387.691-.393.671c.01,0,.011.021.018.013C-.381.656-.358.681-.36.666c0,0,.005,0,.008.01,0-.015,0-.005.005-.01s0,0-.005-.009L-.347.65s.008.012.006.015A.412.412,0,0,0-.218.634c-.007-.01-.01,0-.018-.017s.008,0,.007-.01c.011.025.013,0,.026.027l0-.015L-.2.626C-.185.6-.2.617-.179.613S-.17.585-.162.59A.015.015,0,0,1-.167.577c.005.013,0-.012.01,0,0,0,.012,0,0-.021.005.008.014.009.012.018s.007,0,.007,0l-.006,0c.009-.006.019.006.019-.012L-.127.551s.009-.007.018.01l0,.008A.028.028,0,0,0-.095.549h0c0-.021.049-.054.05-.079L-.057.459l0-.014s.013.046.01.041A.508.508,0,0,1,.074.44c.009.006.009.021.01.023s0-.015,0-.016,0,.011,0,.013S.1.461.1.455.086.434.081.424l.008,0,0,.011S.087.4.1.4A.245.245,0,0,0,.14.393a.021.021,0,0,1,0,.016s0,0,.008,0S.15.4.145.4C.146.367.168.386.17.366S.044-.039.034-.067a.009.009,0,0,1,.008,0c0-.006-.01-.007-.011,0l0,.015c0,.008,0-.008-.011-.005s0-.017.005-.02S.016-.085.019-.071C.013-.075.014-.086.007-.089S0-.071,0-.076v0c-.015-.009-.01.024-.024.015v0c-.006-.006-.01.007-.018,0s.007.01,0,.013-.012,0-.021,0v.014C-.088-.037-.18.016-.2.026v0A.844.844,0,0,0-.35.1C-.36.092-.367.1-.375.1s.007.013,0,.013c-.019.006,0,.009-.016.02A.275.275,0,0,1-.519.165c0,.021-.022.013-.028.028v0C-.556.2-.626.206-.636.217l0,0c-.008.015-.013,0-.024-.007a.038.038,0,0,1,0,.036l0,0c0,.005-.011.027-.019.033l0-.011C-.686.28-.7.28-.708.283S-.748.272-.76.292L-.781.266v0A3.121,3.121,0,0,0-.618.708l0,.011,0,0c.007,0,.005-.01.009,0l-.008,0c.006,0,0,.008,0,.015A.014.014,0,0,1-.6.736s0,0,0-.006,0-.016.007-.013.006.017.013.016A.34.34,0,0,0-.473.714s0,0,0,.007S-.454.711-.446.7A.048.048,0,0,1-.437.717c0-.008.048-.028.05-.026",
    transform: "translate(0.782 0.089)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    transform: "translate(176.639 37.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M0-.014a.024.024,0,0,0,.025.007C.015-.015.008-.018,0-.014",
    transform: "translate(0 0.016)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570",
    transform: "translate(177.908 36.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M-.006-.006-.012,0l.006,0",
    transform: "translate(0.012 0.006)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572",
    transform: "translate(175.89 36.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M0,0a.023.023,0,0,0,.024,0C.012-.011,0-.011,0,0",
    transform: "translate(0 0.009)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573",
    transform: "translate(175.913 36.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574",
    transform: "translate(176.48 35.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M0-.008l0,0a.006.006,0,0,0,0,0",
    transform: "translate(0.007 0.008)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576",
    transform: "translate(151.499 49.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M0-.034c0,.013.011.015.019.018C.014-.029.009-.035,0-.034",
    transform: "translate(0 0.034)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(151.518 49.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4578",
    "data-name": "Group 4578",
    transform: "translate(152.775 48.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M0,0l0,0Z",
    transform: "translate(0.009 0.005)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4579",
    "data-name": "Group 4579",
    transform: "translate(151.506 48.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M-.379.76V.739c.018,0,.006.023.023.017.006-.028.029,0,.034-.013A.013.013,0,0,1-.312.755C-.31.739-.3.752-.3.747s0,0,0-.009L-.29.732c.005.005.006.014,0,.016A.905.905,0,0,0-.07.741C-.076.73-.085.739-.092.722s.014,0,.017-.01c.007.027.02,0,.03.031V.727l.006.009C0,.715-.031.728.005.726.025.72.031.7.044.7S.036.695.04.69c0,.013.013-.012.017,0C.062.689.078.688.07.671c0,.009.019.01.012.02s.01,0,.013,0l-.007,0C.1.677.116.689.123.671L.116.665c.01,0,.018-.006.025.011L.133.684A.062.062,0,0,0,.17.665H.165C.179.644.266.609.275.582L.265.57.275.555A.263.263,0,0,1,.278.6C.306.589.452.537.48.536.494.54.49.559.49.559S.491.543.5.54s0,.011,0,.014S.515.554.513.547.5.527.5.517l.015,0,0,.011s0-.032.013-.031S.575.477.6.471A.021.021,0,0,1,.594.489s.007,0,.012,0S.612.477.606.474C.613.442.643.457.651.434.643.41.517.031.508,0a.014.014,0,0,1,.01,0C.515,0,.506,0,.5,0L.509.017C.5.025.5.009.495.013.49,0,.5,0,.5-.008S.486-.013.489,0C.48,0,.483-.013.474-.016S.468,0,.459,0V0C.439-.009.444.025.425.017v0C.418.008.412.02.4.016S.409.025.4.029.388.035.377.028l0,.015C.339.053.205.113.169.123v0C.116.141,0,.164-.054.189-.065.178-.077.183-.087.181c.006,0,.006.013,0,.013C-.115.2-.086.2-.115.212A.469.469,0,0,1-.31.218C-.325.237-.346.224-.361.236l0,0C-.377.24-.474.223-.494.229l0,0C-.509.242-.506.223-.519.216a.033.033,0,0,1-.02.033v0c-.009,0-.029.02-.043.022V.255C-.593.267-.616.26-.624.261S-.671.232-.7.244L-.712.212l0,0A1.863,1.863,0,0,0-.758.68l0,.011h.009C-.743.7-.737.685-.739.7l-.013,0c.009,0,0,.01,0,.015A.025.025,0,0,1-.744.715s0,0,0-.008S-.732.695-.726.7s0,.018.01.02a.726.726,0,0,0,.183.03c0,.005,0,0,0,.007.02,0,.036,0,.054-.007A.036.036,0,0,1-.475.768c0-.01.1-.008.1-.008",
    transform: "translate(0.766 0.016)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4580",
    "data-name": "Group 4580",
    transform: "translate(151.428 46.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M0-.029a.021.021,0,0,0,.016.016C.011-.026.007-.03,0-.029",
    transform: "translate(0 0.029)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581",
    transform: "translate(151.443 46.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4582",
    "data-name": "Group 4582",
    transform: "translate(152.592 46.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M0,0H0",
    transform: "translate(0.01 0.002)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4583",
    "data-name": "Group 4583",
    transform: "translate(151.422 46.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M-.3.589V.568c.014,0,0,.023.017.018.005-.029.022,0,.026-.012,0,0,.006,0,.006.012,0-.016.006,0,.01-.008s0,0,0-.009L-.234.564c0,.005,0,.014,0,.016A.675.675,0,0,0-.068.593c0-.012-.012,0-.014-.022s.01,0,.013-.008c0,.027.015.007.02.034l0-.016,0,.01c.03-.016.007-.008.033,0S.013.563.022.571a.011.011,0,0,1,0-.014c0,.014.011-.01.013,0,0,0,.017,0,.012-.019,0,.01.014.014.007.021s.008,0,.011,0L.058.558c.013,0,.02.012.029-.005L.082.546C.089.544.1.543.1.561L.091.567A.041.041,0,0,0,.122.556h0C.132.537.2.521.216.5L.21.484.221.472S.216.518.214.514a.824.824,0,0,1,.165,0c.009.008,0,.023,0,.025s0-.015.014-.014,0,.011,0,.014S.4.539.4.532.4.509.4.5L.407.5V.51S.413.479.424.486a.451.451,0,0,0,.059,0A.023.023,0,0,1,.475.5s.007,0,.009,0C.479.5.491.5.488.494.5.467.52.492.532.473S.559.05.559.02c0,0,.008,0,.009,0A.008.008,0,0,0,.555.018V.033C.545.039.552.024.543.025S.551.009.558.008.545,0,.543.011C.536.006.543,0,.536-.01S.524.007.517,0V0C.5-.017.495.016.482,0l0,0C.478-.008.468,0,.46-.006s0,.012,0,.013S.443.007.436,0L.428.009C.394.007.258.025.223.027v0A1.457,1.457,0,0,0,.008.048C0,.035-.011.038-.02.034s0,.014,0,.014c-.027,0,0,.009-.029.014A.479.479,0,0,1-.228.05c-.015.018-.034,0-.048.016l0,0c-.016.007-.1-.01-.123,0l0,0C-.411.072-.409.052-.421.046A.033.033,0,0,1-.439.079v0C-.446.078-.464.1-.477.1V.088C-.487.1-.507.095-.516.1S-.561.072-.584.087L-.6.055l0,0A2.347,2.347,0,0,0-.595.525V.537l.006,0c.007.006.011-.008.01,0l-.01,0c.008,0,0,.009,0,.016A.014.014,0,0,1-.581.559s0,0,0-.007.01-.015.015-.01,0,.018.009.02a.6.6,0,0,0,.14.019c0,.005,0,0,0,.007.014-.005.027,0,.04-.009A.033.033,0,0,1-.375.6C-.377.587-.3.586-.3.589",
    transform: "translate(0.611 0.01)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4584",
    "data-name": "Group 4584",
    transform: "translate(151.82 44.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M0-.035a.018.018,0,0,0,.009.018c0-.012,0-.018-.009-.018",
    transform: "translate(0 0.035)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585",
    transform: "translate(152.808 44.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M0,0h0S0,0,0,0",
    transform: "translate(0.007 0.002)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4586",
    "data-name": "Group 4586",
    transform: "translate(151.828 44.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M-.2.437-.2.417c.011,0,0,.023.009.021C-.18.411-.174.444-.168.43c0,0,0,0,0,.013.005-.015.006,0,.01-.006s0,0,0-.01l.008,0c0,.006,0,.015,0,.016A.414.414,0,0,0-.029.479c0-.012-.008-.005-.006-.024s.007.005.011-.005c0,.027.01.009.008.037L-.011.473v.01C.016.472,0,.476.016.484S.038.465.042.474a.015.015,0,0,1,0-.014c0,.014.011-.008.009.006S.066.469.067.45c0,.01.007.015,0,.022s.005,0,.008,0l0-.006c.01,0,.013.015.023,0l0-.008C.1.459.1.459.1.477L.1.481A.029.029,0,0,0,.121.475h0C.133.458.189.456.2.435V.42L.213.41S.2.455.2.449A.528.528,0,0,1,.324.474C.329.484.32.5.32.5S.326.485.333.488.33.5.329.5s0,0,.006,0a.171.171,0,0,1,0-.035l.008,0,0,.011S.356.449.363.457A.269.269,0,0,0,.406.47.024.024,0,0,1,.4.483S.4.483.4.488C.4.476.411.481.409.476.425.452.433.479.447.463S.558.054.565.025c0,0,.005,0,.006.005S.566.019.563.022l0,.015c-.009,0,0-.01-.007-.01S.561.014.567.014.559,0,.554.014c0-.007,0-.016,0-.022S.541.006.539,0V0C.531-.02.518.011.51,0l0,0C.51-.016.5-.008.5-.017S.5-.005.493,0,.48-.007.477-.018L.469-.007C.444-.015.338-.02.312-.024v0A.858.858,0,0,0,.146-.039c0-.014-.013-.013-.019-.018s0,.014,0,.013C.1-.05.121-.036.1-.035A.293.293,0,0,1-.032-.077c-.015.015-.026,0-.039.008l0,0C-.083-.069-.146-.1-.161-.1l0,0C-.174-.086-.168-.1-.176-.113a.037.037,0,0,1-.02.03v0c-.007,0-.024.017-.034.017l0-.011c-.011.01-.025,0-.031,0S-.286-.111-.307-.1L-.312-.134l0,0a3.116,3.116,0,0,0-.1.458l0,.011h.005C-.4.344-.4.332-.4.342l-.007,0s0,.009,0,.015A.011.011,0,0,1-.407.362s0-.005,0-.008S-.4.342-.394.348s0,.018,0,.02a.357.357,0,0,0,.1.042c0,.005,0,0,0,.006s.021,0,.032,0a.049.049,0,0,1,0,.017c0-.01.056,0,.057,0",
    transform: "translate(0.413 0.134)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4587",
    "data-name": "Group 4587",
    transform: "translate(152.438 43.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M0-.034C0-.022,0-.02,0-.017S0-.034,0-.034",
    transform: "translate(0 0.034)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4588",
    "data-name": "Group 4588",
    transform: "translate(152.443 43.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M0,0H0Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    transform: "translate(153.263 42.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M0,0h0S0,0,0,0",
    transform: "translate(0.006 0.002)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    "data-name": "Group 4590",
    transform: "translate(152.444 42.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M-.155.427-.149.408c.008,0,0,.023,0,.02C-.133.4-.132.434-.125.42c0,0,0,0,0,.013.005-.015,0,0,.008-.006s0,0,0-.009l.007,0c0,.005,0,.014,0,.015A.265.265,0,0,0-.019.47c0-.012-.006-.006,0-.024s0,.005.01-.005c-.006.027.007.009,0,.036L0,.463v.01C.017.462,0,.466.016.474S.036.455.039.464a.018.018,0,0,1,0-.014c0,.014.009-.008.006.006S.058.46.061.441c0,.009,0,.015,0,.021s0,0,.007,0l0-.006c.008,0,.008.015.018,0V.449c.005,0,.009,0,.006.019L.08.472A.021.021,0,0,0,.1.466h0C.113.449.158.446.172.426V.412L.183.4S.166.445.167.441a.309.309,0,0,1,.1.025C.267.475.258.488.258.49S.265.476.27.479A.024.024,0,0,1,.265.491s0,0,.006,0A.2.2,0,0,1,.277.456l.006,0,0,.011S.292.441.3.449.32.456.331.462A.029.029,0,0,1,.322.475s0,0,0,0C.326.467.333.473.332.468.347.443.351.471.364.455S.5.052.5.024c0,0,0,0,0,.005S.506.018.5.021L.5.036c-.007,0,0-.01,0-.01S.5.012.507.012.5,0,.5.013C.494.007.5,0,.5-.009S.487.005.485,0v0C.481-.021.467.009.463-.006l0,0c0-.008-.009,0-.012-.009s0,.012,0,.013-.01,0-.011-.014L.43-.008A1.248,1.248,0,0,0,.306-.026v0A.534.534,0,0,0,.175-.041c0-.014-.009-.013-.013-.017s0,.014,0,.013,0,.008-.021.009a.185.185,0,0,1-.1-.041C.023-.064.015-.08,0-.072l0,0C-.005-.071-.053-.1-.065-.1v0C-.077-.088-.07-.107-.075-.115a.042.042,0,0,1-.019.03v0c-.006,0-.021.016-.029.017l0-.011c-.009.01-.02,0-.025,0S-.164-.113-.182-.1V-.136l0,0A3.986,3.986,0,0,0-.309.318l0,.011h0C-.305.334-.3.323-.3.333l-.006,0s0,.009,0,.015a.016.016,0,0,1,0,.007s0,0,0-.007S-.3.333-.3.338-.3.356-.3.359A.242.242,0,0,0-.221.4s0,0,0,.006.017,0,.025,0A.062.062,0,0,1-.2.422c0-.01.045,0,.045,0",
    transform: "translate(0.313 0.136)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592",
    transform: "translate(160.948 36.911)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4591",
    "data-name": "Group 4591",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M0-11.63A15.887,15.887,0,0,0,1.625-7.356a2.077,2.077,0,0,0,.929,1c.78.315,1.6-.315,2.2-.9A1.462,1.462,0,0,0,6.029-5.827a3.129,3.129,0,0,0,2-.488,12.675,12.675,0,0,0,3.865-3.753A27.364,27.364,0,0,1,9.069-8.054a2.453,2.453,0,0,1-2.287.471c-.7-.349-1.049-1.322-1.825-1.376C3.95-9.029,3.363-7.458,2.365-7.6c-.571-.083-.887-.691-1.111-1.223q-.6-1.44-1.209-2.881",
    transform: "translate(0 11.707)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4594",
    "data-name": "Group 4594",
    transform: "translate(171.843 74.026)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M-.177.278A1.866,1.866,0,0,1,.014-1.16a1.492,1.492,0,0,1,1.148-.447,9.168,9.168,0,0,1,2.8.588,19.846,19.846,0,0,0,6.422.8A5.756,5.756,0,0,1,7.027,1.027,17.126,17.126,0,0,1,3.4.778L-.359.251",
    transform: "translate(0.359 1.609)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4595",
    "data-name": "Group 4595",
    transform: "matrix(0.007, 1, -1, 0.007, 157.502, 130.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M.051,11.827H21.3L20.68,2.28,0,0Z",
    transform: "translate(0 0)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4596",
    "data-name": "Group 4596",
    transform: "translate(140.994 146.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M-14.378-38.449s-6.716,4.768-9.968.641l-.85,2-3.819,14.246a1.911,1.911,0,0,0,1.074,2.287,1.845,1.845,0,0,0,1.954-.374C-23.223-22.278-13.109-32-13.208-33.314l-.039-3.5a1.777,1.777,0,0,0-1.132-1.637",
    transform: "translate(29.084 38.449)",
    fill: "#1a0e90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4598",
    "data-name": "Group 4598",
    transform: "translate(142.467 150.601)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4597",
    "data-name": "Group 4597",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M0,15.084,14.409-.267l0,.764a2.127,2.127,0,0,1-.683,1.686C12.557,3.755,9.33,7.272,1.679,14.615A1.845,1.845,0,0,1,0,15.084",
    transform: "translate(0 0.267)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4600",
    "data-name": "Group 4600",
    transform: "translate(153.876 147.723)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4599",
    "data-name": "Group 4599",
    transform: "translate(2.952 1.79) rotate(147.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M1.105,2.109A1.118,1.118,0,0,0,2.15,1.045,1.074,1.074,0,0,0,1.105,0,1.178,1.178,0,0,0,0,1.132,1.115,1.115,0,0,0,1.212,2.1",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4601",
    "data-name": "Group 4601",
    transform: "translate(142.969 156.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M-3.57,2.057c-.1.05-.5-.9-1.575-1.409A5.635,5.635,0,0,0-7.22.243C-7.235.2-7.006.059-6.584,0A2.873,2.873,0,0,1-4.969.294,2.879,2.879,0,0,1-3.761,1.4c.209.372.236.638.191.653",
    transform: "translate(7.22 0.02)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4602",
    "data-name": "Group 4602",
    transform: "matrix(0.29, -0.957, 0.957, 0.29, 141.962, 159.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M.016,3.51A14.848,14.848,0,0,0,.3,1.758,15.217,15.217,0,0,0,.016.005,2.052,2.052,0,0,1,.7,1.757,2.049,2.049,0,0,1,.016,3.51",
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4603",
    "data-name": "Group 4603",
    transform: "matrix(0.369, -0.929, 0.929, 0.369, 143.965, 153.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M.016,5.437a18.487,18.487,0,0,0,.4-2.718A18.606,18.606,0,0,0,.016,0,4.093,4.093,0,0,1,.809,2.72,4.1,4.1,0,0,1,.016,5.437",
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4604",
    "data-name": "Group 4604",
    transform: "translate(144.639 150.467) rotate(-87.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M.02,4.709c-.11-.043.263-1.057.254-2.354C.283,1.059-.09.045.02,0a3.574,3.574,0,0,1,.65,2.353A3.577,3.577,0,0,1,.02,4.709",
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4605",
    "data-name": "Group 4605",
    transform: "translate(143.852 146.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M-2.361,3.288a1.569,1.569,0,0,1,.1-.675A4.737,4.737,0,0,1-1.4.957,2.1,2.1,0,0,1-.328.137.743.743,0,0,1,.465.453a1.208,1.208,0,0,1,.13.852A2.611,2.611,0,0,1-2.1,3.259,3.028,3.028,0,0,1-4.732,1.154,1.05,1.05,0,0,1-4.62.286.729.729,0,0,1-3.8.047,2.577,2.577,0,0,1-2.746.873a5.281,5.281,0,0,1,.952,1.6,1.621,1.621,0,0,1,.158.663A8.418,8.418,0,0,0-2.954,1.06a2.4,2.4,0,0,0-.936-.7A.388.388,0,0,0-4.338.49a.721.721,0,0,0-.04.575,2.7,2.7,0,0,0,2.3,1.8A2.267,2.267,0,0,0,.237,1.238.879.879,0,0,0,.171.64.4.4,0,0,0-.264.459a1.9,1.9,0,0,0-.919.678A7.009,7.009,0,0,0-2.361,3.288",
    transform: "translate(4.776 -0.006)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4606",
    "data-name": "Group 4606",
    transform: "matrix(-0.466, 0.885, -0.885, -0.466, 135.924, 118.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M.168,14.287H25.217l.6-10.851L0,0Z",
    transform: "translate(0 0)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4607",
    "data-name": "Group 4607",
    transform: "translate(98.266 130.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M-14.4-22.864l-.381.614s-13.015-2.219-14.343-.306l20.8,12.624L-4.4-17.022A13.919,13.919,0,0,1-14.4-22.864",
    transform: "translate(29.119 23.333)",
    fill: "#1a0e90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4609",
    "data-name": "Group 4609",
    transform: "translate(117.516 137.284)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4608",
    "data-name": "Group 4608",
    transform: "translate(1.362 2.685) rotate(-135.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M.929,1.875A.993.993,0,0,1,0,.93.956.956,0,0,1,.929,0a1.048,1.048,0,0,1,.979,1.007.991.991,0,0,1-1.074.859",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4611",
    "data-name": "Group 4611",
    transform: "translate(97.781 130.466)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4610",
    "data-name": "Group 4610",
    transform: "translate(0 1.915) rotate(-61.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M0,24.313H1.949l.239-23.3S1.762-.086.994.005Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4612",
    "data-name": "Group 4612",
    transform: "translate(114.172 133.907) rotate(153.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M.579,2.6C.677,2.533.4,2,.413,1.3.4.606.677.075.579.008.5-.072,0,.459,0,1.3S.5,2.68.579,2.6",
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4613",
    "data-name": "Group 4613",
    transform: "matrix(-0.989, 0.145, -0.145, -0.989, 110.693, 133.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M.578,2.409C.672,2.337.4,1.853.414,1.209.4.565.672.081.578.01.5-.076,0,.408,0,1.209s.5,1.285.578,1.2",
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4614",
    "data-name": "Group 4614",
    transform: "matrix(0.994, 0.111, -0.111, 0.994, 107.165, 131.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M.032,2.244c.087.068.487-.4.484-1.119S.119-.063.032.007C-.071.066.11.536.1,1.125S-.07,2.183.032,2.244",
    transform: "translate(0 0)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4615",
    "data-name": "Group 4615",
    transform: "translate(137.308 112.558) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M3.615,3.1H49.064V0H0Z",
    transform: "translate(0 0)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4616",
    "data-name": "Group 4616",
    transform: "translate(179.145 109.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1761",
    "data-name": "Rectangle 1761",
    width: 3.008,
    height: 52.564,
    transform: "translate(0 0)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4617",
    "data-name": "Group 4617",
    transform: "translate(179.145 119.531) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    "data-name": "Rectangle 1762",
    width: 41.837,
    height: 3.357,
    transform: "translate(0 0)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4618",
    "data-name": "Group 4618",
    transform: "translate(137.308 99.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M-43.411,9.513h-42.5a1.9,1.9,0,0,1-1.9-1.9V1.9a1.9,1.9,0,0,1,1.9-1.9h42.5a1.9,1.9,0,0,1,1.9,1.9V7.615a1.9,1.9,0,0,1-1.9,1.9",
    transform: "translate(87.811)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4619",
    "data-name": "Group 4619",
    transform: "translate(159.538 75.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M-20.151-51.279s6.286,11.16,5.358,18.964-2.648,7.8-2.648,7.8l-20.393-1.126-2.926-24.515,4.971-2.787Z",
    transform: "translate(40.761 52.939)",
    fill: "#1a0e90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4620",
    "data-name": "Group 4620",
    transform: "translate(127.004 49.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M0-50.4,5.1-26.113l24.071,2.23,15.518-1.065L39.06-30.329l-6.526,1.4-2.321-23.5Z",
    transform: "translate(0 52.435)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4621",
    "data-name": "Group 4621",
    transform: "translate(160.547 67.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M-.005-11.531c.7,1.937,4.017.112,4.017.112l-.227,3.46L1.72-6.485s-.008.928,1.359,1.022A4.613,4.613,0,0,0,4.994-5.6l.074.462a1.082,1.082,0,0,0,1.044.914,1.377,1.377,0,0,0,.64-.1,2.845,2.845,0,0,0,2.814.289,3.819,3.819,0,0,0,1.722-2.235l.221-2.858,1.748-1.212s1.441-2.668-.361-4.5A3.592,3.592,0,0,0,9.2-15.658l-2.8.931a2.862,2.862,0,0,0-1.991.528c-.464.338-1.045.743-1.559,1.046,0,0-3,1.217-2.857,1.622",
    transform: "translate(0.01 15.854)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(165.594 74.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M-1.415-6.392c.036,0,.083.22.128.581a4.3,4.3,0,0,1,0,1.45,1.553,1.553,0,0,1-.383.743,1.3,1.3,0,0,1-.585.359c-.4.1-.627-.067-.607-.087.012-.042.236.039.548-.089a1.348,1.348,0,0,0,.77-.986A6.556,6.556,0,0,0-1.472-5.8c0-.364.021-.591.057-.593",
    transform: "translate(2.862 6.392)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4623",
    "data-name": "Group 4623",
    transform: "translate(164.473 75.166) rotate(-176.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M.131,3.467A5.825,5.825,0,0,1,0,1.735,5.893,5.893,0,0,1,.131,0,5.765,5.765,0,0,1,.263,1.732,5.8,5.8,0,0,1,.131,3.467",
    transform: "translate(0 0)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4624",
    "data-name": "Group 4624",
    transform: "translate(167.228 75.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M-2.108-7.047a1.61,1.61,0,0,1,.131.676,2.842,2.842,0,0,1-.3,1.653,2.585,2.585,0,0,1-1.31,1.056c-.4.154-.667.18-.676.148s.234-.128.6-.318A2.837,2.837,0,0,0-2.507-4.851a3.21,3.21,0,0,0,.344-1.516,2.106,2.106,0,0,1,.055-.68",
    transform: "translate(4.265 7.047)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4625",
    "data-name": "Group 4625",
    transform: "translate(170.165 66.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M-2.96,6.884A9.546,9.546,0,0,1-2.3,5.621,4,4,0,0,0-1.9,4.181,3.61,3.61,0,0,0-2.158,2.39,3.592,3.592,0,0,0-3.261.958,4.014,4.014,0,0,0-4.6.286,9.36,9.36,0,0,0-5.987.064.909.909,0,0,1-5.6,0a3.845,3.845,0,0,1,1.053.1A3.93,3.93,0,0,1-3.115.764a3.7,3.7,0,0,1,1.2,1.523,3.7,3.7,0,0,1,.261,1.918,3.909,3.909,0,0,1-.483,1.5,9.462,9.462,0,0,1-.577.877c-.145.2-.228.308-.244.3",
    transform: "translate(5.987 0.002)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4626",
    "data-name": "Group 4626",
    transform: "translate(141.388 64.485) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M1.5,3.007a1.5,1.5,0,1,1,1.5-1.5,1.5,1.5,0,0,1-1.5,1.5",
    transform: "translate(0 0)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4627",
    "data-name": "Group 4627",
    transform: "translate(142.533 88.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M-4.685-83.1l-.137.082a9.623,9.623,0,0,0-4.644,8.687l1.527,32.874L6.818-39.973,7.3-69.7l6.131-.743L3.207-81.908A6.248,6.248,0,0,0-4.685-83.1",
    transform: "translate(9.477 84)",
    fill: "#1a0e90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4628",
    "data-name": "Group 4628",
    transform: "translate(119.378 74.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M0,28.614,19.676-10.862s2.787-4.087,6.689-3.9S54.607-6.775,54.607-6.775V13.107l-8.547-.186L26.737,11.062l-13.042,25.2Z",
    transform: "translate(0 14.77)",
    fill: "#1a0e90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4629",
    "data-name": "Group 4629",
    transform: "translate(142.843 88.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M-22.986-38.955a1.39,1.39,0,0,1-.158-.173l-.44-.524-1.659-2.025-5.985-7.392,0-.005,0,0c-1.447-2.329-4.761-3.707-8.074-3.141a8.889,8.889,0,0,0-4.611,2.245,6.922,6.922,0,0,0-1.574,2.184,8.619,8.619,0,0,0-.657,2.694,33.309,33.309,0,0,0-.075,3.38q.017,1.675.033,3.3c.038,2.161.074,4.245.109,6.232.087,3.971.2,7.547.316,10.549s.226,5.414.3,7.11c.035.826.062,1.474.081,1.933.007.21.012.376.016.5a.775.775,0,0,1,0,.172.85.85,0,0,1-.023-.17c-.011-.127-.024-.293-.041-.5-.031-.459-.075-1.106-.131-1.931-.106-1.677-.243-4.105-.38-7.107s-.272-6.579-.372-10.552c-.039-1.987-.081-4.072-.124-6.234q-.018-1.621-.037-3.3a33.271,33.271,0,0,1,.075-3.407,8.862,8.862,0,0,1,.68-2.776A7.169,7.169,0,0,1-44.1-50.163a9.122,9.122,0,0,1,4.749-2.3c3.4-.571,6.8.855,8.29,3.274l-.007-.009,5.914,7.449,1.615,2.059.416.543a1.221,1.221,0,0,1,.134.193",
    transform: "translate(46.495 52.59)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4630",
    "data-name": "Group 4630",
    transform: "translate(158.933 97.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M-.129,18.468c-.073,0-.132-4.135-.132-9.233S-.2,0-.129,0,0,4.134,0,9.234s-.059,9.233-.131,9.233",
    transform: "translate(0.261)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631",
    transform: "translate(151.623 75.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M-26.419,9.408a1.2,1.2,0,0,1-.278-.093L-27.472,9l-2.841-1.16c-2.4-.972-5.738-2.266-9.469-3.567s-7.152-2.357-9.638-3.087L-52.366.336l-.8-.238A1.223,1.223,0,0,1-53.44,0a1.2,1.2,0,0,1,.288.049l.813.19c.706.168,1.721.432,2.972.776,2.5.685,5.935,1.717,9.674,3.017s7.069,2.627,9.454,3.643c1.193.508,2.153.932,2.81,1.238l.755.356a1.193,1.193,0,0,1,.256.141",
    transform: "translate(53.44 0.004)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4632",
    "data-name": "Group 4632",
    transform: "translate(166.879 80.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M-12.08.5A14.4,14.4,0,0,1-13.891.432C-15.007.365-16.549.289-18.254.246l-4.37-.088A12.488,12.488,0,0,1-24.435.064a1.764,1.764,0,0,1,.486-.052c.313-.016.766-.029,1.325-.04,1.119-.021,2.667-.033,4.377.011s3.255.149,4.37.263c.558.057,1.008.112,1.318.16a1.751,1.751,0,0,1,.478.1",
    transform: "translate(24.435 0.047)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4633",
    "data-name": "Group 4633",
    transform: "translate(122.051 112.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M-13.124,8.045c-.04.03-.559-.711-1.551-1.771A21,21,0,0,0-16.528,4.53a22.472,22.472,0,0,0-2.537-1.8,22.458,22.458,0,0,0-2.782-1.4,20.864,20.864,0,0,0-2.409-.82c-1.4-.38-2.3-.491-2.29-.541a2.9,2.9,0,0,1,.634.046c.2.021.452.054.737.112s.614.106.967.2a18.355,18.355,0,0,1,2.454.775,20.756,20.756,0,0,1,2.827,1.4,20.635,20.635,0,0,1,2.557,1.843,18.332,18.332,0,0,1,1.834,1.8c.251.267.45.534.632.759s.33.429.444.6a2.938,2.938,0,0,1,.338.538",
    transform: "translate(26.547 0.037)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4634",
    "data-name": "Group 4634",
    transform: "translate(143.781 125.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M-15.383,3.111c-.023.042-.821-.4-2.176-.956A25.542,25.542,0,0,0-23.049.6a25.556,25.556,0,0,0-5.7-.265c-1.462.1-2.358.264-2.366.217A3.005,3.005,0,0,1-30.494.4,16.61,16.61,0,0,1-28.765.15a22.713,22.713,0,0,1,5.758.191,22.679,22.679,0,0,1,5.521,1.643,16.643,16.643,0,0,1,1.561.784,2.993,2.993,0,0,1,.542.343",
    transform: "translate(31.116 -0.049)",
    fill: "#375a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4722",
    "data-name": "Group 4722",
    transform: "translate(5.786 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4661",
    "data-name": "Group 4661",
    transform: "translate(0 51.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636",
    transform: "translate(107.6 42.496) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 200,
    height: 42.364,
    transform: "translate(0.073 0.394)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4740",
    "data-name": "Group 4740",
    transform: "translate(107.535 42.996) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SECURITY",
    transform: "translate(-44.538 17.238)",
    fill: "#282d30",
    fontSize: 8,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SECURITY")), /*#__PURE__*/React.createElement("g", {
    id: "Group_4738",
    "data-name": "Group 4738",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4737",
    "data-name": "Group 4737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4664",
    "data-name": "Group 4664",
    transform: "translate(-10.333 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    transform: "translate(-44.333 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-2",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732",
    transform: "translate(29.667 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-3",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665",
    transform: "translate(-10.48 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4730",
    "data-name": "Group 4730",
    transform: "translate(-44.48 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-2",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4733",
    "data-name": "Group 4733",
    transform: "translate(29.52 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-3",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4671",
    "data-name": "Group 4671",
    transform: "translate(-29.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731",
    transform: "translate(-43.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-2",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734",
    transform: "translate(-19.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-3",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4637",
    "data-name": "Group 4637",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M-12.976,42.247s-.012-.258-.018-.752-.009-1.229-.018-2.189c-.01-1.925-.023-4.759-.042-8.413-.022-7.3-.054-17.884-.093-31.011l.171.092-199.571.04h-.013l.244-.132c0,14.819-.007,29.136-.01,42.364l-.234-.126,143.077.059,41.531.035,11.114.016,2.875.008c.649,0,.986.008.986.008s-.318.005-.957.008l-2.848.008-11.065.016-41.478.035-143.236.059h-.235v-.126c0-13.228-.007-27.545-.01-42.364V-.249h.258l199.571.04h.171v.092c-.038,13.151-.07,23.75-.092,31.066-.019,3.646-.033,6.473-.042,8.392-.008.953-.014,1.68-.018,2.173s-.018.733-.018.733",
    transform: "translate(120.331 0.249)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4646",
    "data-name": "Group 4646",
    transform: "translate(72.26 37.513) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5503",
    "data-name": "Path 5503",
    d: "M14.52,29.038A14.519,14.519,0,1,1,29.04,14.519,14.52,14.52,0,0,1,14.52,29.038",
    transform: "translate(0 -155)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_003-privacy",
    "data-name": "003-privacy",
    transform: "translate(21.775 -147.868) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M154.281,70.344a3.285,3.285,0,0,0,3.281-3.281V63.781h-.938V62.344a2.344,2.344,0,0,0-4.688,0v1.438H151v3.281A3.285,3.285,0,0,0,154.281,70.344Zm-1.406-8a1.406,1.406,0,0,1,2.813,0v1.438h-2.812Zm-.938,2.375h4.688v2.344a2.344,2.344,0,0,1-4.688,0Z",
    transform: "translate(-147.25 -58.125)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M37.9,15.963l.129.037.129-.037a9.532,9.532,0,0,0,6.9-9.163V.937h-2.15L41.975,0H34.087L33.15.937H31V6.8A9.532,9.532,0,0,0,37.9,15.963ZM31.938,1.875h1.6l.938-.938h7.112l.938.938h1.6V6.8a8.626,8.626,0,0,1-6.094,8.224A8.626,8.626,0,0,1,31.938,6.8Z",
    transform: "translate(-31 0)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M241,241h.938v2.813H241Z",
    transform: "translate(-234.437 -233.469)",
    fill: "#7d97f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687",
    transform: "translate(0.065 153.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4662",
    "data-name": "Group 4662",
    transform: "translate(107.6 42.497) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 200,
    height: 42.364,
    transform: "translate(0.138 -0.106)",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4663",
    "data-name": "Group 4663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M-12.975,42.246s-.012-.258-.018-.751-.01-1.23-.018-2.189c-.01-1.925-.023-4.759-.042-8.413-.022-7.3-.054-17.884-.093-31.011l.17.092-199.572.04h-.013l.244-.131c0,14.819-.007,29.136-.009,42.364l-.235-.126,143.078.06,41.531.035,11.115.016,2.875.008c.648,0,.986.008.986.008s-.318.005-.957.008l-2.848.008-11.066.016-41.478.035-143.238.06h-.234v-.126c0-13.229-.007-27.545-.01-42.364V-.25h.257l199.572.04h.171v.092c-.038,13.15-.071,23.75-.092,31.066-.019,3.646-.033,6.473-.042,8.392-.008.953-.015,1.68-.018,2.173s-.018.733-.018.733",
    transform: "translate(120.267 0.25)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4672",
    "data-name": "Group 4672",
    transform: "translate(72.194 36.649) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5527",
    "data-name": "Path 5527",
    d: "M14.519,29.039A14.519,14.519,0,1,1,29.039,14.52a14.519,14.519,0,0,1-14.52,14.519",
    transform: "translate(0.352 -155.044)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4743",
    "data-name": "Group 4743",
    transform: "translate(-2.842 0.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001-support",
    "data-name": "001-support",
    transform: "translate(26.292 -149.087) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4742",
    "data-name": "Group 4742",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M14.279,7.093h-.043V6.052A6.1,6.1,0,0,0,8.089,0,6.1,6.1,0,0,0,1.942,6.052V7.093H1.683A1.741,1.741,0,0,0,0,8.876v2.654a1.689,1.689,0,0,0,1.66,1.72H3.279a.406.406,0,0,0,.39-.422c0-.008,0-.016,0-.024V7.6c0-.255-.151-.51-.388-.51H2.8V6.052A5.244,5.244,0,0,1,8.089.849a5.244,5.244,0,0,1,5.284,5.2V7.092H12.9c-.237,0-.388.255-.388.51v5.2a.405.405,0,0,0,.364.444l.024,0h.5l-.043.064a3.426,3.426,0,0,1-2.739,1.338,2.135,2.135,0,0,0-2.519-1.64,2.111,2.111,0,0,0-1.709,2.043,2.141,2.141,0,0,0,2.157,2.1,2.238,2.238,0,0,0,1.553-.658,1.858,1.858,0,0,0,.518-1.019A4.294,4.294,0,0,0,14.042,13.8l.41-.595a1.457,1.457,0,0,0,1.51-1.465V9.089A1.938,1.938,0,0,0,14.279,7.093ZM2.8,12.4H1.683a.834.834,0,0,1-.82-.848c0-.008,0-.015,0-.023V8.876a.885.885,0,0,1,.82-.934H2.8Zm6.665,3.5a1.282,1.282,0,0,1-.927.4,1.306,1.306,0,0,1-1.294-1.253,1.273,1.273,0,0,1,2.545,0h0A1.116,1.116,0,0,1,9.469,15.905ZM15.1,11.743c0,.573-.561.658-.82.658h-.906V7.942h.906c.475,0,.82.658.82,1.147Z",
    transform: "translate(0)",
    fill: "#7d97f4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4739",
    "data-name": "Group 4739",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SUPPORT",
    transform: "translate(-44.538 17.238)",
    fill: "#282d30",
    fontSize: 8,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SUPPORT")), /*#__PURE__*/React.createElement("g", {
    id: "Group_4738-2",
    "data-name": "Group 4738",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4737-2",
    "data-name": "Group 4737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4664-2",
    "data-name": "Group 4664",
    transform: "translate(-10.333 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-4",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729-2",
    "data-name": "Group 4729",
    transform: "translate(-44.333 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-5",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4732-2",
    "data-name": "Group 4732",
    transform: "translate(29.667 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-6",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736-2",
    "data-name": "Group 4736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4665-2",
    "data-name": "Group 4665",
    transform: "translate(-10.48 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-4",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4730-2",
    "data-name": "Group 4730",
    transform: "translate(-44.48 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-5",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4733-2",
    "data-name": "Group 4733",
    transform: "translate(29.52 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-6",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4735-2",
    "data-name": "Group 4735",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4671-2",
    "data-name": "Group 4671",
    transform: "translate(-29.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-4",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4731-2",
    "data-name": "Group 4731",
    transform: "translate(-43.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-5",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734-2",
    "data-name": "Group 4734",
    transform: "translate(-19.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-6",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4721",
    "data-name": "Group 4721",
    transform: "translate(0.065 102.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4688",
    "data-name": "Group 4688",
    transform: "translate(107.6 42.496) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1765",
    "data-name": "Rectangle 1765",
    width: 200,
    height: 42.364,
    transform: "translate(0.138 -0.607)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4741",
    "data-name": "Group 4741",
    transform: "translate(107.6 42.996) rotate(180)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PRIVACY",
    transform: "translate(-44.538 17.238)",
    fill: "#282d30",
    fontSize: 8,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRIVACY")), /*#__PURE__*/React.createElement("g", {
    id: "Group_4738-3",
    "data-name": "Group 4738",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4737-3",
    "data-name": "Group 4737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4664-3",
    "data-name": "Group 4664",
    transform: "translate(-10.333 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-7",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729-3",
    "data-name": "Group 4729",
    transform: "translate(-44.333 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-8",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4732-3",
    "data-name": "Group 4732",
    transform: "translate(29.667 22.017) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519-9",
    "data-name": "Path 5519",
    d: "M.131,51.4C.059,51.4,0,39.9,0,25.7S.059,0,.131,0,.263,11.506.263,25.7.2,51.4.131,51.4",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736-3",
    "data-name": "Group 4736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4665-3",
    "data-name": "Group 4665",
    transform: "translate(-10.48 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-7",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4730-3",
    "data-name": "Group 4730",
    transform: "translate(-44.48 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-8",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4733-3",
    "data-name": "Group 4733",
    transform: "translate(29.52 27.148) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520-9",
    "data-name": "Path 5520",
    d: "M.131,51.7C.059,51.7,0,40.125,0,25.851S.059,0,.131,0,.263,11.572.263,25.851.2,51.7.131,51.7",
    transform: "translate(0 0)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4735-3",
    "data-name": "Group 4735",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4671-3",
    "data-name": "Group 4671",
    transform: "translate(-29.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-7",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4731-3",
    "data-name": "Group 4731",
    transform: "translate(-43.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-8",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734-3",
    "data-name": "Group 4734",
    transform: "translate(-19.822 33.938) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526-9",
    "data-name": "Path 5526",
    d: "M.132,17.737C.059,17.737,0,13.766,0,8.869S.059,0,.132,0,.263,3.97.263,8.869.2,17.737.132,17.737",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4689",
    "data-name": "Group 4689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M-12.975,42.246s-.012-.257-.018-.751-.01-1.23-.018-2.189c-.01-1.925-.023-4.758-.042-8.413-.022-7.3-.054-17.884-.093-31.011l.17.092-199.572.04h-.013l.244-.132c0,14.819-.007,29.136-.009,42.364l-.235-.126,143.078.06,41.531.035,11.115.016,2.875.008c.648,0,.986.008.986.008s-.318.006-.957.008l-2.848.008-11.066.016-41.478.035-143.238.06h-.234v-.126c0-13.229-.007-27.545-.01-42.364V-.25h.257l199.572.04h.171v.092c-.038,13.151-.071,23.75-.092,31.066-.019,3.646-.033,6.472-.042,8.392-.008.953-.015,1.679-.018,2.173s-.018.733-.018.733",
    transform: "translate(120.267 0.25)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4698",
    "data-name": "Group 4698",
    transform: "translate(72.195 37.477) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5551",
    "data-name": "Path 5551",
    d: "M14.52,29.038A14.519,14.519,0,1,1,29.04,14.519,14.52,14.52,0,0,1,14.52,29.038",
    transform: "translate(0 -155)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_001-verified",
    "data-name": "001-verified",
    transform: "translate(22.739 -146.733) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M53.115,2.591,46.99.048a.625.625,0,0,0-.479,0L40.385,2.591A.625.625,0,0,0,40,3.168V6.26a10.467,10.467,0,0,0,6.514,9.694.625.625,0,0,0,.472,0A10.467,10.467,0,0,0,53.5,6.26V3.168A.625.625,0,0,0,53.115,2.591ZM52.25,6.26a9.219,9.219,0,0,1-5.5,8.437,9.219,9.219,0,0,1-5.5-8.437V3.585L46.75,1.3l5.5,2.284ZM46.059,8.366,48.746,5.68a.625.625,0,1,1,.884.884L46.5,9.692a.625.625,0,0,1-.884,0L43.871,7.945a.625.625,0,1,1,.884-.884Z",
    transform: "translate(-40 0)",
    fill: "#7d97f4"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsEmptyState);
export default __webpack_public_path__ + "static/media/reviews_empty_state.62aa51595e86574d56c0763c485f3b2a.svg";
export { ForwardRef as ReactComponent };